var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// ../../node_modules/@fortawesome/pro-solid-svg-icons/faGripVertical.js
var require_faGripVertical = __commonJS({
  "../../node_modules/@fortawesome/pro-solid-svg-icons/faGripVertical.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix2 = "fas";
    var iconName = "grip-vertical";
    var width = 320;
    var height = 512;
    var aliases = [];
    var unicode = "f58e";
    var svgPathData = "M40 352c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm192 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zM40 320l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM232 192c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zM40 160l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 48c0 22.1 17.9 40 40 40zM232 32c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0z";
    exports.definition = {
      prefix: prefix2,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faGripVertical = exports.definition;
    exports.prefix = prefix2;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-solid-svg-icons/faGripDotsVertical.js
var require_faGripDotsVertical = __commonJS({
  "../../node_modules/@fortawesome/pro-solid-svg-icons/faGripDotsVertical.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix2 = "fas";
    var iconName = "grip-dots-vertical";
    var width = 256;
    var height = 512;
    var aliases = [];
    var unicode = "e411";
    var svgPathData = "M48 144c26.5 0 48-21.5 48-48s-21.5-48-48-48S0 69.5 0 96s21.5 48 48 48zm0 160c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM96 416c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM208 144c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm48 112c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM208 464c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z";
    exports.definition = {
      prefix: prefix2,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faGripDotsVertical = exports.definition;
    exports.prefix = prefix2;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/free-solid-svg-icons/faArrowsTurnToDots.js
var require_faArrowsTurnToDots = __commonJS({
  "../../node_modules/@fortawesome/free-solid-svg-icons/faArrowsTurnToDots.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix2 = "fas";
    var iconName = "arrows-turn-to-dots";
    var width = 512;
    var height = 512;
    var aliases = [];
    var unicode = "e4c1";
    var svgPathData = "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM512 384c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM64 64c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64S28.7 64 64 64z";
    exports.definition = {
      prefix: prefix2,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faArrowsTurnToDots = exports.definition;
    exports.prefix = prefix2;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/lodash.debounce/index.js
var require_lodash = __commonJS({
  "../../node_modules/lodash.debounce/index.js"(exports, module2) {
    var FUNC_ERROR_TEXT = "Expected a function";
    var NAN = 0 / 0;
    var symbolTag = "[object Symbol]";
    var reTrim = /^\s+|\s+$/g;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var objectProto = Object.prototype;
    var objectToString = objectProto.toString;
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    var now = function() {
      return root.Date.now();
    };
    function debounce5(func, wait, options) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
        return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    function isObject(value) {
      var type = typeof value;
      return !!value && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return !!value && typeof value == "object";
    }
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, "");
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module2.exports = debounce5;
  }
});

// ../../node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min = __commonJS({
  "../../node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    "use strict";
    var b = 60103;
    var c = 60106;
    var d = 60107;
    var e2 = 60108;
    var f = 60114;
    var g = 60109;
    var h = 60110;
    var k = 60112;
    var l2 = 60113;
    var m = 60120;
    var n2 = 60115;
    var p = 60116;
    var q = 60121;
    var r = 60122;
    var u = 60117;
    var v = 60129;
    var w = 60131;
    if ("function" === typeof Symbol && Symbol.for) {
      x = Symbol.for;
      b = x("react.element");
      c = x("react.portal");
      d = x("react.fragment");
      e2 = x("react.strict_mode");
      f = x("react.profiler");
      g = x("react.provider");
      h = x("react.context");
      k = x("react.forward_ref");
      l2 = x("react.suspense");
      m = x("react.suspense_list");
      n2 = x("react.memo");
      p = x("react.lazy");
      q = x("react.block");
      r = x("react.server.block");
      u = x("react.fundamental");
      v = x("react.debug_trace_mode");
      w = x("react.legacy_hidden");
    }
    var x;
    function y(a) {
      if ("object" === typeof a && null !== a) {
        var t2 = a.$$typeof;
        switch (t2) {
          case b:
            switch (a = a.type, a) {
              case d:
              case f:
              case e2:
              case l2:
              case m:
                return a;
              default:
                switch (a = a && a.$$typeof, a) {
                  case h:
                  case k:
                  case p:
                  case n2:
                  case g:
                    return a;
                  default:
                    return t2;
                }
            }
          case c:
            return t2;
        }
      }
    }
    var z = g;
    var A = b;
    var B = k;
    var C = d;
    var D = p;
    var E = n2;
    var F = c;
    var G = f;
    var H = e2;
    var I = l2;
    exports.ContextConsumer = h;
    exports.ContextProvider = z;
    exports.Element = A;
    exports.ForwardRef = B;
    exports.Fragment = C;
    exports.Lazy = D;
    exports.Memo = E;
    exports.Portal = F;
    exports.Profiler = G;
    exports.StrictMode = H;
    exports.Suspense = I;
    exports.isAsyncMode = function() {
      return false;
    };
    exports.isConcurrentMode = function() {
      return false;
    };
    exports.isContextConsumer = function(a) {
      return y(a) === h;
    };
    exports.isContextProvider = function(a) {
      return y(a) === g;
    };
    exports.isElement = function(a) {
      return "object" === typeof a && null !== a && a.$$typeof === b;
    };
    exports.isForwardRef = function(a) {
      return y(a) === k;
    };
    exports.isFragment = function(a) {
      return y(a) === d;
    };
    exports.isLazy = function(a) {
      return y(a) === p;
    };
    exports.isMemo = function(a) {
      return y(a) === n2;
    };
    exports.isPortal = function(a) {
      return y(a) === c;
    };
    exports.isProfiler = function(a) {
      return y(a) === f;
    };
    exports.isStrictMode = function(a) {
      return y(a) === e2;
    };
    exports.isSuspense = function(a) {
      return y(a) === l2;
    };
    exports.isValidElementType = function(a) {
      return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e2 || a === l2 || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n2 || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? true : false;
    };
    exports.typeOf = y;
  }
});

// ../../node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (process.env.NODE_ENV !== "production") {
      (function() {
        "use strict";
        var REACT_ELEMENT_TYPE = 60103;
        var REACT_PORTAL_TYPE = 60106;
        var REACT_FRAGMENT_TYPE = 60107;
        var REACT_STRICT_MODE_TYPE = 60108;
        var REACT_PROFILER_TYPE = 60114;
        var REACT_PROVIDER_TYPE = 60109;
        var REACT_CONTEXT_TYPE = 60110;
        var REACT_FORWARD_REF_TYPE = 60112;
        var REACT_SUSPENSE_TYPE = 60113;
        var REACT_SUSPENSE_LIST_TYPE = 60120;
        var REACT_MEMO_TYPE = 60115;
        var REACT_LAZY_TYPE = 60116;
        var REACT_BLOCK_TYPE = 60121;
        var REACT_SERVER_BLOCK_TYPE = 60122;
        var REACT_FUNDAMENTAL_TYPE = 60117;
        var REACT_SCOPE_TYPE = 60119;
        var REACT_OPAQUE_ID_TYPE = 60128;
        var REACT_DEBUG_TRACING_MODE_TYPE = 60129;
        var REACT_OFFSCREEN_TYPE = 60130;
        var REACT_LEGACY_HIDDEN_TYPE = 60131;
        if (typeof Symbol === "function" && Symbol.for) {
          var symbolFor = Symbol.for;
          REACT_ELEMENT_TYPE = symbolFor("react.element");
          REACT_PORTAL_TYPE = symbolFor("react.portal");
          REACT_FRAGMENT_TYPE = symbolFor("react.fragment");
          REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
          REACT_PROFILER_TYPE = symbolFor("react.profiler");
          REACT_PROVIDER_TYPE = symbolFor("react.provider");
          REACT_CONTEXT_TYPE = symbolFor("react.context");
          REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
          REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
          REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
          REACT_MEMO_TYPE = symbolFor("react.memo");
          REACT_LAZY_TYPE = symbolFor("react.lazy");
          REACT_BLOCK_TYPE = symbolFor("react.block");
          REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
          REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
          REACT_SCOPE_TYPE = symbolFor("react.scope");
          REACT_OPAQUE_ID_TYPE = symbolFor("react.opaque.id");
          REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
          REACT_OFFSCREEN_TYPE = symbolFor("react.offscreen");
          REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
        }
        var enableScopeAPI = false;
        function isValidElementType(type) {
          if (typeof type === "string" || typeof type === "function") {
            return true;
          }
          if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
            return true;
          }
          if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
              return true;
            }
          }
          return false;
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                  case REACT_SUSPENSE_LIST_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal2 = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        var hasWarnedAboutDeprecatedIsConcurrentMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
            }
          }
          return false;
        }
        function isConcurrentMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
              hasWarnedAboutDeprecatedIsConcurrentMode = true;
              console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
            }
          }
          return false;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef2(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal2;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef2;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/react-is/index.js"(exports, module2) {
    "use strict";
    if (process.env.NODE_ENV === "production") {
      module2.exports = require_react_is_production_min();
    } else {
      module2.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/tslib/tslib.js
var require_tslib = __commonJS({
  "../../node_modules/tslib/tslib.js"(exports, module2) {
    var __extends2;
    var __assign2;
    var __rest2;
    var __decorate2;
    var __param2;
    var __metadata2;
    var __awaiter2;
    var __generator2;
    var __exportStar2;
    var __values2;
    var __read2;
    var __spread2;
    var __spreadArrays2;
    var __spreadArray2;
    var __await2;
    var __asyncGenerator2;
    var __asyncDelegator2;
    var __asyncValues2;
    var __makeTemplateObject2;
    var __importStar2;
    var __importDefault2;
    var __classPrivateFieldGet2;
    var __classPrivateFieldSet2;
    var __classPrivateFieldIn2;
    var __createBinding2;
    (function(factory) {
      var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
      if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function(exports2) {
          factory(createExporter(root, createExporter(exports2)));
        });
      } else if (typeof module2 === "object" && typeof module2.exports === "object") {
        factory(createExporter(root, createExporter(module2.exports)));
      } else {
        factory(createExporter(root));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v) {
          return exports2[id] = previous ? previous(id, v) : v;
        };
      }
    })(function(exporter) {
      var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
        d.__proto__ = b;
      } || function(d, b) {
        for (var p in b)
          if (Object.prototype.hasOwnProperty.call(b, p))
            d[p] = b[p];
      };
      __extends2 = function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
      __assign2 = Object.assign || function(t2) {
        for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s = arguments[i2];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t2[p] = s[p];
        }
        return t2;
      };
      __rest2 = function(s, e2) {
        var t2 = {};
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p) && e2.indexOf(p) < 0)
            t2[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p = Object.getOwnPropertySymbols(s); i2 < p.length; i2++) {
            if (e2.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i2]))
              t2[p[i2]] = s[p[i2]];
          }
        return t2;
      };
      __decorate2 = function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d = decorators[i2])
              r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
      };
      __param2 = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata2 = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter2 = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve) {
            resolve(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e2) {
              reject(e2);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e2) {
              reject(e2);
            }
          }
          function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator2 = function(thisArg, body) {
        var _ = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f, y, t2, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
          return this;
        }), g;
        function verb(n2) {
          return function(v) {
            return step([n2, v]);
          };
        }
        function step(op) {
          if (f)
            throw new TypeError("Generator is already executing.");
          while (_)
            try {
              if (f = 1, y && (t2 = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t2 = y["return"]) && t2.call(y), 0) : y.next) && !(t2 = t2.call(y, op[1])).done)
                return t2;
              if (y = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _.label++;
                  return { value: op[1], done: false };
                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _.ops.pop();
                  _.trys.pop();
                  continue;
                default:
                  if (!(t2 = _.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _.label < t2[1]) {
                    _.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _.label < t2[2]) {
                    _.label = t2[2];
                    _.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _.ops.pop();
                  _.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _);
            } catch (e2) {
              op = [6, e2];
              y = 0;
            } finally {
              f = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __exportStar2 = function(m, o2) {
        for (var p in m)
          if (p !== "default" && !Object.prototype.hasOwnProperty.call(o2, p))
            __createBinding2(o2, m, p);
      };
      __createBinding2 = Object.create ? function(o2, m, k, k2) {
        if (k2 === void 0)
          k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
          desc = { enumerable: true, get: function() {
            return m[k];
          } };
        }
        Object.defineProperty(o2, k2, desc);
      } : function(o2, m, k, k2) {
        if (k2 === void 0)
          k2 = k;
        o2[k2] = m[k];
      };
      __values2 = function(o2) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o2[s], i2 = 0;
        if (m)
          return m.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read2 = function(o2, n2) {
        var m = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m)
          return o2;
        var i2 = m.call(o2), r, ar = [], e2;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r = i2.next()).done)
            ar.push(r.value);
        } catch (error) {
          e2 = { error };
        } finally {
          try {
            if (r && !r.done && (m = i2["return"]))
              m.call(i2);
          } finally {
            if (e2)
              throw e2.error;
          }
        }
        return ar;
      };
      __spread2 = function() {
        for (var ar = [], i2 = 0; i2 < arguments.length; i2++)
          ar = ar.concat(__read2(arguments[i2]));
        return ar;
      };
      __spreadArrays2 = function() {
        for (var s = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s += arguments[i2].length;
        for (var r = Array(s), k = 0, i2 = 0; i2 < il; i2++)
          for (var a = arguments[i2], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
        return r;
      };
      __spreadArray2 = function(to, from, pack) {
        if (pack || arguments.length === 2)
          for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
            if (ar || !(i2 in from)) {
              if (!ar)
                ar = Array.prototype.slice.call(from, 0, i2);
              ar[i2] = from[i2];
            }
          }
        return to.concat(ar || Array.prototype.slice.call(from));
      };
      __await2 = function(v) {
        return this instanceof __await2 ? (this.v = v, this) : new __await2(v);
      };
      __asyncGenerator2 = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i2, q = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g[n2])
            i2[n2] = function(v) {
              return new Promise(function(a, b) {
                q.push([n2, v, a, b]) > 1 || resume(n2, v);
              });
            };
        }
        function resume(n2, v) {
          try {
            step(g[n2](v));
          } catch (e2) {
            settle(q[0][3], e2);
          }
        }
        function step(r) {
          r.value instanceof __await2 ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f, v) {
          if (f(v), q.shift(), q.length)
            resume(q[0][0], q[0][1]);
        }
      };
      __asyncDelegator2 = function(o2) {
        var i2, p;
        return i2 = {}, verb("next"), verb("throw", function(e2) {
          throw e2;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f) {
          i2[n2] = o2[n2] ? function(v) {
            return (p = !p) ? { value: __await2(o2[n2](v)), done: n2 === "return" } : f ? f(v) : v;
          } : f;
        }
      };
      __asyncValues2 = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o2[Symbol.asyncIterator], i2;
        return m ? m.call(o2) : (o2 = typeof __values2 === "function" ? __values2(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v) {
            return new Promise(function(resolve, reject) {
              v = o2[n2](v), settle(resolve, reject, v.done, v.value);
            });
          };
        }
        function settle(resolve, reject, d, v) {
          Promise.resolve(v).then(function(v2) {
            resolve({ value: v2, done: d });
          }, reject);
        }
      };
      __makeTemplateObject2 = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      var __setModuleDefault = Object.create ? function(o2, v) {
        Object.defineProperty(o2, "default", { enumerable: true, value: v });
      } : function(o2, v) {
        o2["default"] = v;
      };
      __importStar2 = function(mod) {
        if (mod && mod.__esModule)
          return mod;
        var result = {};
        if (mod != null) {
          for (var k in mod)
            if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
              __createBinding2(result, mod, k);
        }
        __setModuleDefault(result, mod);
        return result;
      };
      __importDefault2 = function(mod) {
        return mod && mod.__esModule ? mod : { "default": mod };
      };
      __classPrivateFieldGet2 = function(receiver, state, kind, f) {
        if (kind === "a" && !f)
          throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
          throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
      };
      __classPrivateFieldSet2 = function(receiver, state, value, kind, f) {
        if (kind === "m")
          throw new TypeError("Private method is not writable");
        if (kind === "a" && !f)
          throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
          throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
      };
      __classPrivateFieldIn2 = function(state, receiver) {
        if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function")
          throw new TypeError("Cannot use 'in' operator on non-object");
        return typeof state === "function" ? receiver === state : state.has(receiver);
      };
      exporter("__extends", __extends2);
      exporter("__assign", __assign2);
      exporter("__rest", __rest2);
      exporter("__decorate", __decorate2);
      exporter("__param", __param2);
      exporter("__metadata", __metadata2);
      exporter("__awaiter", __awaiter2);
      exporter("__generator", __generator2);
      exporter("__exportStar", __exportStar2);
      exporter("__createBinding", __createBinding2);
      exporter("__values", __values2);
      exporter("__read", __read2);
      exporter("__spread", __spread2);
      exporter("__spreadArrays", __spreadArrays2);
      exporter("__spreadArray", __spreadArray2);
      exporter("__await", __await2);
      exporter("__asyncGenerator", __asyncGenerator2);
      exporter("__asyncDelegator", __asyncDelegator2);
      exporter("__asyncValues", __asyncValues2);
      exporter("__makeTemplateObject", __makeTemplateObject2);
      exporter("__importStar", __importStar2);
      exporter("__importDefault", __importDefault2);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet2);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet2);
      exporter("__classPrivateFieldIn", __classPrivateFieldIn2);
    });
  }
});

// src/index.js
var src_exports = {};
__export(src_exports, {
  Banner: () => Banner_default,
  BannerGroup: () => BannerGroup,
  Button: () => Button_default,
  ButtonGroup: () => ButtonGroup,
  ButtonLink: () => ButtonLink,
  Caption: () => Caption_default,
  Card: () => Card_default,
  CardContent: () => Content,
  Carousel: () => Carousel_default,
  Checkbox: () => Checkbox_default,
  CheckboxGroup: () => CheckboxGroup,
  CheckboxSelect: () => CheckboxSelect_default,
  ContentStatus: () => ContentStatus,
  Creatable: () => Creatable,
  DataList: () => DataList_default,
  DateInput: () => DateInput_default,
  DateRangeDropdown: () => DateRangeDropdown_default,
  DateRangeInputs: () => DateRangeInputs_default,
  DateRangePicker: () => DateRangePicker_default,
  Definition: () => Definition,
  Description: () => Description3,
  DescriptiveList: () => DescriptiveList,
  Dropdown: () => Dropdown_default,
  EmptyState: () => EmptyState_default,
  ErrorMsg: () => ErrorMsg,
  ErrorProgress: () => ErrorProgress,
  ExpandableText: () => ExpandableText_default,
  ExternalLink: () => ExternalLink,
  FULL_RANGE_OPTIONS: () => FULL_RANGE_OPTIONS,
  Form: () => Form_default,
  Fullscreen: () => Fullscreen_default,
  H1: () => H1,
  H2: () => H2,
  H3: () => H3,
  H4: () => H4,
  H5: () => H5,
  Heading: () => Heading,
  HorizontalScroll: () => HorizontalScroll_default,
  Icon: () => Icon_default,
  IconButton: () => IconButton,
  IconWithinCButton: () => IconWithinCButton,
  ImageSkeleton: () => ImageSkeleton,
  Input: () => Input_default,
  InputClickToCopy: () => InputClickToCopy,
  Item: () => Item2,
  LIMITED_RANGE_OPTIONS: () => LIMITED_RANGE_OPTIONS,
  Label: () => Label_default,
  Link: () => Link,
  List: () => List,
  ListRow: () => ListRow_default,
  ListRowContent: () => Content3,
  Logo: () => Logo_default,
  Menu: () => Menu2,
  MenuCheckboxItem: () => MenuCheckboxItem,
  MenuContent: () => MenuContent,
  MenuHeading: () => MenuHeading,
  MenuItem: () => MenuItem,
  MenuList: () => MenuList,
  MenuPortalOverride: () => MenuPortalOverride,
  MenuSection: () => MenuSection,
  MenuSeparator: () => MenuSeparator,
  MenuTrigger: () => MenuTrigger,
  Modal: () => Modal_default,
  ModalFooter: () => ModalFooter,
  MoreMenu: () => MoreMenu_default,
  NegativeBanner: () => NegativeBanner,
  NegativeNotice: () => NegativeNotice,
  Notice: () => Notice_default,
  OptionLabel: () => OptionLabel,
  OptionWrapper: () => OptionWrapper,
  Overflow: () => Overflow,
  Page: () => Page_default,
  PageActions: () => PageActions,
  PageBody: () => PageBody,
  PageDescription: () => PageDescription,
  PageHeader: () => PageHeader,
  PageReturn: () => PageReturn,
  PageSubheader: () => PageSubheader,
  PageTitle: () => PageTitle,
  Panel: () => Panel_default,
  PanelActions: () => Actions,
  PanelBody: () => Body4,
  PanelFooter: () => Footer,
  PanelHeader: () => Header2,
  PanelSection: () => Section,
  PanelSectionTitle: () => SectionTitle,
  PanelTitle: () => Title,
  Paragraph: () => Paragraph_default,
  Popover: () => Popover,
  PopoverContent: () => PopoverContent,
  PopoverTrigger: () => PopoverTrigger,
  Portal: () => Portal_default,
  PrintButton: () => PrintButton_default,
  Progress: () => Progress_default,
  RANGE_OPTIONS: () => RANGE_OPTIONS,
  Radio: () => Radio_default,
  RadioControl: () => Control2,
  RadioGroup: () => Group2,
  RadioLabel: () => Label5,
  SearchInput: () => SearchInput,
  Select: () => Select,
  Skeleton: () => Skeleton_default,
  SortDropdown: () => SortDropdown,
  Spinner: () => Spinner_default,
  SplitButton: () => SplitButton,
  SquareButton: () => SquareButton,
  StarCheckbox: () => StarCheckbox,
  StatusLabel: () => StatusLabel_default,
  SuccessMsg: () => SuccessMsg,
  SuccessNotice: () => SuccessNotice,
  SuccessProgress: () => SuccessProgress,
  Switch: () => Switch_default,
  TabItem: () => TabItem,
  Table: () => Table,
  TabsList: () => TabsList,
  TabsNav: () => TabsNav,
  Tbody: () => Tbody,
  Td: () => Td,
  Term: () => Term,
  Text: () => Text_default,
  TextArea: () => TextArea_default,
  TextClickToCopy: () => TextClickToCopy,
  Th: () => Th,
  Thead: () => Thead,
  Toast: () => Toast2,
  Tooltip: () => Tooltip_default,
  Tr: () => Tr,
  TrialProgressBar: () => TrialProgressBar,
  UILink: () => UILink,
  WarningMsg: () => WarningMsg,
  WarningNotice: () => WarningNotice,
  add: () => add,
  calculateDatesFor: () => calculateDatesFor,
  calendar: () => calendar,
  diff: () => diff,
  easing: () => easing,
  endOf: () => endOf,
  format: () => format,
  fromNow: () => fromNow,
  getEndOfToday: () => getEndOfToday,
  getRecommendedFrequency: () => getRecommendedFrequency,
  isAfter: () => isAfter,
  isBefore: () => isBefore,
  normalizeDates: () => normalizeDates,
  parse: () => parse,
  startOf: () => startOf,
  subtract: () => subtract,
  useDateRange: () => useDateRange,
  useToggle: () => useToggle,
  utc: () => utc
});
module.exports = __toCommonJS(src_exports);

// src/Banner.js
var import_react3 = __toESM(require("react"));
var import_prop_types2 = __toESM(require("prop-types"));
var import_styled_components3 = __toESM(require("styled-components"));

// src/Link.js
var import_react2 = __toESM(require("react"));
var import_styled_components2 = __toESM(require("styled-components"));
var import_react_router_hash_link = require("react-router-hash-link");

// src/Icon.js
var import_react = __toESM(require("react"));
var import_prop_types = __toESM(require("prop-types"));
var import_styled_components = __toESM(require("styled-components"));
var import_react_fontawesome = require("@fortawesome/react-fontawesome");

// src/lib/easing.js
var createEasing = (delay) => (...properties) => properties.map((property) => `${property} ${delay}ms ease-in-out`).join(",");
var easing = createEasing(200);

// src/lib/register-icons.js
var import_fontawesome_svg_core_legacy = require("@fortawesome/fontawesome-svg-core-legacy");
var import_faAndroid = require("@fortawesome/free-brands-svg-icons-legacy/faAndroid");
var import_faAngular = require("@fortawesome/free-brands-svg-icons-legacy/faAngular");
var import_faApple = require("@fortawesome/free-brands-svg-icons-legacy/faApple");
var import_faCcVisa = require("@fortawesome/free-brands-svg-icons-legacy/faCcVisa");
var import_faCcMastercard = require("@fortawesome/free-brands-svg-icons-legacy/faCcMastercard");
var import_faCcStripe = require("@fortawesome/free-brands-svg-icons-legacy/faCcStripe");
var import_faEmber = require("@fortawesome/free-brands-svg-icons-legacy/faEmber");
var import_faPhp = require("@fortawesome/free-brands-svg-icons-legacy/faPhp");
var import_faPython = require("@fortawesome/free-brands-svg-icons-legacy/faPython");
var import_faReact = require("@fortawesome/free-brands-svg-icons-legacy/faReact");
var import_faVuejs = require("@fortawesome/free-brands-svg-icons-legacy/faVuejs");
var import_faStripe = require("@fortawesome/free-brands-svg-icons-legacy/faStripe");
var import_faAdjust = require("@fortawesome/free-solid-svg-icons-legacy/faAdjust");
var import_faAngleDoubleDown = require("@fortawesome/free-solid-svg-icons-legacy/faAngleDoubleDown");
var import_faAngleDoubleUp = require("@fortawesome/free-solid-svg-icons-legacy/faAngleDoubleUp");
var import_faAngleDown = require("@fortawesome/free-solid-svg-icons-legacy/faAngleDown");
var import_faAngleRight = require("@fortawesome/free-solid-svg-icons-legacy/faAngleRight");
var import_faAngleUp = require("@fortawesome/free-solid-svg-icons-legacy/faAngleUp");
var import_faArchive = require("@fortawesome/free-solid-svg-icons-legacy/faArchive");
var import_faArrowDown = require("@fortawesome/free-solid-svg-icons-legacy/faArrowDown");
var import_faArrowLeft = require("@fortawesome/free-solid-svg-icons-legacy/faArrowLeft");
var import_faArrowRight = require("@fortawesome/free-solid-svg-icons-legacy/faArrowRight");
var import_faArrowUp = require("@fortawesome/free-solid-svg-icons-legacy/faArrowUp");
var import_faArrowsAltH = require("@fortawesome/free-solid-svg-icons-legacy/faArrowsAltH");
var import_faArrowsAltV = require("@fortawesome/free-solid-svg-icons-legacy/faArrowsAltV");
var import_faAsterisk = require("@fortawesome/free-solid-svg-icons-legacy/faAsterisk");
var import_faBan = require("@fortawesome/free-solid-svg-icons-legacy/faBan");
var import_faBookOpen = require("@fortawesome/free-solid-svg-icons-legacy/faBookOpen");
var import_faBullseye = require("@fortawesome/free-solid-svg-icons-legacy/faBullseye");
var import_faCalculator = require("@fortawesome/free-solid-svg-icons-legacy/faCalculator");
var import_faCalendarAlt = require("@fortawesome/free-solid-svg-icons-legacy/faCalendarAlt");
var import_faCameraRetro = require("@fortawesome/free-solid-svg-icons-legacy/faCameraRetro");
var import_faCaretDown = require("@fortawesome/free-solid-svg-icons-legacy/faCaretDown");
var import_faCaretUp = require("@fortawesome/free-solid-svg-icons-legacy/faCaretUp");
var import_faChartBar = require("@fortawesome/free-solid-svg-icons-legacy/faChartBar");
var import_faChartLine = require("@fortawesome/free-solid-svg-icons-legacy/faChartLine");
var import_faCheck = require("@fortawesome/free-solid-svg-icons-legacy/faCheck");
var import_faCheckCircle = require("@fortawesome/free-solid-svg-icons-legacy/faCheckCircle");
var import_faCheckSquare = require("@fortawesome/free-solid-svg-icons-legacy/faCheckSquare");
var import_faChevronDown = require("@fortawesome/free-solid-svg-icons-legacy/faChevronDown");
var import_faChevronLeft = require("@fortawesome/free-solid-svg-icons-legacy/faChevronLeft");
var import_faChevronRight = require("@fortawesome/free-solid-svg-icons-legacy/faChevronRight");
var import_faChevronUp = require("@fortawesome/free-solid-svg-icons-legacy/faChevronUp");
var import_faCircle = require("@fortawesome/free-solid-svg-icons-legacy/faCircle");
var import_faCircleNotch = require("@fortawesome/free-solid-svg-icons-legacy/faCircleNotch");
var import_faClipboardCheck = require("@fortawesome/free-solid-svg-icons-legacy/faClipboardCheck");
var import_faClock = require("@fortawesome/free-solid-svg-icons-legacy/faClock");
var import_faClone = require("@fortawesome/free-solid-svg-icons-legacy/faClone");
var import_faCode = require("@fortawesome/free-solid-svg-icons-legacy/faCode");
var import_faCog = require("@fortawesome/free-solid-svg-icons-legacy/faCog");
var import_faColumns = require("@fortawesome/free-solid-svg-icons-legacy/faColumns");
var import_faComment = require("@fortawesome/free-solid-svg-icons-legacy/faComment");
var import_faCommentAlt = require("@fortawesome/free-solid-svg-icons-legacy/faCommentAlt");
var import_faCopy = require("@fortawesome/free-solid-svg-icons-legacy/faCopy");
var import_faDesktop = require("@fortawesome/free-solid-svg-icons-legacy/faDesktop");
var import_faDownload = require("@fortawesome/free-solid-svg-icons-legacy/faDownload");
var import_faEdit = require("@fortawesome/free-solid-svg-icons-legacy/faEdit");
var import_faEllipsisH = require("@fortawesome/free-solid-svg-icons-legacy/faEllipsisH");
var import_faEnvelope = require("@fortawesome/free-solid-svg-icons-legacy/faEnvelope");
var import_faExchangeAlt = require("@fortawesome/free-solid-svg-icons-legacy/faExchangeAlt");
var import_faExclamation = require("@fortawesome/free-solid-svg-icons-legacy/faExclamation");
var import_faExclamationCircle = require("@fortawesome/free-solid-svg-icons-legacy/faExclamationCircle");
var import_faExclamationTriangle = require("@fortawesome/free-solid-svg-icons-legacy/faExclamationTriangle");
var import_faExpand = require("@fortawesome/free-solid-svg-icons-legacy/faExpand");
var import_faExternalLinkAlt = require("@fortawesome/free-solid-svg-icons-legacy/faExternalLinkAlt");
var import_faEye = require("@fortawesome/free-solid-svg-icons-legacy/faEye");
var import_faFileAlt = require("@fortawesome/free-solid-svg-icons-legacy/faFileAlt");
var import_faFileExport = require("@fortawesome/free-solid-svg-icons-legacy/faFileExport");
var import_faFlag = require("@fortawesome/free-solid-svg-icons-legacy/faFlag");
var import_faFlask = require("@fortawesome/free-solid-svg-icons-legacy/faFlask");
var import_faFont = require("@fortawesome/free-solid-svg-icons-legacy/faFont");
var import_faGem = require("@fortawesome/free-solid-svg-icons-legacy/faGem");
var import_faGlobe = require("@fortawesome/free-solid-svg-icons-legacy/faGlobe");
var import_faGripVertical = __toESM(require_faGripVertical());
var import_faGripDotsVertical = __toESM(require_faGripDotsVertical());
var import_faHistory = require("@fortawesome/free-solid-svg-icons-legacy/faHistory");
var import_faImage = require("@fortawesome/free-solid-svg-icons-legacy/faImage");
var import_faInfo = require("@fortawesome/free-solid-svg-icons-legacy/faInfo");
var import_faInfoCircle = require("@fortawesome/free-solid-svg-icons-legacy/faInfoCircle");
var import_faKey = require("@fortawesome/free-solid-svg-icons-legacy/faKey");
var import_faLevelDownAlt = require("@fortawesome/free-solid-svg-icons-legacy/faLevelDownAlt");
var import_faLightbulb = require("@fortawesome/free-solid-svg-icons-legacy/faLightbulb");
var import_faList = require("@fortawesome/free-solid-svg-icons-legacy/faList");
var import_faLock = require("@fortawesome/free-solid-svg-icons-legacy/faLock");
var import_faLongArrowAltRight = require("@fortawesome/free-solid-svg-icons-legacy/faLongArrowAltRight");
var import_faMagic = require("@fortawesome/free-solid-svg-icons-legacy/faMagic");
var import_faMap = require("@fortawesome/free-solid-svg-icons-legacy/faMap");
var import_faMinus = require("@fortawesome/free-solid-svg-icons-legacy/faMinus");
var import_faMinusCircle = require("@fortawesome/free-solid-svg-icons-legacy/faMinusCircle");
var import_faPalette = require("@fortawesome/free-solid-svg-icons-legacy/faPalette");
var import_faPen = require("@fortawesome/free-solid-svg-icons-legacy/faPen");
var import_faPencilAlt = require("@fortawesome/free-solid-svg-icons-legacy/faPencilAlt");
var import_faPlus = require("@fortawesome/free-solid-svg-icons-legacy/faPlus");
var import_faPlusCircle = require("@fortawesome/free-solid-svg-icons-legacy/faPlusCircle");
var import_faPrint = require("@fortawesome/free-solid-svg-icons-legacy/faPrint");
var import_faQuestionCircle = require("@fortawesome/free-solid-svg-icons-legacy/faQuestionCircle");
var import_faRocket = require("@fortawesome/free-solid-svg-icons-legacy/faRocket");
var import_faSearch = require("@fortawesome/free-solid-svg-icons-legacy/faSearch");
var import_faShare = require("@fortawesome/free-solid-svg-icons-legacy/faShare");
var import_faSignOutAlt = require("@fortawesome/free-solid-svg-icons-legacy/faSignOutAlt");
var import_faSlidersH = require("@fortawesome/free-solid-svg-icons-legacy/faSlidersH");
var import_faSort = require("@fortawesome/free-solid-svg-icons-legacy/faSort");
var import_faStar = require("@fortawesome/free-solid-svg-icons-legacy/faStar");
var import_faTag = require("@fortawesome/free-solid-svg-icons-legacy/faTag");
var import_faTh = require("@fortawesome/free-solid-svg-icons-legacy/faTh");
var import_faThLarge = require("@fortawesome/free-solid-svg-icons-legacy/faThLarge");
var import_faThList = require("@fortawesome/free-solid-svg-icons-legacy/faThList");
var import_faThumbtack = require("@fortawesome/free-solid-svg-icons-legacy/faThumbtack");
var import_faTimes = require("@fortawesome/free-solid-svg-icons-legacy/faTimes");
var import_faTimesCircle = require("@fortawesome/free-solid-svg-icons-legacy/faTimesCircle");
var import_faTrash = require("@fortawesome/free-solid-svg-icons-legacy/faTrash");
var import_faTrashAlt = require("@fortawesome/free-solid-svg-icons-legacy/faTrashAlt");
var import_faUnlink = require("@fortawesome/free-solid-svg-icons-legacy/faUnlink");
var import_faUpload = require("@fortawesome/free-solid-svg-icons-legacy/faUpload");
var import_faUser = require("@fortawesome/free-solid-svg-icons-legacy/faUser");
var import_faUserCircle = require("@fortawesome/free-solid-svg-icons-legacy/faUserCircle");
var import_faUsers = require("@fortawesome/free-solid-svg-icons-legacy/faUsers");
var import_faMapMarker = require("@fortawesome/free-solid-svg-icons-legacy/faMapMarker");
var import_faMapMarkerAlt = require("@fortawesome/free-solid-svg-icons-legacy/faMapMarkerAlt");
var import_faMobile = require("@fortawesome/free-solid-svg-icons-legacy/faMobile");
var import_faArrowsTurnToDots = __toESM(require_faArrowsTurnToDots());
var import_faStar2 = require("@fortawesome/free-regular-svg-icons-legacy/faStar");
var import_faCircle2 = require("@fortawesome/free-regular-svg-icons-legacy/faCircle");
var import_faProjectDiagram = require("@fortawesome/free-solid-svg-icons-legacy/faProjectDiagram");
var registered = [
  import_faAndroid.faAndroid,
  import_faAngular.faAngular,
  import_faApple.faApple,
  import_faEmber.faEmber,
  import_faPhp.faPhp,
  import_faPython.faPython,
  import_faReact.faReact,
  import_faVuejs.faVuejs,
  import_faAdjust.faAdjust,
  import_faAngleDoubleDown.faAngleDoubleDown,
  import_faAngleDoubleUp.faAngleDoubleUp,
  import_faAngleDown.faAngleDown,
  import_faAngleRight.faAngleRight,
  import_faAngleUp.faAngleUp,
  import_faArchive.faArchive,
  import_faArrowDown.faArrowDown,
  import_faArrowLeft.faArrowLeft,
  import_faArrowRight.faArrowRight,
  import_faArrowUp.faArrowUp,
  import_faArrowsAltH.faArrowsAltH,
  import_faArrowsAltV.faArrowsAltV,
  import_faAsterisk.faAsterisk,
  import_faBan.faBan,
  import_faBookOpen.faBookOpen,
  import_faBullseye.faBullseye,
  import_faCalculator.faCalculator,
  import_faCalendarAlt.faCalendarAlt,
  import_faCameraRetro.faCameraRetro,
  import_faCaretDown.faCaretDown,
  import_faCaretUp.faCaretUp,
  import_faCcVisa.faCcVisa,
  import_faCcMastercard.faCcMastercard,
  import_faCcStripe.faCcStripe,
  import_faChartBar.faChartBar,
  import_faChartLine.faChartLine,
  import_faCheck.faCheck,
  import_faCheckCircle.faCheckCircle,
  import_faCheckSquare.faCheckSquare,
  import_faChevronDown.faChevronDown,
  import_faChevronLeft.faChevronLeft,
  import_faChevronRight.faChevronRight,
  import_faChevronUp.faChevronUp,
  import_faCircle.faCircle,
  import_faCircleNotch.faCircleNotch,
  import_faClipboardCheck.faClipboardCheck,
  import_faClock.faClock,
  import_faClone.faClone,
  import_faCode.faCode,
  import_faCog.faCog,
  import_faColumns.faColumns,
  import_faComment.faComment,
  import_faCommentAlt.faCommentAlt,
  import_faCopy.faCopy,
  import_faDesktop.faDesktop,
  import_faDownload.faDownload,
  import_faEdit.faEdit,
  import_faEllipsisH.faEllipsisH,
  import_faEnvelope.faEnvelope,
  import_faExchangeAlt.faExchangeAlt,
  import_faExclamation.faExclamation,
  import_faExclamationCircle.faExclamationCircle,
  import_faExclamationTriangle.faExclamationTriangle,
  import_faExpand.faExpand,
  import_faExternalLinkAlt.faExternalLinkAlt,
  import_faFileAlt.faFileAlt,
  import_faFileExport.faFileExport,
  import_faEye.faEye,
  import_faFlag.faFlag,
  import_faFlask.faFlask,
  import_faFont.faFont,
  import_faGem.faGem,
  import_faGlobe.faGlobe,
  import_faGripVertical.faGripVertical,
  import_faHistory.faHistory,
  import_faImage.faImage,
  import_faInfo.faInfo,
  import_faInfoCircle.faInfoCircle,
  import_faKey.faKey,
  import_faLevelDownAlt.faLevelDownAlt,
  import_faLightbulb.faLightbulb,
  import_faList.faList,
  import_faLock.faLock,
  import_faLongArrowAltRight.faLongArrowAltRight,
  import_faMagic.faMagic,
  import_faMap.faMap,
  import_faMapMarker.faMapMarker,
  import_faMapMarkerAlt.faMapMarkerAlt,
  import_faMinus.faMinus,
  import_faMinusCircle.faMinusCircle,
  import_faMobile.faMobile,
  import_faPalette.faPalette,
  import_faPen.faPen,
  import_faPencilAlt.faPencilAlt,
  import_faPrint.faPrint,
  import_faPlus.faPlus,
  import_faPlusCircle.faPlusCircle,
  import_faQuestionCircle.faQuestionCircle,
  import_faRocket.faRocket,
  import_faSearch.faSearch,
  import_faShare.faShare,
  import_faSignOutAlt.faSignOutAlt,
  import_faSlidersH.faSlidersH,
  import_faSort.faSort,
  import_faStar.faStar,
  import_faStripe.faStripe,
  import_faTag.faTag,
  import_faTh.faTh,
  import_faThLarge.faThLarge,
  import_faThList.faThList,
  import_faThumbtack.faThumbtack,
  import_faTimes.faTimes,
  import_faTimesCircle.faTimesCircle,
  import_faTrash.faTrash,
  import_faTrashAlt.faTrashAlt,
  import_faUnlink.faUnlink,
  import_faUpload.faUpload,
  import_faUser.faUser,
  import_faUserCircle.faUserCircle,
  import_faUsers.faUsers,
  import_faArrowsTurnToDots.faArrowsTurnToDots,
  import_faStar2.faStar,
  import_faCircle2.faCircle,
  import_faProjectDiagram.faProjectDiagram,
  import_faGripDotsVertical.faGripDotsVertical
];
import_fontawesome_svg_core_legacy.library.add(...registered);
import_fontawesome_svg_core_legacy.dom.watch();

// src/Icon.js
var Icon = (0, import_styled_components.default)(import_react_fontawesome.FontAwesomeIcon).attrs(() => ({
  focusable: false
}))`
  color: inherit;
  font-size: inherit;
  line-height: inherit;
`;
Icon.propTypes = {
  icon: import_prop_types.default.oneOfType([
    import_prop_types.default.string,
    import_prop_types.default.arrayOf(import_prop_types.default.string)
  ])
};
var Icon_default = Icon;
var Button = import_styled_components.default.button`
  align-items: center;
  background: none;
  border-radius: 6px;
  border: none;
  color: var(--icon);
  display: flex;
  font-size: 16px;
  height: 24px;
  justify-content: center;
  transition: ${easing("color")};
  width: 24px;

  :hover {
    color: var(--icon-hover);
  }

  :focus {
    outline: 2px solid var(--input-focus);
    outline-offset: -2px;
  }

  ${Icon} {
    width: 100%;
  }
`;
var BaseIconButton = ({
  icon,
  label,
  onClick,
  type = "button",
  ...unhandledProps
}) => {
  return /* @__PURE__ */ import_react.default.createElement(Button, {
    "aria-label": label,
    onClick,
    type,
    ...unhandledProps
  }, /* @__PURE__ */ import_react.default.createElement(Icon, {
    icon
  }));
};
BaseIconButton.propTypes = {
  icon: import_prop_types.default.string,
  label: import_prop_types.default.string,
  onClick: import_prop_types.default.func,
  type: import_prop_types.default.string
};
var IconButton = (0, import_styled_components.default)(BaseIconButton)``;
var IconWithinCButton = (0, import_styled_components.default)(Icon)`
  margin-right: 10px;
  ${({ gray }) => gray && `color: var(--icon)`}
`;

// src/Link.js
var theme = `
  --link-active-color: var(--deep-work);
  --link-color: var(--blurple);
  --link-focus-outline-color: var(--blues-cues);
  --link-font-weight: var(--bold);
  --link-hover-color: var(--deep-work);
  --link-text-decoration: underline;
  --link-visited-color: var(--link-active-color);
`;
var UILink = import_styled_components2.default.a`
  ${theme}

  color: var(--link-color);
  cursor: pointer;
  font-size: inherit;
  font-weight: var(--link-font-weight);
  line-height: 1.5;
  text-decoration: none;

  > ${Icon_default} {
    margin-left: 8px;
    margin-right: 4px;
  }

  &:hover {
    color: var(--link-hover-color);
    text-decoration: var(--link-text-decoration);
  }

  &:focus-visible {
    border-radius: 6px;
    box-shadow: 0 0 0 2px var(--link-focus-outline-color);
    outline: none;
  }

  &:active {
    color: var(--link-active-color);
    text-decoration: var(--link-text-decoration);
  }

  &:visited {
    color: var(--link-visited-color);

    > ${Icon_default} {
      color: var(--link-visited-color);
    }
  }
`;
var Link = (0, import_styled_components2.default)(UILink).attrs(({ to }) => ({
  as: to ? import_react_router_hash_link.HashLink : "a"
}))``;
var ExternalLink = (0, import_styled_components2.default)(UILink).attrs(
  ({ children, icon = true }) => ({
    rel: "noopener noreferrer",
    target: "_blank",
    children: /* @__PURE__ */ import_react2.default.createElement(import_react2.default.Fragment, null, children, icon && /* @__PURE__ */ import_react2.default.createElement(Icon_default, {
      icon: "external-link-alt"
    }))
  })
)``;
var ButtonLink = (0, import_styled_components2.default)(UILink).attrs(({ as }) => ({
  as: as || "button"
}))`
  background: none;
  border: none;
`;
var Link_default = Link;

// src/Banner.js
var Wrapper = import_styled_components3.default.div`
  background: var(--banner-info-gradient);
  color: var(--banner-content);
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 12px 16px;
  font-weight: var(--bold);

  > ${IconButton} {
    color: var(--banner-content);
    height: var(--medium-large);
    margin-left: 8px;
    width: var(--medium-large);
  }

  ${UILink} {
    color: inherit;
    font-weight: var(--bold);
    text-decoration: underline;
  }
`;
var BodyWrapper = import_styled_components3.default.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
`;
var Body = import_styled_components3.default.span``;
function BaseBanner({ children, className, onDismiss, ...unhandledProps }) {
  return /* @__PURE__ */ import_react3.default.createElement(Wrapper, {
    className,
    ...unhandledProps
  }, /* @__PURE__ */ import_react3.default.createElement(BodyWrapper, null, /* @__PURE__ */ import_react3.default.createElement(Body, null, children)), onDismiss && /* @__PURE__ */ import_react3.default.createElement(IconButton, {
    icon: "times",
    label: "Dismiss banner",
    onClick: onDismiss
  }));
}
BaseBanner.propTypes = {
  children: import_prop_types2.default.node,
  className: import_prop_types2.default.string,
  onDismiss: import_prop_types2.default.func
};
BaseBanner.displayName = "Banner";
var Banner = (0, import_styled_components3.default)(BaseBanner)``;
var Banner_default = Banner;
var NegativeBanner = (0, import_styled_components3.default)(Banner).attrs(() => ({
  role: "alert",
  "aria-live": "polite"
}))`
  background: var(--banner-negative-gradient);
`;
var BannerGroup = import_styled_components3.default.div`
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 2000;
`;

// src/Button.js
var import_react4 = __toESM(require("react"));
var import_styled_components4 = __toESM(require("styled-components"));
var import_prop_types3 = __toESM(require("prop-types"));
var theme2 = `
  --button-background: initial;
  --button-border-color: transparent;
  --button-color: var(--white);
`;
var UIButton = import_styled_components4.default.button`
  ${theme2}

  align-items: center;
  background: var(--button-background);
  border-radius: 6px;
  border: 1px solid var(--button-border-color);
  color: var(--button-color);
  display: flex;
  flex-shrink: 0;
  font-size: var(--regular);
  font-weight: var(--semi-bold);
  height: 40px;
  justify-content: center;
  line-height: 1.5;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  transition: ${easing("background", "box-shadow", "color")};

  &:hover:not([disabled]) {
    box-shadow: var(--button-elevation);
  }

  &[disabled] {
    background: var(--disabled);
    border-color: transparent;
    box-shadow: none;
    color: var(--white);
    transition: background 0ms;
  }

  > ${Icon_default} {
    color: inherit;
    font-size: var(--regular);
    margin-right: 8px;
  }

  /**
   * Style overrides for links forwarded as buttons
   */
  &${UILink} {
    --link-color: var(--button-color);
    --link-hover-color: inherit;
    --link-text-decoration: none;
    --link-visited-color: var(--button-color);

    > ${Icon_default} {
      margin-right: 0;
    }
  }
`;
var Primary = (0, import_styled_components4.default)(UIButton)`
  --button-background: var(--primary-grad);
`;
var Secondary = (0, import_styled_components4.default)(UIButton)`
  --button-background: var(--white);
  --button-color: var(--oh-hi-dark);
  --button-border-color: var(--sharkbait-ooh-la-la);
`;
var Positive = (0, import_styled_components4.default)(UIButton)`
  --button-background: var(--safety-grad);
`;
var Negative = (0, import_styled_components4.default)(UIButton)`
  --button-background: var(--danger-grad);
`;
var UnstyledButton = (0, import_react4.forwardRef)(
  ({ kind, type = "button", ...unhandledProps }, ref) => {
    switch (kind) {
      case "secondary":
        return /* @__PURE__ */ import_react4.default.createElement(Secondary, {
          ref,
          type,
          ...unhandledProps
        });
      case "negative":
        return /* @__PURE__ */ import_react4.default.createElement(Negative, {
          ref,
          type,
          ...unhandledProps
        });
      case "positive":
        return /* @__PURE__ */ import_react4.default.createElement(Positive, {
          ref,
          type,
          ...unhandledProps
        });
      case "primary":
      default:
        return /* @__PURE__ */ import_react4.default.createElement(Primary, {
          ref,
          type,
          ...unhandledProps
        });
    }
  }
);
UnstyledButton.propTypes = {
  kind: import_prop_types3.default.oneOf(["primary", "secondary", "positive", "negative"]),
  type: import_prop_types3.default.string
};
var Button2 = (0, import_styled_components4.default)(UnstyledButton)``;
var Button_default = Button2;
var SquareButton = (0, import_styled_components4.default)(Button2).attrs(({ icon }) => ({
  children: /* @__PURE__ */ import_react4.default.createElement(Icon_default, {
    icon
  })
}))`
  padding: 8px;
  width: 40px;
  height: 40px;

  ${Icon_default} {
    margin-right: 0;

    ${({ kind }) => kind === "secondary" && `
      color: var(--icon);
    `}
  }
`;
var sharedFocusStyles = import_styled_components4.css`
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border: 2px solid var(--pleather);
`;
var SplitButton = import_styled_components4.default.div`
  display: flex;
  width: fit-content;
  position: relative;
  background: var(--primary-grad);
  border-radius: 8px;
  min-width: fit-content;
  ${(props) => props.kind === "positive" && "background: var(--safety-grad);"}
  ${(props) => props.disabled && `background: var(--disabled);
    ${Button2} {
      pointer-events: none;
      cursor: not-allowed;
      :hover {
        box-shadow: none;
      }
    }
    `}

  ${Button2} {
    border: none;
    border-radius: 0;
    outline: none;
    background: none;
    position: relative;
  }

  ${Button2}:first-of-type {
    :focus-visible {
      :before {
        ${sharedFocusStyles}
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      }
    }
  }

  ${Button2}:not(:first-of-type) {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-left: 1px solid rgba(255, 255, 255, 0.3);
    padding: 18px 11px;

    ${Icon_default} {
      margin: 0;
      font-size: var(--xx-small);
    }
    :focus-visible {
      :before {
        ${sharedFocusStyles}
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }
    }
  }
`;
SplitButton.displayName = "SplitButton";
var ButtonGroup = import_styled_components4.default.div`
  align-items: stretch;
  display: flex;

  > ${Button2}, > ${SplitButton} {
    margin-right: 12px;
  }

  ${({ right }) => right && `
      flex-direction: row-reverse;

      > ${Button2}, > ${SplitButton} {
        margin-left: 12px;
        margin-right: 0;
      }
    `}
`;

// src/Caption.js
var import_prop_types4 = __toESM(require("prop-types"));
var import_styled_components5 = __toESM(require("styled-components"));
var Caption = import_styled_components5.default.span`
  color: var(--text-secondary);
  font-size: var(--x-small);
  font-weight: ${({ bold }) => bold ? "var(--semi-bold)" : "var(--normal)"};
  letter-spacing: 0;
  line-height: 1.5em;
`;
Caption.propTypes = {
  bold: import_prop_types4.default.bool
};
var Caption_default = Caption;
var ErrorMsg = (0, import_styled_components5.default)(Caption)`
  color: var(--danger-dark);
`;
var SuccessMsg = (0, import_styled_components5.default)(Caption)`
  color: var(--bulbasaur);
`;
var WarningMsg = (0, import_styled_components5.default)(Caption)`
  color: var(--warn-dark);
`;

// src/Card.js
var import_react5 = __toESM(require("react"));
var import_prop_types5 = __toESM(require("prop-types"));
var import_styled_components6 = __toESM(require("styled-components"));
var LIST = "list";
var GRID = "grid";
var ACTIVE = "active";
var INACTIVE = "inactive";
var SELECTED = "selected";
var Image = import_styled_components6.default.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 12px 24px;
`;
var Wrapper2 = import_styled_components6.default.div`
  --card-status-size: 7px;
  --card-grid-radius: 12px;
  --card-list-radius: 6px;
  --card-grid-radius-with-status: var(--card-status-size)
    var(--card-status-size) var(--card-grid-radius) var(--card-grid-radius);

  background-color: var(--white);
  box-shadow: var(--level-1);
  display: flex;
  transition: ${easing("box-shadow")};

  ${({ onClick }) => onClick && `
      cursor: pointer;

      :hover {
        box-shadow: var(--level-2);
      }
  `}

  ${({ $kind, $status }) => {
  switch ($kind) {
    case GRID:
      return `
          border-radius: ${$status ? `var(--card-grid-radius-with-status)` : `var(--card-grid-radius)`};
          flex-direction: column;

          ${Image} {
            background-color: var(--myst);
          }
        `;
    case LIST:
    default:
      return `
          border-radius: var(--card-list-radius);

          & + & {
            margin-top: 16px;
          }

          ${Image} {
            background-color: var(--light-gray);
          }
        `;
  }
}}

  &::before {
    content: '';
    flex-shrink: 0;
  }

  ${({ $kind, $status, $hasImage }) => {
  switch (true) {
    case ($kind === LIST && $status === ACTIVE):
      return `
          &::before {
            background: linear-gradient(0deg, var(--merfolk));
            border-radius: var(--card-list-radius) 0 0 var(--card-list-radius);
            height: auto;
            width: var(--card-status-size);
          }
        `;
    case ($kind === LIST && $status === INACTIVE):
      return `border-left: var(--card-status-size) solid var(--status-inactive);`;
    case ($kind === LIST && $status === SELECTED):
      return `
          &::before {
            background: linear-gradient(0deg, var(--blurple-haze));
            border-radius: var(--card-list-radius) 0 0 var(--card-list-radius);
            height: auto;
            width: var(--card-status-size);
          }
        `;
    case ($kind === LIST && !$status && $hasImage):
      return `border-left: var(--card-status-size) solid var(--light-gray)`;
    case ($kind === GRID && $status === ACTIVE):
      return `
          &::before {
            background: linear-gradient(90deg, var(--merfolk));
            border-radius: var(--card-status-size) var(--card-status-size) 0 0;
            height: var(--card-status-size);
            width: auto;
          }
        `;
    case ($kind === GRID && $status === INACTIVE):
      return `border-top: var(--card-status-size) solid var(--status-inactive);`;
    case ($kind === GRID && $status === SELECTED):
      return `
          &::before {
            background: linear-gradient(90deg, var(--blurple-haze));
            border-radius: var(--card-status-size) var(--card-status-size) 0 0;
            height: var(--card-status-size);
            width: auto;
          }
        `;
    case ($kind === GRID && !$status && $hasImage):
      return `border-top: var(--card-status-size) solid var(--myst)`;
    default:
      return ``;
  }
}}
`;
var Content = import_styled_components6.default.div`
  height: 100%;
  min-height: 0;
  min-width: 0;
  padding: 16px 24px;
  width: 100%;
`;
var Card = ({
  children,
  className,
  image,
  kind = LIST,
  onClick,
  status,
  ...unhandledProps
}) => /* @__PURE__ */ import_react5.default.createElement(Wrapper2, {
  className,
  onClick,
  $kind: kind,
  $status: status,
  $hasImage: !!image,
  ...unhandledProps
}, image && /* @__PURE__ */ import_react5.default.createElement(Image, null, image), /* @__PURE__ */ import_react5.default.createElement(Content, null, children));
Card.propTypes = {
  children: import_prop_types5.default.node,
  className: import_prop_types5.default.string,
  image: import_prop_types5.default.node,
  kind: import_prop_types5.default.oneOf([LIST, GRID]),
  onClick: import_prop_types5.default.func,
  status: import_prop_types5.default.oneOf([ACTIVE, INACTIVE, SELECTED])
};
var Card_default = (0, import_styled_components6.default)(Card)``;

// src/Carousel.js
var import_react6 = __toESM(require("react"));
var import_lodash = __toESM(require_lodash());
var import_styled_components7 = __toESM(require("styled-components"));
var import_prop_types6 = __toESM(require("prop-types"));
var CarouselWrapper = import_styled_components7.default.div`
  min-height: 120px;
  min-width: 200px;
  padding: 16px 32px;
  position: relative;
  width: 100%;
`;
var Navigation = import_styled_components7.default.div`
  align-items: center;
  background: none;
  border: none;
  bottom: 0;
  display: flex;
  position: absolute;
  top: 0;
  bottom: 32px;
  width: 118px;
  z-index: 1;
`;
var Left = (0, import_styled_components7.default)(Navigation)`
  justify-content: flex-start;
  left: 0;
  padding-left: 15px;
  ${({ $active }) => !$active && `background:  linear-gradient(90deg, var(--white) 3%, transparent 97%);`}
`;
var Right = (0, import_styled_components7.default)(Navigation)`
  justify-content: flex-end;
  padding-right: 15px;
  right: 0;
  ${({ $active }) => !$active && `background: linear-gradient(270deg,var(--white) 3%, transparent 97%);`}
`;
var Arrow = import_styled_components7.default.button`
  align-items: center;
  background-color: var(--white);
  border-radius: 50%;
  border: 1px solid var(--noreaster);
  box-shadow: var(--level-2);
  color: var(--blurple);
  display: flex;
  font-size: var(--medium-large);
  height: 40px;
  justify-content: center;
  width: 40px;
  ${({ disabled }) => disabled && "display: none;"}
`;
var Body2 = import_styled_components7.default.div`
  align-items: center;
  display: flex;
  gap: 24px;
`;
var Wrapper3 = import_styled_components7.default.div`
  display: flex;
  height: 100%;
  justify-content: flex-start;
  overflow-x: auto;
  padding: 16px 0;
  position: relative;
  width: 100%;
`;
var Item = import_styled_components7.default.div`
  display: flex;
  overflow: hidden;
`;
var ITEM_GAP = 24;
var SCROLL_INCREMENT = 200;
var ONE_FRAME = 16;
var Carousel = ({ items, className }) => {
  const [currentPosition, setCurrentPosition] = (0, import_react6.useState)(0);
  const [previousActive, setPreviousActive] = (0, import_react6.useState)(false);
  const [nextActive, setNextActive] = (0, import_react6.useState)(false);
  const [showArrow, setShowArrow] = (0, import_react6.useState)(false);
  const [wrapperWidth, setWrapperWidth] = (0, import_react6.useState)();
  const wrapper = (0, import_react6.useRef)();
  const body = (0, import_react6.useRef)();
  (0, import_react6.useEffect)(() => {
    const handler = (0, import_lodash.default)(() => {
      var _a;
      wrapper.current.scrollLeft = 0;
      setWrapperWidth((_a = wrapper.current) == null ? void 0 : _a.offsetWidth);
    }, ONE_FRAME);
    window.addEventListener("resize", handler);
    return () => {
      window.removeEventListener("resize", handler);
    };
  }, []);
  (0, import_react6.useLayoutEffect)(() => {
    const { offsetWidth, scrollWidth } = wrapper.current;
    setPreviousActive(currentPosition <= 0);
    setNextActive(scrollWidth - currentPosition - offsetWidth <= ITEM_GAP / 2);
    setWrapperWidth(scrollWidth);
  }, [wrapperWidth, currentPosition, items]);
  (0, import_react6.useLayoutEffect)(() => {
    const { parentElement, offsetWidth } = body.current;
    const bodyWidth = items.length * SCROLL_INCREMENT;
    const parentWidth = parentElement == null ? void 0 : parentElement.offsetWidth;
    setShowArrow(parentWidth <= offsetWidth || parentWidth <= bodyWidth);
  }, [wrapperWidth, currentPosition, items]);
  const previous = () => {
    wrapper.current.scrollLeft = wrapper.current.scrollLeft - SCROLL_INCREMENT - ITEM_GAP;
    setCurrentPosition(wrapper.current.scrollLeft);
  };
  const next = () => {
    wrapper.current.scrollLeft = wrapper.current.scrollLeft + SCROLL_INCREMENT + ITEM_GAP;
    setCurrentPosition(wrapper.current.scrollLeft);
  };
  const onScroll = (e2) => {
    setCurrentPosition(e2.target.scrollLeft);
  };
  return /* @__PURE__ */ import_react6.default.createElement(CarouselWrapper, {
    className
  }, showArrow && /* @__PURE__ */ import_react6.default.createElement(Left, {
    $active: previousActive
  }, /* @__PURE__ */ import_react6.default.createElement(Arrow, {
    disabled: previousActive,
    onClick: previous,
    role: "button",
    "aria-label": "previous"
  }, /* @__PURE__ */ import_react6.default.createElement(Icon_default, {
    icon: "chevron-left"
  }))), /* @__PURE__ */ import_react6.default.createElement(Wrapper3, {
    ref: wrapper,
    onScroll
  }, /* @__PURE__ */ import_react6.default.createElement(Body2, {
    ref: body
  }, items.map((slide) => {
    return /* @__PURE__ */ import_react6.default.createElement(Item, {
      key: slide.title,
      title: slide.title,
      tabIndex: "0"
    }, slide.element);
  }))), showArrow && /* @__PURE__ */ import_react6.default.createElement(Right, {
    $active: nextActive
  }, /* @__PURE__ */ import_react6.default.createElement(Arrow, {
    disabled: nextActive,
    onClick: next,
    role: "button",
    "aria-label": "next"
  }, /* @__PURE__ */ import_react6.default.createElement(Icon_default, {
    icon: "chevron-right"
  }))));
};
var ItemShape = {
  title: import_prop_types6.default.string,
  element: import_prop_types6.default.element
};
Carousel.propTypes = {
  items: import_prop_types6.default.arrayOf(import_prop_types6.default.shape(ItemShape)),
  className: import_prop_types6.default.string
};
Carousel.displayName = "Carousel";
var Carousel_default = (0, import_styled_components7.default)(Carousel)``;

// src/Checkbox.js
var import_react7 = __toESM(require("react"));
var import_react_checkbox_legacy = require("@radix-ui/react-checkbox-legacy");
var import_prop_types7 = __toESM(require("prop-types"));
var import_styled_components8 = __toESM(require("styled-components"));
var CheckboxIndicator = (0, import_styled_components8.default)(import_react_checkbox_legacy.Indicator).attrs({
  as: Icon_default,
  icon: "check"
})`
  color: transparent;
`;
var Label = import_styled_components8.default.label`
  font-weight: var(--semi-bold);
  color: var(--checkbox-color);
  cursor: pointer;
`;
var StarIcon = (0, import_styled_components8.default)(Icon_default)`
  font-size: 16px;
`;
var CheckboxWrapper = (0, import_styled_components8.default)(import_react_checkbox_legacy.Root)`
  transition: ${easing("background-color", "border-color", "box-shadow")};
  align-items: center;
  background-color: white;
  border-radius: 4px;
  border: 2px solid var(--checkbox);
  box-shadow: none;
  color: white;
  display: flex;
  flex-shrink: 0;
  font-size: var(--xx-small);
  height: 16px;
  justify-content: center;
  position: relative;
  text-align: center;
  width: 16px;
  cursor: pointer;
  outline: none;

  &:hover {
    border-color: var(--checkbox-hover);
  }

  &:focus {
    border-color: var(--checkbox-hover);
    background: var(--checkbox-unselected-focus-bg);
    box-shadow: 0 0 0 5px var(--checkbox-unselected-focus-bg);
  }

  &[aria-checked='true'] {
    background: var(--checkbox-checked);
    border-color: var(--checkbox-checked);
    &:focus {
      background: var(--checkbox-checked-hover);
      box-shadow: 0 0 0 5px var(--checkbox-selected-focus-bg);
      border-color: var(--checkbox-checked-hover);
    }
    &:hover {
      background: var(--checkbox-checked-hover);
    }
    ${CheckboxIndicator} {
      color: white;
    }
  }

  &[aria-invalid='true'] {
    border-color: var(--danger-dark);
    color: var(--danger-dark);

    & + ${Label} {
      color: var(--danger-dark);
    }

    &:hover,
    &:focus-within {
      border-color: var(--checkbox-hover);
      background: transparent;
      box-shadow: none;
    }
  }

  &[aria-checked='true'][aria-invalid='true'] {
    background: transparent;
    box-shadow: none;
    border-color: var(--danger-dark);

    &:focus {
      background: transparent;
      box-shadow: none;
    }
    &:hover {
      border-color: var(--checkbox-hover);
      background: transparent;
    }

    ${CheckboxIndicator} {
      color: var(--danger-dark);
    }
  }

  &[disabled] {
    cursor: default;
    border-color: var(--checkbox-disabled);
    color: var(--checkbox-disabled);

    & + ${Label} {
      cursor: default;
      color: var(--checkbox-disabled);
    }
  }

  &[disabled][aria-checked='true'] {
    background: var(--checkbox-disabled);
    border-color: var(--checkbox-disabled);
    color: var(--checkbox-disabled);
  }
`;
var StarWrapper = (0, import_styled_components8.default)(import_react_checkbox_legacy.Root)`
  border: none;
  background: transparent;
  color: var(--checkbox-star-color);
  &[aria-checked='true'] {
    ${StarIcon} {
      color: var(--checkbox-star-checked-color);
    }
  }
`;
var Wrapper4 = import_styled_components8.default.div`
  align-items: center;
  display: flex;

  position: relative;
  gap: 8px;

  ${({ $isStar }) => $isStar && "width: fit-content"}
`;
var CheckboxGroup = import_styled_components8.default.div`
  ${Wrapper4} {
    min-height: 40px;
    padding: 12px 24px;

    &:hover {
      background-color: var(--checkbox-group-hover);
      border-radius: 6px;
    }
  }
`;
var StarCheckbox = (0, import_styled_components8.default)(
  ({
    children,
    label,
    onChange,
    id = `checkbox-id-${Math.random() * 1e5}`,
    defaultChecked,
    checked,
    className,
    ...unhandledProps
  }) => {
    const [isChecked, setChecked] = (0, import_react7.useState)(defaultChecked || checked);
    const handleClick = () => {
      setChecked((currentChecked) => {
        onChange == null ? void 0 : onChange(!currentChecked);
        return !currentChecked;
      });
    };
    (0, import_react7.useEffect)(() => {
      setChecked(defaultChecked || checked);
    }, [defaultChecked, checked]);
    return /* @__PURE__ */ import_react7.default.createElement(Wrapper4, {
      className,
      $isStar: true
    }, /* @__PURE__ */ import_react7.default.createElement(StarWrapper, {
      id,
      checked: isChecked,
      ...unhandledProps,
      onClick: handleClick
    }, /* @__PURE__ */ import_react7.default.createElement(StarIcon, {
      $checked: isChecked,
      icon: isChecked ? "star" : ["far", "star"]
    })), (children || label) && /* @__PURE__ */ import_react7.default.createElement(Label, {
      htmlFor: id
    }, children || label));
  }
)``;
StarCheckbox.propTypes = {
  children: import_prop_types7.default.node,
  label: import_prop_types7.default.string,
  id: import_prop_types7.default.string,
  onChange: import_prop_types7.default.func,
  checked: import_prop_types7.default.bool,
  defaultChecked: import_prop_types7.default.bool,
  className: import_prop_types7.default.string
};
StarCheckbox.displayName = "StarCheckbox";
var Checkbox = import_react7.default.forwardRef(
  ({
    children,
    label,
    onChange,
    id = `checkbox-id-${Math.random() * 1e5}`,
    error,
    className,
    title,
    ...unhandledProps
  }, ref) => {
    return /* @__PURE__ */ import_react7.default.createElement(Wrapper4, {
      className,
      title
    }, /* @__PURE__ */ import_react7.default.createElement(CheckboxWrapper, {
      id,
      onCheckedChange: onChange,
      "aria-invalid": error,
      ref,
      ...unhandledProps
    }, /* @__PURE__ */ import_react7.default.createElement(CheckboxIndicator, null)), (children || label) && /* @__PURE__ */ import_react7.default.createElement(Label, {
      htmlFor: id
    }, children || label));
  }
);
Checkbox.propTypes = {
  children: import_prop_types7.default.node,
  label: import_prop_types7.default.string,
  id: import_prop_types7.default.string,
  onChange: import_prop_types7.default.func,
  error: import_prop_types7.default.bool,
  className: import_prop_types7.default.string,
  title: import_prop_types7.default.string
};
Checkbox.displayName = "Checkbox";
var Checkbox_default = (0, import_styled_components8.default)(Checkbox)``;

// src/CheckboxSelect.js
var import_react9 = __toESM(require("react"));
var import_styled_components11 = __toESM(require("styled-components"));
var import_react_select2 = require("react-select");

// src/Select.js
var import_react8 = __toESM(require("react"));
var import_prop_types8 = __toESM(require("prop-types"));
var import_styled_components10 = __toESM(require("styled-components"));
var import_react_select = __toESM(require("react-select"));
var import_creatable = __toESM(require("react-select/creatable"));

// src/Label.js
var import_styled_components9 = __toESM(require("styled-components"));
var Label_default = import_styled_components9.default.label`
  display: flex;
  flex-direction: column;
  font-size: var(--regular);
  font-weight: var(--semi-bold);
  gap: 6px;
  justify-content: space-between;
  position: relative;
  color: var(--pleather);

  & + && {
    margin-top: 16px;
  }
`;

// src/Select.js
var shapes = {
  OPTION: import_prop_types8.default.shape({
    label: import_prop_types8.default.node,
    value: import_prop_types8.default.any,
    icon: import_prop_types8.default.oneOfType([
      import_prop_types8.default.string,
      import_prop_types8.default.arrayOf(import_prop_types8.default.string)
    ])
  })
};
var extend = (overrides, styles = {}) => Object.entries(overrides).reduce((acc, [key, value]) => {
  acc[key] = (provided, state) => ({
    ...provided,
    ...typeof value === "function" ? value(state) : value,
    ...styles[key]
  });
  return acc;
}, {});
var base = {
  clearIndicator: {
    alignItems: "center",
    color: "var(--dropdown-inactive)",
    display: "flex",
    height: "16px",
    marginRight: "8px",
    padding: "0px",
    transition: "color 200ms ease-in-out",
    width: "16px",
    ":hover": {
      color: "var(--dropdown-active)"
    }
  },
  container: {
    fontSize: "var(--regular)",
    maxWidth: "400px",
    minWidth: "256px"
  },
  control: ({ isDisabled, isFocused, selectProps: { error } }) => ({
    background: "var(--dropdown-bg)",
    borderColor: "var(--dropdown-inactive)",
    borderRadius: "6px",
    boxShadow: "none",
    cursor: "pointer",
    minHeight: "40px",
    transition: "border-color 200ms ease-in-out",
    ":hover": {
      borderColor: "var(--dropdown-active)"
    },
    ...isFocused && {
      borderColor: "var(--dropdown-active)",
      ":hover": {
        borderColor: "var(--dropdown-active)"
      }
    },
    ...isDisabled && {
      background: "var(--dropdown-disabled)",
      borderColor: "var(--dropdown-disabled)",
      color: "var(--dropdown-disabled-text)",
      ":hover": {
        borderColor: "var(--dropdown-disabled)"
      }
    },
    ...error && {
      borderColor: "var(--danger-dark)",
      ":hover": {
        borderColor: "var(--danger-dark)"
      }
    }
  }),
  dropdownIndicator: ({ isDisabled, selectProps: { menuIsOpen } }) => ({
    alignItems: "center",
    color: "var(--dropdown-inactive)",
    display: "flex",
    height: "14px",
    marginRight: "12px",
    padding: "0px",
    width: "14px",
    ":hover": {
      color: "var(--dropdown-inactive)"
    },
    ...isDisabled && {
      color: "var(--dropdown-disabled-text)"
    },
    ...menuIsOpen && {
      transform: "rotate(-180deg)"
    }
  }),
  indicatorSeparator: {
    display: "none"
  },
  input: {
    color: "var(--dropdown-text)"
  },
  menu: {
    borderRadius: "6px",
    boxShadow: "var(--dropdown-menu-shadow)",
    color: "var(--dropdown-text)",
    marginTop: "6px",
    padding: "8px"
  },
  menuPortal: {
    zIndex: 99999
  },
  multiValue: {
    borderRadius: "4px",
    background: "var(--dropdown-option-bg)"
  },
  multiValueRemove: {
    color: "var(--dropdown-inactive)",
    ":hover": {
      color: "var(--dropdown-active)"
    }
  },
  option: ({ isFocused, isSelected }) => ({
    borderRadius: "6px",
    cursor: "pointer",
    ...isFocused && {
      background: "var(--dropdown-option-bg)"
    },
    ...isSelected && {
      background: "none",
      color: "var(--dropdown-option-selected)",
      fontWeight: "var(--bold)",
      ":hover": {
        background: "var(--dropdown-option-bg)"
      }
    }
  }),
  placeholder: {
    color: "var(--dropdown-placeholder)"
  },
  singleValue: {
    color: "var(--dropdown-text)"
  }
};
var borderless = {
  control: ({ hasValue, isFocused }) => ({
    background: "var(--dropdown-bg)",
    border: "none",
    boxShadow: "none",
    cursor: "pointer",
    transition: "background 200ms ease-in-out",
    ":hover": {
      background: "var(--dropdown-disabled)"
    },
    ...(isFocused || hasValue) && {
      background: "var(--dropdown-disabled)"
    }
  }),
  dropdownIndicator: {
    display: "none"
  }
};
var maxMenuHeight = 300;
var BaseIcon = (0, import_styled_components10.default)(Icon_default)`
  color: var(--dropdown-icon);
  font-size: var(--regular);
`;
var Prefix = (0, import_styled_components10.default)(BaseIcon)`
  margin-left: 12px;
`;
function Control({ children, ...unhandledProps }) {
  const {
    selectProps: { icon }
  } = unhandledProps;
  return /* @__PURE__ */ import_react8.default.createElement(import_react_select.components.Control, {
    ...unhandledProps
  }, icon && /* @__PURE__ */ import_react8.default.createElement(Prefix, {
    icon
  }), children);
}
var OptionLabel = import_styled_components10.default.div`
  color: var(--dropdown-text);
  font-weight: var(--bold);
  font-size: var(--regular);
`;
var Description = import_styled_components10.default.div`
  color: var(--dropdown-text);
  font-size: var(--regular);
  font-weight: var(--normal);
`;
var IconBox = import_styled_components10.default.div`
  width: 22px;
  margin-right: 2px;
  text-align: center;
  display: inline-block;
`;
var OptionIcon = (0, import_styled_components10.default)(({ isSelected, ...unhandledProps }) => /* @__PURE__ */ import_react8.default.createElement(BaseIcon, {
  ...unhandledProps
}))`
  margin-right: 6px;
  ${({ isSelected }) => isSelected && import_styled_components10.css`
      color: var(--dropdown-option-selected);
    `}
`;
var OptionWrapper = import_styled_components10.default.div`
  ${({ isSelected }) => isSelected && `
     color: var(--dropdown-option-selected);
     font-weight: bold;

     ${OptionLabel} {
      color: var(--dropdown-option-selected);
      font-weight: bold;
     }

     ${Description} {
      font-weight: var(--normal);
     }
    `}

  ${({ $isDisabled }) => $isDisabled && `
     ':hover': {
      borderColor: 'var(--dropdown-disabled)',
     },
     color: var(--dropdown-disabled-text);
     font-weight: bold;

     ${OptionLabel} {
      color: var(--dropdown-disabled-text);
      font-weight: bold;
     }

     ${Description} {
      font-weight: var(--normal);
      color: var(--dropdown-disabled-text);
     }
    `}
`;
function Option({
  children,
  data,
  innerProps,
  isSelected,
  isDisabled,
  ...unhandledProps
}) {
  const { label, description, icon } = data;
  const child = description ? /* @__PURE__ */ import_react8.default.createElement(OptionWrapper, {
    isSelected,
    $isDisabled: isDisabled
  }, /* @__PURE__ */ import_react8.default.createElement(OptionLabel, null, label), /* @__PURE__ */ import_react8.default.createElement(Description, null, description)) : /* @__PURE__ */ import_react8.default.createElement(import_react8.default.Fragment, null, icon && /* @__PURE__ */ import_react8.default.createElement(IconBox, null, /* @__PURE__ */ import_react8.default.createElement(OptionIcon, {
    isSelected,
    icon
  })), typeof label === "string" ? /* @__PURE__ */ import_react8.default.createElement("span", {
    title: label
  }, children) : children);
  return /* @__PURE__ */ import_react8.default.createElement(import_react_select.components.Option, {
    ...unhandledProps,
    data,
    innerProps: {
      ...innerProps,
      role: "option"
    },
    isSelected,
    isDisabled
  }, child);
}
function ClearIndicator({ innerProps, ...unhandledProps }) {
  return /* @__PURE__ */ import_react8.default.createElement(import_react_select.components.ClearIndicator, {
    ...unhandledProps,
    innerProps: {
      ...innerProps,
      "aria-label": "Clear options"
    }
  });
}
function MultiValueRemove({ innerProps, ...unhandledProps }) {
  return /* @__PURE__ */ import_react8.default.createElement(import_react_select.components.MultiValueRemove, {
    ...unhandledProps,
    innerProps: {
      ...innerProps,
      "aria-label": "Clear option"
    }
  });
}
function createSelect(Component2) {
  const isCreatable = Component2 === import_creatable.default;
  const Base2 = ({
    components: replacements,
    icon,
    inputValue: initialInputValue,
    isMulti,
    kind = "default",
    onChange,
    onInputChange,
    options: initialOptions,
    portal = false,
    styles,
    value: initialValue,
    ...unhandledProps
  }) => {
    const [options, setOptions] = (0, import_react8.useState)(initialOptions);
    const [value, setValue] = (0, import_react8.useState)(initialValue);
    const [inputValue, setInputValue] = (0, import_react8.useState)(initialInputValue);
    (0, import_react8.useEffect)(() => {
      setOptions(initialOptions);
    }, [initialOptions]);
    (0, import_react8.useEffect)(() => {
      setValue(initialValue);
    }, [initialValue]);
    (0, import_react8.useEffect)(() => {
      setInputValue(initialInputValue);
    }, [initialInputValue]);
    const handleBlur = () => {
      const label = (inputValue == null ? void 0 : inputValue.trim()) || "";
      const exists = options.find((option2) => option2.label === label);
      if (!label) {
        return;
      }
      const option = exists || { label, value: label };
      if (isMulti) {
        setValue([...value || [], option]);
      } else {
        setValue(option);
      }
      setInputValue("");
      onChange == null ? void 0 : onChange(option);
    };
    const handleInputChange = (textInput, { action }) => {
      if (action === "input-change") {
        setInputValue(textInput);
      }
      if (action === "input-blur" && isCreatable) {
        handleBlur();
      }
      onInputChange == null ? void 0 : onInputChange(textInput, { action });
    };
    const handleChange = (selected, ...rest) => {
      setValue(selected);
      setInputValue("");
      onChange == null ? void 0 : onChange(selected, ...rest);
    };
    const combinedStyles = (0, import_react8.useMemo)(() => {
      const baseStyles = {
        ...base,
        ...kind === "borderless" ? borderless : {}
      };
      return extend(baseStyles, styles);
    }, [styles, kind]);
    return /* @__PURE__ */ import_react8.default.createElement(Component2, {
      components: {
        ClearIndicator,
        Control,
        MultiValueRemove,
        Option,
        ...replacements
      },
      icon: (value == null ? void 0 : value.icon) || icon,
      menuPortalTarget: portal && document.querySelector("#portal-root"),
      menuPosition: portal ? "fixed" : "absolute",
      styles: combinedStyles,
      inputValue,
      isMulti,
      onChange: handleChange,
      onInputChange: handleInputChange,
      options,
      value,
      maxMenuHeight,
      ...unhandledProps
    });
  };
  Base2.propTypes = {
    components: import_prop_types8.default.objectOf(import_prop_types8.default.elementType),
    error: import_prop_types8.default.bool,
    icon: import_prop_types8.default.oneOfType([
      import_prop_types8.default.string,
      import_prop_types8.default.arrayOf(import_prop_types8.default.string)
    ]),
    kind: import_prop_types8.default.oneOf(["default", "borderless"]),
    portal: import_prop_types8.default.bool,
    styles: import_prop_types8.default.objectOf(
      import_prop_types8.default.oneOfType([import_prop_types8.default.object, import_prop_types8.default.func])
    ),
    inputValue: import_prop_types8.default.string,
    isMulti: import_prop_types8.default.bool,
    onChange: import_prop_types8.default.func,
    onInputChange: import_prop_types8.default.func,
    options: import_prop_types8.default.arrayOf(shapes.OPTION),
    value: import_prop_types8.default.oneOfType([
      import_prop_types8.default.arrayOf(shapes.OPTION),
      shapes.OPTION
    ])
  };
  return (0, import_styled_components10.default)(Base2)``;
}
var Select = createSelect(import_react_select.default);
var Creatable = createSelect(import_creatable.default);
var SelectLabel = (0, import_styled_components10.default)(Label_default)`
  > ${Select}, > ${Creatable} {
    margin-top: 6px;
  }

  & + && {
    margin-top: 16px;
  }
`;

// src/CheckboxSelect.js
var Toggle = (0, import_styled_components11.default)(Checkbox_default)`
  align-items: center;
  display: flex;
`;
var Label2 = import_styled_components11.default.span`
  color: var(--dropdown-text);
  font-weight: var(--normal);
`;
function CheckboxOption({ children, getValue, ...unhandledProps }) {
  const { data } = unhandledProps;
  const value = getValue();
  const checked = value.includes(data);
  return /* @__PURE__ */ import_react9.default.createElement(Option, {
    ...unhandledProps
  }, /* @__PURE__ */ import_react9.default.createElement(Toggle, {
    checked
  }, /* @__PURE__ */ import_react9.default.createElement(Label2, null, children)));
}
var Selected = import_styled_components11.default.span`
  color: var(--dropdown-text);
`;
var Remaining = import_styled_components11.default.span`
  color: var(--dropdown-text);
  margin-left: 4px;
`;
function CheckboxValueContainer({ children, getValue, ...unhandledProps }) {
  const [, input] = children;
  const value = getValue();
  const count = value.length;
  return /* @__PURE__ */ import_react9.default.createElement(import_react_select2.components.ValueContainer, {
    ...unhandledProps
  }, count === 0 && children, count > 0 && /* @__PURE__ */ import_react9.default.createElement(import_react9.default.Fragment, null, /* @__PURE__ */ import_react9.default.createElement(Selected, null, value[0].label), count > 1 && /* @__PURE__ */ import_react9.default.createElement(Remaining, null, "+", count - 1), input));
}
function CheckboxSelect({ components: components2, ...unhandledProps }) {
  return /* @__PURE__ */ import_react9.default.createElement(Select, {
    ...unhandledProps,
    blurInputOnSelect: false,
    closeMenuOnSelect: false,
    components: {
      ...components2,
      ClearIndicator,
      Control,
      MultiValueRemove,
      Option: CheckboxOption,
      ValueContainer: CheckboxValueContainer
    },
    hideSelectedOptions: false,
    isClearable: true,
    isMulti: true,
    isSearchable: false
  });
}
var CheckboxSelect_default = (0, import_styled_components11.default)(CheckboxSelect)``;

// src/ClickToCopy.js
var import_react11 = __toESM(require("react"));
var import_prop_types10 = __toESM(require("prop-types"));
var import_styled_components13 = __toESM(require("styled-components"));

// src/lib/Fade.js
var import_react10 = __toESM(require("react"));
var import_prop_types9 = __toESM(require("prop-types"));
var import_styled_components12 = __toESM(require("styled-components"));
var import_react_transition_group = require("react-transition-group");
var translate = ({ direction, distance }) => ({
  top: `translate3d(0, -${distance}px, 0)`,
  right: `translate3d(${distance}px, 0, 0)`,
  bottom: `translate3d(0, ${distance}px, 0)`,
  left: `translate3d(-${distance}px, 0, 0)`,
  center: "translate3d(0, 0, 0)"
})[direction];
var Container = import_styled_components12.default.div`
  opacity: 0;
  transition-property: opacity, transform;
  transition-timing-function: ease-in-out;
  transition-duration: ${({ timeout }) => timeout}ms;
  transition-delay: ${({ delay }) => delay}ms;

  &.fade-appear,
  &.fade-enter,
  &.fade-exit,
  &.fade-exit-active,
  &.fade-exit-done {
    opacity: 0;
    transform: ${translate};
  }

  &.fade-appear-active,
  &.fade-appear-done,
  &.fade-enter-active,
  &.fade-enter-done {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
var Fade = ({
  children,
  delay = 0,
  distance = 8,
  from = "center",
  timeout = 200,
  visible = false,
  ...unhandledProps
}) => /* @__PURE__ */ import_react10.default.createElement(import_react_transition_group.CSSTransition, {
  appear: true,
  classNames: "fade",
  in: visible,
  mountOnEnter: true,
  timeout: delay + timeout,
  unmountOnExit: true,
  ...unhandledProps
}, /* @__PURE__ */ import_react10.default.createElement(Container, {
  delay,
  distance,
  timeout,
  direction: from
}, children));
Fade.propTypes = {
  ...import_react_transition_group.CSSTransition.propTypes,
  children: import_prop_types9.default.node,
  delay: import_prop_types9.default.number,
  distance: import_prop_types9.default.number,
  from: import_prop_types9.default.oneOf(["top", "right", "bottom", "left", "center"]),
  timeout: import_prop_types9.default.number,
  visible: import_prop_types9.default.bool
};
var Fade_default = Fade;

// src/ClickToCopy.js
var copyText = (node, withoutHighlight = true) => {
  const range = document.createRange();
  range.selectNodeContents(node);
  window.getSelection().removeAllRanges();
  window.getSelection().addRange(range);
  document.execCommand("copy");
  if (withoutHighlight) {
    window.getSelection().removeAllRanges();
  }
};
var Wrapper5 = import_styled_components13.default.div`
  position: relative;
`;
var InputWrapper = import_styled_components13.default.div`
  background-color: var(--white);
  border-radius: 6px;
  border: 1px solid var(--text-secondary);
  display: flex;
  position: relative;
`;
var CopyIcon = (0, import_styled_components13.default)(Icon_default)`
  color: var(--primary);
  font-size: 12px;
  margin-left: 6px;
`;
var CopyButton = (0, import_styled_components13.default)(IconButton)`
  background-color: var(--primary-x-light);
  border-radius: 4px;
  border: 1px solid var(--primary);
  color: var(--primary);
  font-size: var(--x-small);
  height: 32px;
  margin: 3px;
  width: 32px;

  &:focus,
  &:hover {
    background-color: var(--primary-light);
    box-shadow: none;
    color: var(--primary-dark);
  }

  &:focus-visible {
    outline: auto;
  }
`;
var Text = import_styled_components13.default.span`
  color: var(--text-primary);
  flex: 1;
  font-size: var(--regular);
  font-weight: var(--normal);
  padding: 10px 14px;
  word-break: break-word;
`;
var TextWrapper = import_styled_components13.default.span`
  width: 0;
  height: 0;
  opacity: 0;
  white-space: nowrap;
  cursor: default;
`;
var TextKind = import_styled_components13.default.span`
  cursor: pointer;
  word-break: break-word;

  ${({ $icon }) => $icon && `
    display: flex;
    align-items: center;
  `}
`;
var FadeWrapper = (0, import_styled_components13.default)(Fade_default)`
  position: absolute;
  right: 0;
  top: -40px;
`;
var Toast = import_styled_components13.default.span`
  background-color: var(--copy-alert-bg);
  border-radius: 6px;
  color: var(--white);
  display: block;
  font-size: var(--regular);
  padding: 8px 12px;
  width: ${({ iconOnly }) => iconOnly ? "150px" : "auto"};
`;
var IconOnly = import_styled_components13.default.div`
  display: flex;
  width: '20px';
  height: '20px';

  cursor: pointer;
  ${TextWrapper} {
    pointer-events: none;
  }
`;
var ClickToCopy = ({ children, onCopy, iconOnly = false, fade = 2e3 }) => {
  const [visible, setVisible] = (0, import_react11.useState)(false);
  (0, import_react11.useEffect)(() => {
    if (!visible) {
      return;
    }
    const timer = setTimeout(() => {
      setVisible(false);
    }, fade);
    return () => {
      clearTimeout(timer);
    };
  }, [fade, visible]);
  const handleCopy = (node, withoutHighlight) => {
    copyText(node, withoutHighlight);
    setVisible(true);
    if (onCopy) {
      onCopy();
    }
  };
  return /* @__PURE__ */ import_react11.default.createElement(Wrapper5, null, /* @__PURE__ */ import_react11.default.createElement(FadeWrapper, {
    visible
  }, /* @__PURE__ */ import_react11.default.createElement(Toast, {
    iconOnly,
    role: "alert"
  }, "Copied to clipboard")), children(handleCopy));
};
ClickToCopy.propTypes = {
  fade: import_prop_types10.default.number,
  onCopy: import_prop_types10.default.func,
  children: import_prop_types10.default.func,
  iconOnly: import_prop_types10.default.bool
};
var BaseTextClickToCopy = ({
  text,
  icon,
  title,
  iconOnly = false,
  ...unhandledProps
}) => {
  const textRef = (0, import_react11.useRef)(null);
  return /* @__PURE__ */ import_react11.default.createElement(ClickToCopy, {
    iconOnly: true,
    ...unhandledProps
  }, (handleCopy) => /* @__PURE__ */ import_react11.default.createElement(TextKind, {
    onClick: () => {
      handleCopy(textRef.current, false);
    },
    ref: textRef,
    $icon: icon
  }, iconOnly ? /* @__PURE__ */ import_react11.default.createElement(IconOnly, {
    title
  }, /* @__PURE__ */ import_react11.default.createElement(TextWrapper, null, text), /* @__PURE__ */ import_react11.default.createElement(CopyIcon, {
    icon: "copy"
  })) : /* @__PURE__ */ import_react11.default.createElement(import_react11.default.Fragment, null, text, " ", icon && /* @__PURE__ */ import_react11.default.createElement(CopyIcon, {
    title,
    icon: "copy"
  }))));
};
BaseTextClickToCopy.propTypes = {
  ...ClickToCopy.propTypes,
  text: import_prop_types10.default.string.isRequired,
  icon: import_prop_types10.default.bool,
  iconOnly: import_prop_types10.default.bool,
  title: import_prop_types10.default.string
};
var TextClickToCopy = (0, import_styled_components13.default)(BaseTextClickToCopy)``;
var BaseInputClickToCopy = ({ text, ...unhandledProps }) => {
  const textRef = (0, import_react11.useRef)(null);
  return /* @__PURE__ */ import_react11.default.createElement(ClickToCopy, {
    ...unhandledProps
  }, (handleCopy) => /* @__PURE__ */ import_react11.default.createElement(InputWrapper, null, /* @__PURE__ */ import_react11.default.createElement(Text, {
    ref: textRef
  }, text), /* @__PURE__ */ import_react11.default.createElement(CopyButton, {
    icon: "copy",
    onClick: () => {
      handleCopy(textRef.current);
    },
    label: "Copy text",
    title: "Copy"
  })));
};
BaseInputClickToCopy.propTypes = {
  ...ClickToCopy.propTypes,
  text: import_prop_types10.default.string.isRequired
};
var InputClickToCopy = (0, import_styled_components13.default)(BaseInputClickToCopy)``;

// src/DateInput.js
var import_react16 = __toESM(require("react"));
var import_server = require("react-dom/server");
var import_prop_types12 = __toESM(require("prop-types"));
var import_styled_components15 = __toESM(require("styled-components"));
var import_DayPickerInput = __toESM(require("react-day-picker-legacy/DayPickerInput"));

// src/lib/Portal.js
var import_react12 = require("react");
var import_react_dom = require("react-dom");
var Portal = ({ children, timeout = 0 }) => {
  const $portal = document.querySelector("#portal-root");
  const $el = (0, import_react12.useMemo)(() => {
    return document.createElement("div");
  }, []);
  (0, import_react12.useEffect)(() => {
    if ($portal) {
      $portal.append($el);
    }
    return () => {
      if (timeout > 0) {
        setTimeout(() => {
          $el.remove();
        }, timeout);
      } else {
        $el.remove();
      }
    };
  }, [$el, $portal, timeout]);
  return (0, import_react_dom.createPortal)(children, $el);
};
var Portal_default = Portal;

// src/lib/date.js
var import_moment = __toESM(require("moment"));
import_moment.default.suppressDeprecationWarnings = true;
var fromNow = (date, omitSuffix = false) => {
  return (0, import_moment.default)(date).fromNow(omitSuffix);
};
var calendar = (date) => {
  return (0, import_moment.default)(date).calendar();
};
var format = (date, tokens) => {
  return (0, import_moment.default)(date).format(tokens);
};
var isAfter = (date, compare) => {
  return (0, import_moment.default)(date).isAfter((0, import_moment.default)(compare));
};
var isBefore = (date, compare) => {
  return (0, import_moment.default)(date).isBefore((0, import_moment.default)(compare));
};
var startOf = (date, unit) => {
  return (0, import_moment.default)(date).startOf(unit).toDate();
};
var endOf = (date, unit) => {
  return (0, import_moment.default)(date).endOf(unit).toDate();
};
var add = (date, value, unit) => {
  return (0, import_moment.default)(date).add(value, unit).toDate();
};
var subtract = (date, value, unit) => {
  return (0, import_moment.default)(date).subtract(value, unit).toDate();
};
var diff = (start, end, unit) => {
  return (0, import_moment.default)(end).diff((0, import_moment.default)(start), unit, true);
};
var parse = (value) => {
  const date = (0, import_moment.default)(value);
  return date.isValid(date) ? date.toDate() : null;
};
var utc = (date) => {
  return (0, import_moment.default)(date).utc();
};

// src/lib/date-range.js
var import_react13 = require("react");
var import_react_day_picker_legacy = require("react-day-picker-legacy");
var DATE_FORMAT = "MMM D, YYYY";
var RANGE_OPTIONS = [
  {
    label: "Last 7 days",
    value: 7
  },
  {
    label: "Last 30 days",
    value: 30
  },
  {
    label: "Last 60 days",
    value: 60
  },
  {
    label: "Last 90 days",
    value: 90
  },
  {
    label: "Current quarter",
    value: "current-quarter"
  },
  {
    label: "Previous quarter",
    value: "previous-quarter"
  },
  {
    label: "Custom",
    value: "custom"
  }
];
var FULL_RANGE_OPTIONS = RANGE_OPTIONS.filter(({ value }) => {
  return !["current-quarter", "previous-quarter"].includes(value);
});
var LIMITED_RANGE_OPTIONS = RANGE_OPTIONS.filter(({ value }) => {
  return [7, 30].includes(value);
});
var EARLIEST_YEAR = 2013;
var YEAR_OPTIONS = Array.from({
  length: new Date().getFullYear() - EARLIEST_YEAR + 1
}).map((_, index) => ({
  label: `${EARLIEST_YEAR + index}`,
  value: EARLIEST_YEAR + index
}));
var MONTH_OPTIONS = import_react_day_picker_legacy.LocaleUtils.getMonths().map((month, index) => ({
  label: month,
  value: index
}));
var getEndOfToday = () => {
  return endOf(Date.now(), "day");
};
var getRecommendedFrequency = ({ start, end }, threshold = 90) => {
  const duration = diff(start, end, "days");
  return Math.ceil(duration) > threshold ? "month" : "day";
};
var validateDate = (value, future) => {
  if (value === "") {
    return true;
  }
  const date = parse(value);
  const valid = date != null;
  if (valid && future) {
    return true;
  }
  const endOfToday = getEndOfToday();
  return valid && isBefore(date, endOfToday);
};
var normalizeDates = ({ start, end }) => ({
  start: start && startOf(start, "day"),
  end: end && endOf(end, "day")
});
var sanitizeDates = (dates = {}, changed = "start") => {
  const { start, end } = dates;
  const other = changed === "start" ? "end" : "start";
  const invalid = changed === "start" ? dates[changed] > end : dates[changed] < start;
  const sanitized = {
    [changed]: dates[changed],
    [other]: invalid ? void 0 : dates[other]
  };
  return normalizeDates(sanitized);
};
var calculateDatesFor = (range, override) => {
  const overridden = override == null ? void 0 : override(range);
  if (overridden) {
    return overridden;
  }
  const parsed = Number.parseInt(range, 10);
  const tail = startOf(add(Date.now(), 1, "days"), "day");
  switch (true) {
    case (typeof parsed === "number" && !Number.isNaN(parsed)): {
      return {
        range,
        start: startOf(subtract(tail, parsed, "days"), "day"),
        end: getEndOfToday()
      };
    }
    case range === "current-quarter": {
      return {
        range,
        start: startOf(tail, "quarter"),
        end: getEndOfToday()
      };
    }
    case range === "previous-quarter": {
      const previous = subtract(tail, 1, "quarter");
      return {
        range,
        start: startOf(previous, "quarter"),
        end: endOf(previous, "quarter")
      };
    }
    case range === "custom":
    default:
      return { range, start: null, end: null };
  }
};
var useDateRange = (options = [], initial = {}, calculate) => {
  var _a;
  const { range } = initial;
  const normalized = !options.some(({ value: value2 }) => value2 === range) ? (_a = options[0]) == null ? void 0 : _a.value : range;
  const dates = range && normalized !== "custom" ? calculateDatesFor(normalized, calculate) : initial;
  const [value, setDateRange] = (0, import_react13.useState)(dates);
  return [value, setDateRange];
};

// src/Input.js
var import_react14 = __toESM(require("react"));
var import_prop_types11 = __toESM(require("prop-types"));
var import_styled_components14 = __toESM(require("styled-components"));
var InputWrapper2 = import_styled_components14.default.div`
  position: relative;
  width: fit-content;

  :focus,
  :focus-within {
    ${Icon_default} {
      color: var(--input-text);
    }
  }

  ${Icon_default} {
    top: 12px;
    left: 16px;
    position: absolute;
    height: 16px;
    width: 16px;
    color: var(--input-clear-icon-color);
  }
`;
var Input = import_styled_components14.default.input`
  background-color: var(--white);
  border: 1px solid;
  border-color: var(--input);
  border-radius: 6px;
  color: var(--input-text);
  font-size: var(--regular);
  font-weight: var(--normal);
  height: 40px;
  outline: none;
  padding: 10px 14px;

  &::placeholder {
    color: var(--input);
  }

  &:focus {
    border: 1px solid;
    border-color: var(--input-focus);
  }

  &[readonly] {
    cursor: default;
  }

  &[disabled],
  &[readonly] {
    background-color: var(--input-disabled-bg);
    border: 1px solid var(--input-disabled-bg);
    color: var(--input-disabled);
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  &[type='number'] {
    appearance: textfield;
  }

  &[type='search'] {
    min-width: 256px;
    padding-left: 44px;
    padding-right: 8px;

    ::-webkit-search-cancel-button {
      appearance: none;
      cursor: pointer;
      height: 16px;
      width: 16px;

      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%7e89a9'><path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/></svg>");
    }
  }

  ${({ error }) => error && `
      border-color: var(--danger-dark);
      color: var(--danger-dark);

      &:focus {
        border-color: var(--danger-dark);
      }
    `}
`;
var SearchInput = (0, import_styled_components14.default)(({ className, ...unhandledProps }) => {
  return /* @__PURE__ */ import_react14.default.createElement(InputWrapper2, {
    className
  }, /* @__PURE__ */ import_react14.default.createElement(Icon_default, {
    icon: "search"
  }), /* @__PURE__ */ import_react14.default.createElement(Input, {
    type: "search",
    ...unhandledProps
  }));
})``;
SearchInput.displayName = "SearchInput";
Input.propTypes = {
  error: import_prop_types11.default.bool,
  name: import_prop_types11.default.string,
  type: import_prop_types11.default.string.isRequired
};
var Input_default = Input;

// src/hooks/use-position.js
var import_react15 = require("react");
var import_lodash2 = __toESM(require_lodash());
var getBoundingClientRect = ($element) => $element ? $element.getBoundingClientRect() : { top: 0, right: 0, bottom: 0, left: 0, height: 0, width: 0 };
var getPositions = ({ attachment, target }) => {
  return {
    right: {
      top: target.bottom,
      left: target.right - attachment.width
    },
    left: { top: target.bottom, left: target.left },
    top: {
      top: target.top - (target.height + 300),
      left: target.left
    },
    bottom: {
      top: target.bottom + 10,
      left: target.left
    }
  };
};
function usePosition({ placement, visible }) {
  const target = (0, import_react15.useRef)();
  const attachment = (0, import_react15.useRef)();
  const [position, setPosition] = (0, import_react15.useState)({});
  const reposition = (0, import_react15.useCallback)(() => {
    const { current: $target } = target;
    const { current: $attachment } = attachment;
    const targetRect = getBoundingClientRect($target);
    const attachmentRect = getBoundingClientRect($attachment);
    const positions = getPositions({
      attachment: attachmentRect,
      target: targetRect
    });
    setPosition(positions[placement]);
  }, [placement]);
  (0, import_react15.useLayoutEffect)(() => {
    if (!visible) {
      return;
    }
    const handler = (0, import_lodash2.default)(reposition, 16, { leading: true });
    reposition();
    window.addEventListener("resize", handler);
    window.addEventListener("scroll", handler);
    return () => {
      window.removeEventListener("resize", handler);
      window.removeEventListener("scroll", handler);
    };
  }, [reposition, visible]);
  return [{ attachment, target }, position, reposition];
}

// src/DateInput.js
var PREV_ICON = (0, import_server.renderToStaticMarkup)(/* @__PURE__ */ import_react16.default.createElement(Icon_default, {
  icon: "chevron-left"
}));
var NEXT_ICON = (0, import_server.renderToStaticMarkup)(/* @__PURE__ */ import_react16.default.createElement(Icon_default, {
  icon: "chevron-right"
}));
var prefix = "DatePicker";
var classes = {
  wrapper: `${prefix}-wrapper`,
  month: `${prefix}-Month`,
  navButtonPrev: `${prefix}-NavButton ${prefix}-NavButton--prev`,
  navButtonNext: `${prefix}-NavButton ${prefix}-NavButton--next`,
  caption: `${prefix}-Caption`,
  weekdays: `${prefix}-Weekdays`,
  weekdaysRow: `${prefix}-WeekdaysRow`,
  weekday: `${prefix}-Weekday`,
  body: `${prefix}-Body`,
  week: `${prefix}-Week`,
  day: `${prefix}-Day`,
  today: "today",
  selected: "selected",
  disabled: "disabled",
  outside: "outside"
};
var Wrapper6 = import_styled_components15.default.div`
  /**
   * DayPickerInput
   */

  .DayPickerInput {
    display: inline-block;
    width: 100%;

    ${Input_default} {
      width: 100%;
    }
  }

  .DayPickerInput-OverlayWrapper {
    position: relative;
  }

  .DayPickerInput-Overlay {
    background-color: var(--white);
    border-radius: 6px;
    box-shadow: var(--level-3);
    color: var(--datepicker-color);
    left: 0;
    position: absolute;
    top: 10px;
    z-index: var(--z-index-300);
  }

  /**
   * DayPicker
   */

  .${prefix}-wrapper {
    user-select: none;
  }

  .${prefix}-Month {
    user-select: none;
  }

  .${prefix}-NavButton {
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50%;
    cursor: pointer;
    display: inline-block;
    height: var(--regular);
    opacity: 0.6;
    position: absolute;
    right: 28px;
    top: 30px;
    width: var(--regular);

    :hover {
      opacity: 0.4;
    }
  }

  .${prefix}-NavButton--prev {
    margin-right: 20px;
    background-image: url('data:image/svg+xml;utf8, ${PREV_ICON}');
  }

  .${prefix}-NavButton--next {
    background-image: url('data:image/svg+xml;utf8, ${NEXT_ICON}');
  }

  .${prefix}-Caption {
    background-color: var(--datepicker-header-bg);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    padding: 16px;
  }

  .${prefix}-Weekdays {
    background-color: var(--datepicker-header-bg);
    padding: 0 16px;
  }

  .${prefix}-WeekdaysRow {
    align-items: center;
    display: flex;
    justify-content: space-around;
  }

  .${prefix}-Weekday {
    align-items: center;
    color: var(--datepicker-weekday-color);
    display: flex;
    font-size: var(--x-small);
    font-weight: var(--bold);
    justify-content: center;
    padding: 8px;

    abbr[title] {
      border-bottom: none;
      text-decoration: none;
    }
  }

  .${prefix}-Body {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    padding: 16px;
  }

  .${prefix}-Week {
    display: contents;
  }

  .${prefix}-Day {
    align-items: center;
    border: 1px solid transparent;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    font-size: var(--regular);
    height: 40px;
    justify-content: center;
    width: 40px;
  }

  /**
   * Modifiers
   */

  .disabled {
    background-color: var(--datepicker-disabled-bg);
    border-radius: 0;
    color: var(--datepicker-disabled-color);
    cursor: default;
  }

  .outside {
    color: var(--datepicker-outside-color);
  }

  .${prefix}-Day:not(.disabled) {
    :hover {
      background-color: var(--datepicker-hover);
      color: var(--datepicker-color);
      font-weight: var(--bold);
    }
  }

  .selected:not(.disabled) {
    background-color: var(--datepicker-selected-bg);
    border: 1px solid var(--datepicker-selected-border);
    color: var(--datepicker-color);
    font-weight: var(--bold);

    :hover {
      background-color: var(--datepicker-selected-hover);
    }
  }
`;
var FooterWrapper = import_styled_components15.default.div`
  background-color: var(--datepicker-footer-bg);
  box-shadow: 0px -4px 10px var(--tint-black);
  padding: 8px 16px;
  text-align: center;
`;
var CaptionWrapper = import_styled_components15.default.div`
  display: flex;

  ${Select} {
    &:first-of-type {
      max-width: 120px;
      margin-right: 8px;
      min-width: 120px;
    }

    &:last-of-type {
      max-width: 80px;
      min-width: 80px;
    }
  }
`;
function Overlay({
  children,
  classNames,
  footer,
  input,
  portal,
  selectedDay: omit,
  attachmentRef,
  position,
  ...unhandledProps
}) {
  const { overlay, overlayWrapper } = classNames;
  if (portal && input) {
    return /* @__PURE__ */ import_react16.default.createElement(Portal_default, null, /* @__PURE__ */ import_react16.default.createElement(Wrapper6, {
      role: "dialog",
      ...unhandledProps
    }, /* @__PURE__ */ import_react16.default.createElement("div", {
      ref: attachmentRef,
      className: overlay,
      style: position
    }, children, footer && /* @__PURE__ */ import_react16.default.createElement(FooterWrapper, null, footer))));
  }
  return /* @__PURE__ */ import_react16.default.createElement("div", {
    role: "dialog",
    className: overlayWrapper,
    ...unhandledProps
  }, /* @__PURE__ */ import_react16.default.createElement("div", {
    className: overlay
  }, children, footer && /* @__PURE__ */ import_react16.default.createElement(FooterWrapper, null, footer)));
}
Overlay.propTypes = {
  children: import_prop_types12.default.node,
  classNames: import_prop_types12.default.shape({
    overlay: import_prop_types12.default.string,
    overlayWrapper: import_prop_types12.default.string
  }),
  footer: import_prop_types12.default.oneOfType([import_prop_types12.default.node, import_prop_types12.default.func]),
  input: import_prop_types12.default.instanceOf(HTMLElement),
  portal: import_prop_types12.default.bool,
  selectedDay: import_prop_types12.default.instanceOf(Date),
  attachmentRef: import_prop_types12.default.oneOfType([import_prop_types12.default.func, import_prop_types12.default.object]),
  position: import_prop_types12.default.shape({
    top: import_prop_types12.default.number,
    bottom: import_prop_types12.default.number,
    left: import_prop_types12.default.number,
    right: import_prop_types12.default.number
  })
};
function Caption2({ classNames, date, onChange, portal }) {
  const month = date.getMonth();
  const year = date.getFullYear();
  const fallback = { label: `${year}`, value: year };
  const overrides = {
    menuList: (provided) => ({
      ...provided,
      maxHeight: "420px"
    })
  };
  const handleMonthChange = ({ value }) => {
    const next = new Date(date);
    onChange(new Date(next.setMonth(value)));
  };
  const handleYearChange = ({ value }) => {
    const next = new Date(date);
    onChange(new Date(next.setFullYear(value)));
  };
  return /* @__PURE__ */ import_react16.default.createElement("div", {
    className: classNames.caption
  }, /* @__PURE__ */ import_react16.default.createElement(CaptionWrapper, null, /* @__PURE__ */ import_react16.default.createElement(Select, {
    name: "Month picker",
    onChange: handleMonthChange,
    options: MONTH_OPTIONS,
    portal,
    styles: overrides,
    value: MONTH_OPTIONS.find(({ value }) => value === month)
  }), /* @__PURE__ */ import_react16.default.createElement(Select, {
    name: "Year picker",
    onChange: handleYearChange,
    options: YEAR_OPTIONS,
    portal,
    styles: overrides,
    value: YEAR_OPTIONS.find(({ value }) => value === year) || fallback
  })));
}
Caption2.propTypes = {
  classNames: import_prop_types12.default.shape({
    caption: import_prop_types12.default.string
  }),
  date: import_prop_types12.default.instanceOf(Date),
  onChange: import_prop_types12.default.func,
  portal: import_prop_types12.default.bool
};
var DayInput = import_react16.default.forwardRef((props, ref) => {
  return /* @__PURE__ */ import_react16.default.createElement(Input_default, {
    ref: ($ele) => {
      ref($ele);
      props.setTargetRef($ele);
    },
    ...props
  });
});
DayInput.propTypes = {
  setTargetRef: import_prop_types12.default.func
};
function DateInput({
  future = false,
  className,
  dayPickerProps = {},
  footer,
  inputProps: { error, ...inputProps } = {},
  onChange,
  onDayChange,
  onDayClick,
  onDayPickerHide,
  portal,
  value,
  placement = "bottom",
  ...unhandledProps
}) {
  const $picker = (0, import_react16.useRef)();
  const [{ staged, status }, setStaged] = (0, import_react16.useState)({});
  const [invalid, setInvalid] = (0, import_react16.useState)(false);
  const [isOpen, setIsOpen] = (0, import_react16.useState)(false);
  const [refs, position] = usePosition({ placement, visible: isOpen });
  const reset = () => {
    setStaged({});
    setInvalid(false);
  };
  (0, import_react16.useEffect)(reset, [value]);
  const endOfToday = (0, import_react16.useMemo)(() => {
    return endOf(Date.now(), "day");
  }, []);
  const handleDayChange = (date, ...rest) => {
    setStaged({ status: "commit", staged: date });
    onDayChange == null ? void 0 : onDayChange(date, ...rest);
  };
  const handleDayClick = (date, modifiers, ...rest) => {
    date.setHours(0);
    setStaged(modifiers.disabled ? {} : { status: "commit", staged: date });
    onDayClick == null ? void 0 : onDayClick(date, modifiers, ...rest, $picker.current);
  };
  const handleDayPickerShow = () => {
    setIsOpen(true);
  };
  const handleDayPickerHide = () => {
    const $input = $picker.current.input;
    const valid = validateDate($input.value, future);
    const previous = value && new Date(value);
    setIsOpen(false);
    switch (status) {
      case "commit":
        onChange == null ? void 0 : onChange(valid ? staged : previous);
        break;
      case "revert":
        onChange == null ? void 0 : onChange(previous);
        break;
      default:
        break;
    }
    setInvalid(!previous && !valid);
    setStaged({});
    onDayPickerHide == null ? void 0 : onDayPickerHide();
  };
  const handleInputKeyDown = (event, ...rest) => {
    var _a;
    const $input = $picker.current.input;
    switch (event.key) {
      case "Enter":
        $input.blur();
        break;
      case "Escape":
        setStaged({ status: status && "revert" });
        $input.blur();
        break;
      default:
        break;
    }
    (_a = inputProps.onKeyDown) == null ? void 0 : _a.call(inputProps, event, ...rest);
  };
  const overlay = (args) => /* @__PURE__ */ import_react16.default.createElement(Overlay, {
    attachmentRef: refs.attachment,
    position,
    footer,
    portal,
    ...args
  });
  const caption = (args) => /* @__PURE__ */ import_react16.default.createElement(Caption2, {
    onChange: handleDayChange,
    portal,
    ...args
  });
  return /* @__PURE__ */ import_react16.default.createElement(Wrapper6, {
    className
  }, /* @__PURE__ */ import_react16.default.createElement(import_DayPickerInput.default, {
    key: value,
    ref: $picker,
    onDayPickerShow: handleDayPickerShow,
    component: DayInput,
    dayPickerProps: {
      ...dayPickerProps,
      captionElement: caption,
      classNames: classes,
      disabledDays: [
        future ? {} : { after: endOfToday },
        ...dayPickerProps.disabledDays || []
      ],
      initialMonth: value,
      month: staged || value,
      onDayClick: handleDayClick,
      showOutsideDays: true,
      weekdaysShort: ["S", "M", "T", "W", "T", "F", "S"]
    },
    format: DATE_FORMAT,
    formatDate: (date) => format(date, DATE_FORMAT),
    inputProps: {
      "aria-invalid": error || invalid,
      "aria-label": "Date picker",
      type: "text",
      error: error || invalid,
      onKeyDown: handleInputKeyDown,
      setTargetRef: ($ele) => {
        refs.target.current = $ele;
      },
      ...inputProps
    },
    keepFocus: false,
    onDayChange: handleDayChange,
    onDayPickerHide: handleDayPickerHide,
    overlayComponent: overlay,
    parseDate: parse,
    placeholder: "MM/DD/YY",
    value,
    ...unhandledProps
  }));
}
DateInput.propTypes = {
  dayPickerProps: import_prop_types12.default.object,
  inputProps: import_prop_types12.default.object,
  footer: import_prop_types12.default.oneOfType([import_prop_types12.default.node, import_prop_types12.default.func]),
  future: import_prop_types12.default.bool,
  onChange: import_prop_types12.default.func,
  onDayClick: import_prop_types12.default.func,
  className: import_prop_types12.default.string,
  onDayChange: import_prop_types12.default.func,
  onDayPickerHide: import_prop_types12.default.func,
  portal: import_prop_types12.default.bool,
  value: import_prop_types12.default.instanceOf(Date),
  placement: import_prop_types12.default.oneOf(["bottom", "top"])
};
var DateInput_default = (0, import_styled_components15.default)(DateInput)``;

// src/DateRangeInputs.js
var import_react17 = __toESM(require("react"));
var import_prop_types13 = __toESM(require("prop-types"));
var import_styled_components16 = __toESM(require("styled-components"));
var Wrapper7 = import_styled_components16.default.div`
  align-items: center;
  display: flex;
`;
var DateLabel = (0, import_styled_components16.default)(Label_default)`
  color: var(--datepicker-label);
  font-size: var(--x-small);
  font-weight: var(--normal);
  width: 100%;

  > :first-child {
    margin-top: 4px;
  }
`;
var Separator = import_styled_components16.default.span`
  color: var(--datepicker-separator);
  padding-top: 16px;

  ::before {
    content: '-';
    margin: 0 8px;
  }
`;
function DateRangeInputs({
  className,
  disabled = false,
  endProps = {},
  onChange,
  onDayClick,
  portal = false,
  startProps = {},
  value: { start, end } = {}
}) {
  const handleChangeFor = (changed) => (value) => {
    const next = { start, end, [changed]: value };
    const sanitized = sanitizeDates(next, changed);
    onChange == null ? void 0 : onChange(sanitized, changed);
  };
  const handleDayClickFor = (changed) => (value, ...unhandledProps) => {
    const next = { start, end, [changed]: value };
    const sanitized = sanitizeDates(next, changed);
    onDayClick == null ? void 0 : onDayClick(sanitized, changed, ...unhandledProps);
  };
  return /* @__PURE__ */ import_react17.default.createElement(Wrapper7, {
    className
  }, /* @__PURE__ */ import_react17.default.createElement(DateLabel, {
    htmlFor: "start"
  }, "Start", /* @__PURE__ */ import_react17.default.createElement(DateInput_default, {
    ...startProps,
    inputProps: {
      ...startProps.inputProps,
      "aria-label": "Start date",
      name: "start",
      disabled
    },
    onChange: handleChangeFor("start"),
    onDayClick: handleDayClickFor("start"),
    portal,
    value: start
  })), /* @__PURE__ */ import_react17.default.createElement(Separator, null), /* @__PURE__ */ import_react17.default.createElement(DateLabel, {
    htmlFor: "end"
  }, "End", /* @__PURE__ */ import_react17.default.createElement(DateInput_default, {
    ...endProps,
    inputProps: {
      ...endProps.inputProps,
      "aria-label": "End date",
      name: "end",
      disabled
    },
    onChange: handleChangeFor("end"),
    onDayClick: handleDayClickFor("end"),
    portal,
    value: end
  })));
}
DateRangeInputs.propTypes = {
  startProps: import_prop_types13.default.object,
  endProps: import_prop_types13.default.object,
  onChange: import_prop_types13.default.func,
  onDayClick: import_prop_types13.default.func,
  className: import_prop_types13.default.string,
  disabled: import_prop_types13.default.bool,
  portal: import_prop_types13.default.bool,
  value: import_prop_types13.default.shape({
    start: import_prop_types13.default.instanceOf(Date),
    end: import_prop_types13.default.instanceOf(Date)
  })
};
var DateRangeInputs_default = (0, import_styled_components16.default)(DateRangeInputs)``;

// src/DateRangePicker.js
var import_react18 = __toESM(require("react"));
var import_prop_types14 = __toESM(require("prop-types"));
var import_styled_components17 = __toESM(require("styled-components"));
var Wrapper8 = import_styled_components17.default.div`
  align-items: stretch;
  display: flex;

  ${({ stacked }) => stacked ? `
          flex-direction: column;

          ${Select} {
            margin-bottom: 8px;
            max-width: unset;
          }
        ` : `
          flex-direction: row;

          ${Select} {
            margin-right: 16px;
            max-width: 180px;
            min-width: 180px;
          }

          ${DateRangeInputs_default} {
            margin-top: 4px;
          }

          ${DateInput_default} {
            width: 125px;
          }
        `}
`;
function DateRangePicker({
  calculate,
  className,
  onChange,
  options = [],
  portal = false,
  stacked = false,
  value: initial = {},
  ...unhandledProps
}) {
  const [{ range, start, end }, setValue] = useDateRange(
    options,
    initial,
    calculate
  );
  const handleTypeChange = (0, import_react18.useCallback)(
    ({ value: selected }) => {
      const next = calculateDatesFor(selected, calculate);
      setValue(next);
      onChange == null ? void 0 : onChange(next);
    },
    [calculate, onChange, setValue]
  );
  const handleDateChange = (0, import_react18.useCallback)(
    (dates) => {
      const next = { range: "custom", ...dates };
      setValue(next);
      onChange == null ? void 0 : onChange(next);
    },
    [onChange, setValue]
  );
  return /* @__PURE__ */ import_react18.default.createElement(Wrapper8, {
    className,
    stacked
  }, /* @__PURE__ */ import_react18.default.createElement(Label_default, {
    htmlFor: "range"
  }, "Date range", /* @__PURE__ */ import_react18.default.createElement(Select, {
    name: "range",
    onChange: handleTypeChange,
    options,
    portal,
    value: options.find(({ value: selected }) => selected === range)
  })), /* @__PURE__ */ import_react18.default.createElement(DateRangeInputs_default, {
    ...unhandledProps,
    disabled: range !== "custom",
    onChange: handleDateChange,
    portal,
    value: { start, end }
  }));
}
DateRangePicker.propTypes = {
  ...DateRangeInputs_default.propTypes,
  calculate: import_prop_types14.default.func,
  className: import_prop_types14.default.string,
  onChange: import_prop_types14.default.func,
  options: import_prop_types14.default.arrayOf(
    import_prop_types14.default.shape({
      label: import_prop_types14.default.string,
      value: import_prop_types14.default.oneOfType([import_prop_types14.default.string, import_prop_types14.default.number])
    })
  ),
  portal: import_prop_types14.default.bool,
  stacked: import_prop_types14.default.bool,
  value: import_prop_types14.default.shape({
    range: import_prop_types14.default.oneOfType([import_prop_types14.default.string, import_prop_types14.default.number]),
    start: import_prop_types14.default.instanceOf(Date),
    end: import_prop_types14.default.instanceOf(Date)
  })
};
var DateRangePicker_default = (0, import_styled_components17.default)(DateRangePicker)``;

// src/DateRangeDropdown.js
var import_react23 = __toESM(require("react"));
var import_prop_types16 = __toESM(require("prop-types"));
var import_styled_components19 = __toESM(require("styled-components"));
var import_lodash3 = __toESM(require("lodash.isequal"));

// src/Dropdown.js
var import_react22 = __toESM(require("react"));
var import_prop_types15 = __toESM(require("prop-types"));
var import_styled_components18 = __toESM(require("styled-components"));

// src/hooks/use-click-outside.js
var import_react19 = require("react");
function useClickOutside(refs, onClickOutside) {
  (0, import_react19.useEffect)(() => {
    if (!refs || refs.length === 0) {
      return;
    }
    const handler = (event) => {
      const { target } = event;
      const inside = refs.filter(({ current }) => current).some(({ current }) => target === current || current.contains(target));
      if (!inside && typeof onClickOutside === "function") {
        onClickOutside(event);
      }
    };
    document.addEventListener("click", handler, true);
    return () => {
      document.removeEventListener("click", handler, true);
    };
  }, [refs, onClickOutside]);
}

// src/hooks/use-is-mounted.js
var import_react20 = require("react");
var useIsMounted = () => {
  const mounted = (0, import_react20.useRef)(false);
  (0, import_react20.useEffect)(() => {
    mounted.current = true;
  }, []);
  return mounted.current;
};
var use_is_mounted_default = useIsMounted;

// src/hooks/use-escape.js
var import_react21 = require("react");
function useEscape(handler, capture = false) {
  (0, import_react21.useEffect)(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape" && typeof handler === "function") {
        handler(event);
      }
    };
    document.addEventListener("keydown", onKeyDown, capture);
    return () => {
      document.removeEventListener("keydown", onKeyDown, capture);
    };
  }, [capture, handler]);
}

// src/Dropdown.js
var Target = import_styled_components18.default.div.attrs({ role: "button" })`
  cursor: pointer;
`;
var Attachment = import_styled_components18.default.div`
  background: var(--white);
  border-radius: 6px;
  box-shadow: var(--dropdown-menu-shadow);
  color: var(--dropdown-text);
  margin-top: 6px;
  padding: 8px;
  position: fixed;
  z-index: var(--z-index-300);
`;
var Dropdown = (0, import_react22.forwardRef)(
  ({
    attachment,
    children,
    disabled = false,
    closeOnEscape = true,
    placement = "right",
    open = false,
    onShow = () => {
    },
    onHide = () => {
    },
    ...unhandledProps
  }, ref) => {
    const isMounted = use_is_mounted_default();
    const [visible, setIsVisible] = (0, import_react22.useState)(!disabled && open);
    const toggleVisible = () => {
      if (!disabled) {
        setIsVisible((current) => !current);
      }
    };
    const [refs, position, reposition] = usePosition({ placement, visible });
    (0, import_react22.useImperativeHandle)(ref, () => ({
      reposition
    }));
    useClickOutside([refs.target, refs.attachment], visible && toggleVisible);
    useEscape(visible && closeOnEscape && toggleVisible);
    (0, import_react22.useEffect)(() => {
      setIsVisible(!disabled && open);
    }, [disabled, open]);
    (0, import_react22.useEffect)(() => {
      if (!isMounted) {
        return;
      }
      if (visible) {
        onShow();
      } else {
        onHide();
      }
    }, [visible]);
    const render = (element) => {
      if (typeof element === "function") {
        return element({ onClose: toggleVisible, visible });
      }
      const child = import_react22.Children.only(element);
      return (0, import_react22.cloneElement)(child, { onClose: toggleVisible });
    };
    return /* @__PURE__ */ import_react22.default.createElement(import_react22.default.Fragment, null, /* @__PURE__ */ import_react22.default.createElement(Target, {
      ...unhandledProps,
      "aria-disabled": disabled,
      ref: refs.target,
      onClick: toggleVisible
    }, render(children)), /* @__PURE__ */ import_react22.default.createElement(Portal_default, null, visible ? /* @__PURE__ */ import_react22.default.createElement(Attachment, {
      ref: refs.attachment,
      style: position
    }, render(attachment)) : null));
  }
);
Dropdown.propTypes = {
  attachment: import_prop_types15.default.oneOfType([import_prop_types15.default.func, import_prop_types15.default.node]),
  children: import_prop_types15.default.oneOfType([import_prop_types15.default.func, import_prop_types15.default.node]),
  closeOnEscape: import_prop_types15.default.bool,
  disabled: import_prop_types15.default.bool,
  placement: import_prop_types15.default.oneOf(["left", "right"]),
  open: import_prop_types15.default.bool,
  onShow: import_prop_types15.default.func,
  onHide: import_prop_types15.default.func
};
var Dropdown_default = (0, import_styled_components18.default)(Dropdown)``;
var List = import_styled_components18.default.ul.attrs({ role: "listbox" })`
  list-style: none;
`;
var LabelWrapper = import_styled_components18.default.div`
  display: flex;
  align-items: center;
`;
var Item2 = import_styled_components18.default.li.attrs({ role: "option" })`
  /* Link style overrides */
  --link-active-color: inherit;
  --link-color: inherit;
  --link-font-weight: inherit;
  --link-text-decoration: none;

  border-radius: 6px;
  color: inherit;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-size: var(--regular);
  font-weight: var(--normal);
  gap: 4px;
  justify-content: space-around;
  padding: 8px 12px;
  white-space: nowrap;

  :hover {
    background: var(--dropdown-option-bg);
    color: inherit;
  }

  ${({ isSelected }) => isSelected && `
      color: var(--dropdown-option-selected);
      font-weight: var(--bold);
    `}

  &[disabled] {
    pointer-events: none;
    color: var(--dirty-water);

    ${LabelWrapper} > ${Icon_default} {
      color: var(--dirty-water);
    }
  }

  ${Icon_default} {
    font-size: inherit;
    margin-right: 8px;
    width: 20px;
    color: var(--dropdown-icon);
  }
`;
function BaseMenuList({ options, onClose, ...unhandledProps }) {
  return /* @__PURE__ */ import_react22.default.createElement(List, {
    ...unhandledProps,
    onClick: onClose
  }, options.map(({ icon, isSelected, label, description, ...rest }) => /* @__PURE__ */ import_react22.default.createElement(Item2, {
    key: label,
    "aria-selected": isSelected,
    isSelected,
    ...rest
  }, /* @__PURE__ */ import_react22.default.createElement(LabelWrapper, null, icon && /* @__PURE__ */ import_react22.default.createElement(Icon_default, {
    icon
  }), label), description)));
}
BaseMenuList.propTypes = {
  options: import_prop_types15.default.arrayOf(
    import_prop_types15.default.shape({
      icon: import_prop_types15.default.string,
      isSelected: import_prop_types15.default.bool,
      label: import_prop_types15.default.node
    })
  ),
  onClose: import_prop_types15.default.func
};
var MenuList = (0, import_styled_components18.default)(BaseMenuList)``;
var Wrapper9 = import_styled_components18.default.div`
  align-items: center;
  color: var(--dropdown-text);
  display: flex;
  font-weight: var(--semi-bold);

  > ${Icon_default} {
    margin-right: 8px;
  }
`;
function BaseSortDropdown({ onChange, options, value, ...props }) {
  const items = (0, import_react22.useMemo)(() => {
    return options.map((option) => ({
      ...option,
      isSelected: value === option.value,
      onClick: (event) => onChange(option, event)
    }));
  }, [onChange, options, value]);
  const label = (0, import_react22.useMemo)(() => {
    const selected = options.find((option) => value === option.value);
    return (selected == null ? void 0 : selected.label) || "Sort by...";
  }, [options, value]);
  return /* @__PURE__ */ import_react22.default.createElement(Dropdown, {
    ...props,
    attachment: /* @__PURE__ */ import_react22.default.createElement(MenuList, {
      options: items
    })
  }, /* @__PURE__ */ import_react22.default.createElement(Wrapper9, null, /* @__PURE__ */ import_react22.default.createElement(Icon_default, {
    icon: "sort"
  }), label));
}
BaseSortDropdown.propTypes = {
  onChange: import_prop_types15.default.func,
  options: import_prop_types15.default.arrayOf(
    import_prop_types15.default.shape({
      label: import_prop_types15.default.string,
      value: import_prop_types15.default.string
    })
  ),
  value: import_prop_types15.default.string
};
var SortDropdown = (0, import_styled_components18.default)(BaseSortDropdown)``;

// src/DateRangeDropdown.js
var Wrapper10 = import_styled_components19.default.div``;
var Menu = import_styled_components19.default.div`
  padding: 18px 24px;

  ${ButtonGroup} {
    margin-top: 18px;
  }
`;
var Trigger = (0, import_styled_components19.default)(Button_default)`
  align-items: center;
  border: 1px solid var(--dropdown-inactive);
  color: var(--dropdown-text);
  display: flex;
  justify-content: space-between;
  text-transform: none;
  transition: ${easing("border")};

  :hover:not([disabled]) {
    border: 1px solid var(--dropdown-active);
    box-shadow: none;
  }

  ${Icon_default} {
    color: var(--dropdown-icon);
    font-size: var(--xx-small);
    margin-left: 16px;
    margin-right: 0;
  }

  ${({ active }) => active && `
      border: 1px solid var(--dropdown-active);
    `}
`;
var DateRangeLabel = import_styled_components19.default.span`
  font-weight: var(--normal);
  line-height: 1;
`;
var formatDateRangeLabel = ({ start, end }) => start && end ? `${format(start, DATE_FORMAT)} - ${format(end, DATE_FORMAT)}` : "Select date range...";
var DateRangeMenu = ({
  error,
  onApply,
  onChange,
  onClose,
  value: initial = {},
  ...unhandledProps
}) => {
  const [value, setValue] = (0, import_react23.useState)(initial);
  const handleApply = () => {
    onApply == null ? void 0 : onApply(value);
    onClose();
  };
  const handleChange = (next) => {
    setValue(next);
    onChange == null ? void 0 : onChange(next);
  };
  const { start, end } = value;
  const disabled = error || !(start && end) || (0, import_lodash3.default)(initial, value);
  return /* @__PURE__ */ import_react23.default.createElement(Menu, null, /* @__PURE__ */ import_react23.default.createElement(DateRangePicker_default, {
    ...unhandledProps,
    onChange: handleChange,
    value
  }), /* @__PURE__ */ import_react23.default.createElement(ButtonGroup, {
    right: true
  }, /* @__PURE__ */ import_react23.default.createElement(Button_default, {
    disabled,
    kind: "positive",
    onClick: handleApply
  }, "Apply"), /* @__PURE__ */ import_react23.default.createElement(Button_default, {
    kind: "secondary",
    onClick: onClose
  }, "Cancel")));
};
DateRangeMenu.propTypes = {
  ...DateRangePicker_default.propTypes,
  error: import_prop_types16.default.bool,
  onApply: import_prop_types16.default.func,
  onClose: import_prop_types16.default.func
};
function DateRangeDropdown({
  className,
  disabled = false,
  error,
  onApply,
  options,
  value: initial = {},
  ...unhandledProps
}) {
  const [value, setValue] = useDateRange(options, initial);
  const handleApply = (next) => {
    setValue(next);
    onApply == null ? void 0 : onApply(next);
  };
  const attachment = ({ onClose }) => /* @__PURE__ */ import_react23.default.createElement(DateRangeMenu, {
    ...unhandledProps,
    disabled,
    error,
    onApply: handleApply,
    onClose,
    options,
    value
  });
  return /* @__PURE__ */ import_react23.default.createElement(Wrapper10, {
    className
  }, /* @__PURE__ */ import_react23.default.createElement(Dropdown_default, {
    attachment,
    closeOnEscape: false,
    disabled,
    placement: "left"
  }, ({ visible }) => /* @__PURE__ */ import_react23.default.createElement(Trigger, {
    "aria-label": "Open date range picker",
    active: visible,
    disabled,
    kind: "secondary"
  }, /* @__PURE__ */ import_react23.default.createElement(DateRangeLabel, null, formatDateRangeLabel(value)), /* @__PURE__ */ import_react23.default.createElement(Icon_default, {
    icon: `chevron-${visible ? "up" : "down"}`
  }))));
}
DateRangeDropdown.propTypes = {
  ...DateRangePicker_default.propTypes,
  disabled: import_prop_types16.default.bool,
  error: import_prop_types16.default.bool,
  onApply: import_prop_types16.default.func,
  options: import_prop_types16.default.arrayOf(
    import_prop_types16.default.shape({
      label: import_prop_types16.default.string,
      value: import_prop_types16.default.oneOfType([import_prop_types16.default.string, import_prop_types16.default.number])
    })
  )
};
var DateRangeDropdown_default = (0, import_styled_components19.default)(DateRangeDropdown)``;

// src/DescriptiveList.js
var import_styled_components20 = __toESM(require("styled-components"));
var Term = import_styled_components20.default.dt`
  float: left;
  font-weight: var(--bold);
  margin-right: 6px;
`;
var Definition = import_styled_components20.default.dd`
  align-items: center;
  display: flex;
`;
var DescriptiveList = import_styled_components20.default.dl`
  color: var(--descriptive-list-text);
  font-size: var(--regular);

  ${Definition}:not(:last-of-type),
  ${Term}:not(:last-of-type) {
    margin-bottom: 12px;
  }
`;

// src/EmptyState.js
var import_react24 = __toESM(require("react"));
var import_styled_components23 = __toESM(require("styled-components"));
var import_prop_types17 = __toESM(require("prop-types"));

// src/Heading.js
var import_styled_components21 = __toESM(require("styled-components"));
var H1 = import_styled_components21.default.h1`
  color: var(--heading-primary);
  font-weight: var(--bold);
  font-size: var(--xx-large);
  line-height: 1.5em;
  letter-spacing: -0.0025em;
`;
var H2 = import_styled_components21.default.h2`
  color: var(--heading-primary);
  font-weight: var(--normal);
  font-size: var(--x-large);
  line-height: 1.5em;
  letter-spacing: 0;
`;
var H3 = import_styled_components21.default.h3`
  color: var(--heading-primary);
  font-weight: var(--semi-bold);
  font-size: var(--large);
  line-height: 1.5em;
  letter-spacing: 0;
`;
var H4 = import_styled_components21.default.h4`
  color: var(--heading-primary);
  font-weight: var(--semi-bold);
  font-size: 17px;
  line-height: 1.5em;
  letter-spacing: -0.0025em;
`;
var H5 = import_styled_components21.default.h5`
  color: var(--heading-primary);
  font-weight: var(--semi-bold);
  font-size: var(--small);
  line-height: 1.8em;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;

// src/Text.js
var import_styled_components22 = __toESM(require("styled-components"));
var Text_default = import_styled_components22.default.p`
  --text-primary: var(--oh-hi-dark);
  --text-secondary: var(--sharkbait-ooh-la-la);
  --text-tertiary: var(--dirty-water);

  margin: 0;
  color: var(--text-primary);
  line-height: 1.5em;
  ${(props) => props.secondary && "color: var(--text-secondary)"};
  ${(props) => props.bold && "font-weight: var(--bold)"};
`;

// src/EmptyState.js
var EmptyStateWrapper = import_styled_components23.default.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;
var ContentWrapper = import_styled_components23.default.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 16px;
  justify-content: center;
  max-width: 70%;
  text-align: center;
`;
var Headline = (0, import_styled_components23.default)(H3)`
  color: var(--pleather);
  margin-bottom: -5px;
`;
var Content2 = (0, import_styled_components23.default)(Text_default)`
  color: var(--pleather);
`;
var EmptyState = ({ action, children, headline, image }) => /* @__PURE__ */ import_react24.default.createElement(EmptyStateWrapper, null, /* @__PURE__ */ import_react24.default.createElement(ContentWrapper, null, image, headline && /* @__PURE__ */ import_react24.default.createElement(Headline, null, headline), /* @__PURE__ */ import_react24.default.createElement(Content2, null, children), action));
EmptyState.propTypes = {
  action: import_prop_types17.default.node,
  children: import_prop_types17.default.string.isRequired,
  headline: import_prop_types17.default.string,
  image: import_prop_types17.default.node.isRequired
};
var EmptyState_default = (0, import_styled_components23.default)(EmptyState)``;

// src/ExpandableText.js
var import_react25 = __toESM(require("react"));
var import_prop_types18 = __toESM(require("prop-types"));
var import_styled_components24 = __toESM(require("styled-components"));
var Wrapper11 = import_styled_components24.default.div`
  display: flex;
  flex-direction: column;
`;
var Overflowable = import_styled_components24.default.span`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ lines }) => lines};
  display: -webkit-box;
  overflow: hidden;
`;
var Expand = import_styled_components24.default.span`
  align-self: flex-start;
  color: var(--primary);
  cursor: pointer;
  font-weight: var(--bold);

  :hover,
  :focus {
    color: var(--primary-dark);
  }

  :focus {
    outline: 1px solid var(--primary);
    outline-offset: 1px;
  }
`;
function ExpandableText({ children, className, lines = 1 }) {
  const ref = (0, import_react25.useRef)();
  const [expandable, setExpandable] = (0, import_react25.useState)(false);
  const [expanded, setExpanded] = (0, import_react25.useState)();
  (0, import_react25.useEffect)(() => {
    const { current: $text } = ref;
    const truncated = $text.scrollHeight > $text.clientHeight;
    setExpandable(truncated);
    setExpanded(!truncated);
  }, [children]);
  const toggle = () => {
    setExpanded((current) => !current);
  };
  return /* @__PURE__ */ import_react25.default.createElement(Wrapper11, {
    "aria-expanded": expanded,
    "aria-label": "Expandable text",
    className
  }, expanded && children, !expanded && /* @__PURE__ */ import_react25.default.createElement(Overflowable, {
    lines,
    ref
  }, children), expandable && /* @__PURE__ */ import_react25.default.createElement(Expand, {
    onClick: toggle,
    role: "button"
  }, "Show ", expanded ? "less" : "more"));
}
ExpandableText.propTypes = {
  children: import_prop_types18.default.node,
  className: import_prop_types18.default.string,
  lines: import_prop_types18.default.number
};
var ExpandableText_default = (0, import_styled_components24.default)(ExpandableText)``;

// src/Fullscreen.js
var import_styled_components25 = __toESM(require("styled-components"));
var Fullscreen = import_styled_components25.default.div`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 10000;
`;
var Fullscreen_default = Fullscreen;

// src/HorizontalScroll.js
var import_react26 = __toESM(require("react"));
var import_prop_types19 = __toESM(require("prop-types"));
var import_styled_components26 = __toESM(require("styled-components"));
var import_react_intersection_observer = require("react-intersection-observer");
var Wrapper12 = import_styled_components26.default.div`
  position: relative;
  width: 100%;

  &&::before,
  &&::after {
    align-items: center;
    background: none;
    border: none;
    bottom: 10px;
    content: '';
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 67px;
    z-index: 1;
  }

  &&::before {
    left: 0;
    background: linear-gradient(90deg, var(--white), transparent);
    ${({ $showLeftFade }) => $showLeftFade && "opacity: 1;"}
  }

  &&::after {
    right: 0;
    background: linear-gradient(270deg, var(--white), transparent);
    ${({ $showRightFade }) => $showRightFade && "opacity: 1;"}
  }
`;
var ScrollContent = import_styled_components26.default.div`
  display: flex;
  overflow: auto;
  position: relative;
  width: 100%;
`;
var EndCap = import_styled_components26.default.div`
  background-color: transparent;
  min-width: 1px;
`;
var LeftEndCap = (0, import_styled_components26.default)(EndCap)``;
var RightEndCap = (0, import_styled_components26.default)(EndCap)``;
var HorizontalScroll = ({ children }) => {
  const [leftRef, leftInView] = (0, import_react_intersection_observer.useInView)();
  const [rightRef, rightInView] = (0, import_react_intersection_observer.useInView)();
  return /* @__PURE__ */ import_react26.default.createElement(Wrapper12, {
    $showRightFade: !rightInView,
    $showLeftFade: !leftInView
  }, /* @__PURE__ */ import_react26.default.createElement(ScrollContent, null, /* @__PURE__ */ import_react26.default.createElement(LeftEndCap, {
    ref: leftRef
  }), children, /* @__PURE__ */ import_react26.default.createElement(RightEndCap, {
    ref: rightRef
  })));
};
HorizontalScroll.propTypes = {
  children: import_prop_types19.default.node
};
var HorizontalScroll_default = (0, import_styled_components26.default)(HorizontalScroll)``;

// src/ListRow.js
var import_react27 = __toESM(require("react"));
var import_prop_types20 = __toESM(require("prop-types"));
var import_styled_components27 = __toESM(require("styled-components"));
var import_react_dropdown_menu = require("@radix-ui/react-dropdown-menu");
var truncate = `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
var Description2 = import_styled_components27.default.span`
  ${truncate}

  color: var(--sharkbait-ooh-la-la);
  font-size: var(--x-small);
  font-weight: var(--normal);
  grid-area: description;
  margin-top: 4px;
`;
var MainText = import_styled_components27.default.span`
  ${truncate}

  color: var(--pleather);
  font-weight: var(--normal);
  grid-area: main;

  ${({ $description }) => $description && `
      font-weight: var(--bold);
    `}
`;
var Wrapper13 = import_styled_components27.default.div`
  /* Link style overrides */
  --link-active-color: inherit;
  --link-color: inherit;
  --link-focus-outline-color: transparent;
  --link-font-weight: inherit;
  --link-text-decoration: none;

  border-radius: 6px;
  color: var(--pleather);
  cursor: pointer;
  display: block;
  font-size: var(--regular);
  text-decoration: none;
  padding: 10px 16px;
  width: 100%;

  &:focus,
  &:focus-visible {
    background-color: var(--noreaster);
    color: var(--oh-hi-dark);
    outline: none;

    ${MainText} {
      color: var(--oh-hi-dark);
    }

    ${Icon_default} {
      color: var(--pleather);
    }
  }

  &[disabled] {
    color: var(--dark-resting);
    cursor: not-allowed;

    &:hover {
      background-color: inherit;
    }

    ${MainText},
    ${Description2} {
      color: var(--dark-resting);
    }

    ${Icon_default} {
      color: var(--myst);
    }
  }
`;
var ContentWrapper2 = import_styled_components27.default.div`
  align-items: center;
  display: grid;
  grid-template:
    'prefix main suffix caret'
    '. description . .'
    / min-content 1fr;
  width: 100%;
`;
var IconWrapper = import_styled_components27.default.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${Icon_default} {
    color: var(--sharkbait-ooh-la-la);
    width: 20px;
  }
`;
var PrefixWrapper = (0, import_styled_components27.default)(IconWrapper)`
  grid-area: prefix;
  padding-right: 8px;
`;
var SuffixWrapper = (0, import_styled_components27.default)(IconWrapper)`
  grid-area: suffix;
  padding-left: 8px;
`;
var CaretWrapper = (0, import_styled_components27.default)(IconWrapper)`
  grid-area: caret;

  ${Icon_default} {
    height: 16px;
    width: 16px;
  }
`;
var BaseContent = ({
  children,
  description,
  prefix: prefix2,
  suffix,
  caret,
  ...unhandledProps
}) => /* @__PURE__ */ import_react27.default.createElement(ContentWrapper2, {
  ...unhandledProps
}, prefix2 && /* @__PURE__ */ import_react27.default.createElement(PrefixWrapper, null, prefix2), /* @__PURE__ */ import_react27.default.createElement(MainText, {
  $description: !!description
}, children), suffix && /* @__PURE__ */ import_react27.default.createElement(SuffixWrapper, null, suffix), caret && /* @__PURE__ */ import_react27.default.createElement(CaretWrapper, null, /* @__PURE__ */ import_react27.default.createElement(Icon_default, {
  icon: "angle-right"
})), description && /* @__PURE__ */ import_react27.default.createElement(Description2, null, description));
BaseContent.propTypes = {
  children: import_prop_types20.default.node,
  description: import_prop_types20.default.string,
  prefix: import_prop_types20.default.node,
  suffix: import_prop_types20.default.node,
  caret: import_prop_types20.default.bool
};
var Content3 = (0, import_styled_components27.default)(BaseContent)``;
var BaseListRow = ({
  children,
  description,
  disabled,
  prefix: prefix2,
  onClick,
  suffix,
  caret,
  ...unhandledProps
}) => /* @__PURE__ */ import_react27.default.createElement(import_react_dropdown_menu.Item, {
  asChild: true,
  disabled,
  onSelect: onClick
}, /* @__PURE__ */ import_react27.default.createElement(Wrapper13, {
  disabled,
  ...unhandledProps
}, /* @__PURE__ */ import_react27.default.createElement(Content3, {
  description,
  prefix: prefix2,
  suffix,
  caret
}, children)));
BaseListRow.propTypes = {
  caret: import_prop_types20.default.bool,
  children: import_prop_types20.default.node,
  description: import_prop_types20.default.string,
  disabled: import_prop_types20.default.bool,
  onClick: import_prop_types20.default.func,
  prefix: import_prop_types20.default.node,
  suffix: import_prop_types20.default.node
};
var ListRow = (0, import_styled_components27.default)(BaseListRow)``;
var ListRow_default = ListRow;

// src/Logo.js
var import_react28 = __toESM(require("react"));
var import_prop_types21 = __toESM(require("prop-types"));
var import_styled_components28 = __toESM(require("styled-components"));
var Wrapper14 = import_styled_components28.default.span`
  align-items: center;
  color: var(--primary);
  display: flex;
  font-size: var(--x-large);
  justify-content: center;

  svg {
    height: 1em;
    width: 1em;

    path {
      fill: currentColor;
    }
  }
`;
var Logo = ({ className }) => /* @__PURE__ */ import_react28.default.createElement(Wrapper14, {
  className
}, /* @__PURE__ */ import_react28.default.createElement("svg", {
  viewBox: "0 0 1600 2000",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ import_react28.default.createElement("path", {
  d: "M695.6 1083.4l555.9 870.5c14.1 21.2 35.3 31 60.7 31h206c39.5 0 70.5-31 70.5-70.5V70.4c0-66.3-83.2-95.9-127-43.7L695.6 998.8c-16.9 22.6-16.9 57.8 0 84.6zM70.6 1985h366.8c39.5 0 70.5-31 70.5-70.5V1446c0-66.3-83.2-95.9-127-43.7L14.1 1870.7c-35.2 48 0 114.3 56.5 114.3z"
})));
Logo.propTypes = {
  className: import_prop_types21.default.string
};
var Logo_default = (0, import_styled_components28.default)(Logo)``;

// src/Menu.js
var import_styled_components29 = __toESM(require("styled-components"));
var import_react_dropdown_menu2 = require("@radix-ui/react-dropdown-menu");
var MenuPortalOverride = import_styled_components29.createGlobalStyle`
  div[data-radix-portal] {
    z-index: 10010 !important
  }
`;
var MenuContent = (0, import_styled_components29.default)(import_react_dropdown_menu2.Content)`
  background-color: var(--white);
  border-radius: 6px;
  box-shadow: var(--level-1);
`;
var MenuHeading = (0, import_styled_components29.default)(import_react_dropdown_menu2.Label)`
  color: var(--pleather);
  cursor: default;
  font-weight: var(--bold);
  overflow: hidden;
  padding: 10px 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
var MenuSection = (0, import_styled_components29.default)(import_react_dropdown_menu2.Group)`
  padding: 8px 4px;
`;
var MenuSeparator = (0, import_styled_components29.default)(import_react_dropdown_menu2.Separator)`
  border-bottom: 0;
  border-top: 1px solid var(--ui-vertical-separator);
`;
var MenuTrigger = (0, import_styled_components29.default)(import_react_dropdown_menu2.Trigger)`
  &:focus-visible {
    outline-width: 0px;
  }
`;
var MenuItem = (0, import_styled_components29.default)(import_react_dropdown_menu2.Item)``;
var MenuCheckboxItem = (0, import_styled_components29.default)(import_react_dropdown_menu2.CheckboxItem)``;
var Menu2 = (0, import_styled_components29.default)(import_react_dropdown_menu2.Root)``;

// src/Modal.js
var import_react29 = __toESM(require("react"));
var import_prop_types22 = __toESM(require("prop-types"));
var import_styled_components30 = __toESM(require("styled-components"));
var P = import_styled_components30.default.p`
  font-size: var(--regular);
`;
var Heading = import_styled_components30.default.h2`
  color: var(--heading-primary);
  font-size: var(--large);
  font-weight: var(--semi-bold);
  line-height: 1.5;
  margin: -8px 0 12px;
  padding-right: 16px;
  word-break: break-word;
`;
var Description3 = import_styled_components30.default.span`
  display: inline-block;
  font-size: var(--regular);
  font-weight: var(--normal);
  line-height: 1.5;
  margin: 0 0 1em;
`;
var Overflow = import_styled_components30.default.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 8px;
`;
var ModalFooter = import_styled_components30.default.div`
  margin-top: 24px;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;
var CloseButton = (0, import_styled_components30.default)(IconButton).attrs(() => ({ icon: "times" }))`
  position: absolute;
  right: 26px;
  top: 26px;
`;
var Overlay2 = import_styled_components30.default.div.attrs(() => ({
  role: "button",
  "aria-label": "overlay"
}))`
  background: var(--overlay);
  height: 100%;
  opacity: 0.8;
  position: absolute;
  width: 100%;
  z-index: 10001;
`;
var Dialog = import_styled_components30.default.div.attrs(() => ({ role: "dialog" }))`
  background: var(--white);
  border-radius: 12px;
  box-shadow: var(--level-4);
  color: var(--text-primary);
  display: flex;
  flex-direction: column;
  max-height: 80%;
  min-height: 160px;
  padding: 32px;
  position: relative;
  z-index: 10002;

  width: ${({ size }) => {
  switch (size) {
    case "xl":
      return "800px";
    case "l":
      return "600px";
    case "m":
      return "500px";
    default:
      return "400px";
  }
}};

  ${({ size }) => size === "full" && `
      border-radius: 0;
      height: 100%;
      max-height: 100%;
      width: 100%;

      ${Heading} {
        font-size: var(--x-large);
      }

      ${CloseButton} {
        font-size: var(--large);
      }
  `}
`;
var Modal = ({
  children,
  className,
  closeOnEscape = true,
  onClose,
  size = "s",
  timeout = 200,
  visible = true
}) => {
  (0, import_react29.useEffect)(() => {
    if (!visible) {
      return () => {
      };
    }
    const {
      style: { overflow }
    } = document.body;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = overflow;
    };
  }, [visible]);
  useEscape(visible && closeOnEscape && onClose);
  return /* @__PURE__ */ import_react29.default.createElement(Portal_default, {
    timeout
  }, /* @__PURE__ */ import_react29.default.createElement(Fade_default, {
    visible,
    timeout
  }, /* @__PURE__ */ import_react29.default.createElement(Fullscreen_default, null, /* @__PURE__ */ import_react29.default.createElement(Overlay2, {
    onClick: onClose
  }), /* @__PURE__ */ import_react29.default.createElement(Dialog, {
    className,
    size
  }, onClose && /* @__PURE__ */ import_react29.default.createElement(CloseButton, {
    onClick: onClose,
    label: "Dismiss dialog",
    title: "Dismiss dialog"
  }), children))));
};
Modal.propTypes = {
  children: import_prop_types22.default.node,
  className: import_prop_types22.default.string,
  closeOnEscape: import_prop_types22.default.bool,
  onClose: import_prop_types22.default.func,
  size: import_prop_types22.default.oneOf(["s", "m", "l", "xl", "full"]),
  timeout: import_prop_types22.default.number,
  visible: import_prop_types22.default.bool
};
var Modal_default = (0, import_styled_components30.default)(Modal)``;

// src/MoreMenu.js
var import_react30 = __toESM(require("react"));
var import_prop_types23 = __toESM(require("prop-types"));
var import_styled_components31 = __toESM(require("styled-components"));
var Opener = (0, import_styled_components31.default)(SquareButton)`
  ${({ small }) => small && `
    width: 32px;
    height: 24px;
  `}

  &[aria-expanded="true"] {
    border: 1px solid var(--primary);
    background-color: var(--luna);

    ${Icon_default} {
      color: var(--primary);
    }
  }
`;
var OpenButton = (0, import_react30.forwardRef)(
  ({ icon, small, ...unhandledProps }, forwardedRef) => /* @__PURE__ */ import_react30.default.createElement(Opener, {
    "aria-label": "Open more menu",
    icon,
    ref: forwardedRef,
    kind: "secondary",
    small,
    ...unhandledProps
  })
);
OpenButton.propTypes = {
  icon: import_prop_types23.default.string,
  small: import_prop_types23.default.bool
};
var MoreMenu = ({
  icon = "ellipsis-h",
  align = "end",
  children,
  side = "bottom",
  small = false
}) => /* @__PURE__ */ import_react30.default.createElement(Menu2, null, /* @__PURE__ */ import_react30.default.createElement(MenuTrigger, {
  asChild: true
}, /* @__PURE__ */ import_react30.default.createElement(OpenButton, {
  icon,
  small
})), /* @__PURE__ */ import_react30.default.createElement(MenuContent, {
  align,
  side,
  sideOffset: 12
}, children));
MoreMenu.propTypes = {
  align: import_prop_types23.default.oneOf(["start", "center", "end"]),
  children: import_prop_types23.default.node,
  icon: import_prop_types23.default.string,
  side: import_prop_types23.default.oneOf(["top", "right", "bottom", "left"]),
  small: import_prop_types23.default.bool
};
var MoreMenu_default = (0, import_styled_components31.default)(MoreMenu)``;

// src/Notice.js
var import_react31 = __toESM(require("react"));
var import_prop_types24 = __toESM(require("prop-types"));
var import_styled_components32 = __toESM(require("styled-components"));
var Header = import_styled_components32.default.div`
  font-weight: var(--bold);
  margin-bottom: 4px;
`;
var Body3 = import_styled_components32.default.div`
  flex-grow: 1;
  line-height: var(--medium-large);
`;
var Wrapper15 = import_styled_components32.default.div`
  align-items: flex-start;
  background-color: var(--primary-x-light);
  border-color: var(--primary-light);
  border-radius: 6px;
  border-style: solid;
  border-width: 2px;
  color: var(--banner-text);
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;

  > ${Icon_default} {
    color: var(--primary);
    height: var(--medium-large);
    margin-right: 8px;
    width: var(--medium-large);
  }

  > ${IconButton} {
    height: var(--medium-large);
    margin-left: 8px;
    width: var(--medium-large);
  }

  ${UILink} {
    color: var(--pleather);
    font-weight: var(--bold);
    text-decoration: underline;
  }
`;
function BaseNotice({ children, className, header, icon, onDismiss }) {
  return /* @__PURE__ */ import_react31.default.createElement(Wrapper15, {
    className,
    role: "alert"
  }, header && /* @__PURE__ */ import_react31.default.createElement(Icon_default, {
    icon: icon || "info-circle",
    role: "img"
  }), /* @__PURE__ */ import_react31.default.createElement(Body3, null, header && /* @__PURE__ */ import_react31.default.createElement(Header, null, header), children), onDismiss && /* @__PURE__ */ import_react31.default.createElement(IconButton, {
    icon: "times",
    label: "Dismiss notice",
    onClick: onDismiss
  }));
}
BaseNotice.propTypes = {
  children: import_prop_types24.default.node,
  className: import_prop_types24.default.string,
  header: import_prop_types24.default.string,
  icon: import_prop_types24.default.string,
  onDismiss: import_prop_types24.default.func
};
var Notice = (0, import_styled_components32.default)(BaseNotice)``;
var Notice_default = Notice;
var NegativeNotice = (0, import_styled_components32.default)(Notice)`
  background-color: var(--danger-x-light);
  border-color: var(--danger-light);

  > ${Icon_default} {
    color: var(--danger-dark);
  }
`;
var WarningNotice = (0, import_styled_components32.default)(Notice)`
  background-color: var(--warn-light);
  border-color: var(--warn);

  > ${Icon_default} {
    color: var(--warn-dark);
  }
`;
var SuccessNotice = (0, import_styled_components32.default)(Notice)`
  background-color: var(--ice-ice-baby);
  border-color: var(--cutecumber);

  > ${Icon_default} {
    color: var(--bulbasaur);
  }
`;

// src/Page.js
var import_react34 = __toESM(require("react"));
var import_styled_components35 = __toESM(require("styled-components"));

// src/StatusLabel.js
var import_react33 = __toESM(require("react"));
var import_prop_types26 = __toESM(require("prop-types"));
var import_styled_components34 = __toESM(require("styled-components"));

// src/Table.js
var import_react32 = __toESM(require("react"));
var import_prop_types25 = __toESM(require("prop-types"));
var import_styled_components33 = __toESM(require("styled-components"));
var Thead = import_styled_components33.default.thead``;
var stickyStyles = import_styled_components33.css`
  border-collapse: separate;
  ${Thead} {
    position: sticky;
    top: 0px;
    background-color: var(--white);
    border-bottom: 1px solid var(--tint-black);
  }
`;
var Table = import_styled_components33.default.table`
  background: var(--white);
  border-collapse: collapse;
  color: var(--table-text);
  width: 100%;

  ${({ sticky }) => sticky && stickyStyles}
`;
var Tbody = import_styled_components33.default.tbody``;
var Tfoot = import_styled_components33.default.tfoot``;
var Tr = import_styled_components33.default.tr``;
var Td = import_styled_components33.default.td`
  border-bottom: 1px solid var(--table-border);
  padding: 8px 24px;
  vertical-align: middle;
  white-space: nowrap;

  @media print {
    white-space: normal;
  }
`;
var ThWrapper = import_styled_components33.default.th`
  border-bottom: 1px solid var(--table-border);
  font-weight: var(--bold);
  padding: 8px 24px;
  vertical-align: middle;
  white-space: nowrap;
  transition: ${easing("background")};

  :hover {
    ${({ sortable }) => sortable && `background: var(--table-header-hover);`}
  }

  ${({ sortable }) => sortable && `
      cursor: pointer
  `};

  ${({ sortable, sorted }) => sortable && sorted && `
      border-bottom: 2px solid var(--table-header-sorted);
    `}

  @media print {
    white-space: normal;
    width: auto;
  }
`;
var ThSortIcon = (0, import_styled_components33.default)(Icon_default)`
  font-size: var(--xx-small);
  margin-left: 8px;
`;
var ThContent = import_styled_components33.default.span`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;
function BaseTh({ children, sorted, ...unhandledProps }) {
  return /* @__PURE__ */ import_react32.default.createElement(ThWrapper, {
    sorted,
    ...unhandledProps
  }, /* @__PURE__ */ import_react32.default.createElement(ThContent, null, children, sorted === "asc" && /* @__PURE__ */ import_react32.default.createElement(ThSortIcon, {
    icon: "arrow-up"
  }), sorted === "desc" && /* @__PURE__ */ import_react32.default.createElement(ThSortIcon, {
    icon: "arrow-down"
  })));
}
BaseTh.propTypes = {
  children: import_prop_types25.default.node,
  sortable: import_prop_types25.default.bool,
  sorted: import_prop_types25.default.oneOf(["asc", "desc"])
};
var Th = (0, import_styled_components33.default)(BaseTh)``;

// src/StatusLabel.js
var ARCHIVED = "ARCHIVED";
var DRAFT = "DRAFT";
var PUBLISHED = "PUBLISHED";
var SCHEDULED = "SCHEDULED";
var INACTIVE2 = "INACTIVE";
var ACTIVE2 = "ACTIVE";
var labels = {
  ARCHIVED: "Archived",
  DRAFT: "Draft",
  PUBLISHED: "Live",
  SCHEDULED: "Scheduled",
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE"
};
function getColorVariables(status, active) {
  switch (status) {
    case SCHEDULED:
      return {
        background: "--color-blue-100",
        color: "--color-blue-600"
      };
    default:
      return active || status === "ACTIVE" ? {
        background: "--status-active-bg",
        color: "--status-active"
      } : {
        background: "--status-inactive-bg",
        color: "--status-inactive"
      };
  }
}
function getStatus(state, published) {
  switch (true) {
    case state === ARCHIVED:
      return ARCHIVED;
    case (state === SCHEDULED && !published):
      return SCHEDULED;
    case state === INACTIVE2:
      return INACTIVE2;
    case state === ACTIVE2:
      return ACTIVE2;
    default:
      return published ? PUBLISHED : DRAFT;
  }
}
function getIcon(status) {
  switch (status) {
    case PUBLISHED:
      return "check-circle";
    case DRAFT:
      return "minus-circle";
    case SCHEDULED:
      return "clock";
    default:
      return "circle";
  }
}
var Label4 = (0, import_styled_components34.default)(Text_default)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
var Wrapper16 = import_styled_components34.default.div`
  align-items: center;
  border-radius: 6px;
  color: var(--status-text);
  display: inline-flex;
  font-size: var(--small);
  font-weight: var(--bold);
  height: 24px;
  justify-content: center;
  max-width: 160px;
  padding: 4px 12px;
  text-transform: capitalize;

  ${Icon_default} {
    margin-right: 6px;
  }

  ${({ active, status }) => {
  const { background, color } = getColorVariables(status, active);
  return `
      background: var(${background});

      ${Icon_default} {
        color: var(${color});
      }
    `;
}}

  /**
   * Table context
   */

  ${Table} & {
    background: none;
    border-radius: 0;
    font-weight: var(--normal);
    padding: 0;
  }
`;
function BaseStatusLabel({
  active = false,
  className,
  icon,
  label,
  status,
  ...unhandledProps
}) {
  return /* @__PURE__ */ import_react33.default.createElement(Wrapper16, {
    "aria-label": label,
    active,
    className,
    status,
    ...unhandledProps
  }, icon && /* @__PURE__ */ import_react33.default.createElement(Icon_default, {
    icon
  }), /* @__PURE__ */ import_react33.default.createElement(Label4, null, label));
}
BaseStatusLabel.propTypes = {
  active: import_prop_types26.default.bool,
  className: import_prop_types26.default.string,
  icon: import_prop_types26.default.string,
  label: import_prop_types26.default.string,
  status: import_prop_types26.default.oneOf([ARCHIVED, DRAFT, PUBLISHED, SCHEDULED])
};
var StatusLabel_default = (0, import_styled_components34.default)(BaseStatusLabel)``;
function BaseContentStatus({ className, published = false, state }) {
  const status = getStatus(state, published);
  const active = status === PUBLISHED;
  const label = labels[status];
  const icon = getIcon(status);
  return /* @__PURE__ */ import_react33.default.createElement(BaseStatusLabel, {
    active,
    status,
    className,
    icon,
    label
  });
}
BaseContentStatus.propTypes = {
  className: import_prop_types26.default.string,
  published: import_prop_types26.default.bool,
  state: import_prop_types26.default.oneOf([ARCHIVED, DRAFT, PUBLISHED, SCHEDULED])
};
var ContentStatus = (0, import_styled_components34.default)(BaseContentStatus)``;

// src/Page.js
var Page_default = import_styled_components35.default.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 870px;
  padding: 0 0 100px 0;
  width: 100%;
`;
var PageHeader = import_styled_components35.default.div.attrs(() => ({
  "data-no-print": true
}))`
  background-color: var(--white);
  border-bottom: 1px solid var(--ui-horizontal-separator);
  padding-left: 60px;
  padding-right: 60px;
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;

  > ${H1} {
    width: 50%;
  }

  ${H1} {
    font-size: var(--x-large);
    font-weight: var(--normal);
    letter-spacing: 0;
    line-height: 1.5em;
  }
`;
var PageTitle = import_styled_components35.default.div`
  align-items: center;
  display: flex;
  position: relative;

  > ${ContentStatus} {
    margin-left: 16px;
  }
`;
var PageActions = import_styled_components35.default.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
var PageReturn = (0, import_styled_components35.default)(Link_default).attrs({
  children: /* @__PURE__ */ import_react34.default.createElement(Icon_default, {
    icon: "chevron-left"
  })
})`
  height: 24px;
  width: 24px;
  position: absolute;
  top: 8px;
  left: -32px;
  color: var(--blurple);
`;
var PageSubheader = import_styled_components35.default.div`
  width: 100%;
  color: var(--sharkbait-ooh-la-la);
`;
var PageDescription = import_styled_components35.default.div`
  justify-content: center;
  align-items: center;
  position: relative;
  max-width: 100%;
`;
var PageBody = import_styled_components35.default.section`
  flex-grow: 1;
  margin: 0 auto;
  max-width: 1240px;
  padding: 16px 60px 0;
  width: 100%;
  gap: 16px;
  display: flex;
  flex-direction: column;
  @media print {
    padding: 5px;
  }

  @media (max-width: 1240px) {
    max-width: 870px;
  }
`;

// src/Panel.js
var import_styled_components36 = __toESM(require("styled-components"));
var Header2 = import_styled_components36.default.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;
var Title = import_styled_components36.default.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
var Actions = import_styled_components36.default.div`
  display: flex;
  gap: 16px;
`;
var Body4 = import_styled_components36.default.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
var Footer = import_styled_components36.default.footer`
  position: relative;
  text-align: center;
`;
var Section = import_styled_components36.default.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
var SectionTitle = import_styled_components36.default.span`
  font-weight: var(--bold);
  color: var(--heading-primary);
  display: flex;
  align-items: center;

  ${StatusLabel_default} {
    margin-left: 8px;
  }
`;
var Panel_default = import_styled_components36.default.div`
  background-color: white;
  border-radius: 6px;
  box-shadow: var(--level-1);
  width: 100%;
  padding: 8px 0;
  overflow: auto;

  > ${Header2}, ${Body4}, ${Footer} {
    padding: 8px 24px;
  }

  > ${Table} {
    border-top: 1px solid var(--tint-black);
  }
`;

// src/Paragraph.js
var import_prop_types27 = __toESM(require("prop-types"));
var import_styled_components37 = __toESM(require("styled-components"));
var Paragraph = import_styled_components37.default.p`
  color: var(--pleather);
  font-size: var(--regular);
  font-weight: ${({ bold }) => bold ? "var(--semi-bold)" : "var(--normal)"};
  letter-spacing: 0;
  line-height: 1.5em;
`;
Paragraph.propTypes = {
  bold: import_prop_types27.default.bool
};
var Paragraph_default = Paragraph;

// src/PrintButton.js
var import_react35 = __toESM(require("react"));
var import_styled_components38 = __toESM(require("styled-components"));
var PrintButton = () => /* @__PURE__ */ import_react35.default.createElement(SquareButton, {
  "aria-label": "Print",
  kind: "secondary",
  icon: "print",
  onClick: () => {
    window.print();
  }
});
var PrintButton_default = (0, import_styled_components38.default)(PrintButton)``;

// src/Progress.js
var import_react36 = __toESM(require("react"));
var import_react_progress = require("@radix-ui/react-progress");
var import_styled_components39 = __toESM(require("styled-components"));
var import_prop_types28 = __toESM(require("prop-types"));
var ProgressBar = (0, import_styled_components39.default)(import_react_progress.Indicator)`
  background: var(--progress-default);
  height: 100%;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  transition: 0.25s ease;
`;
var Bar = (0, import_styled_components39.default)(import_react_progress.Root)`
  height: ${({ $height }) => $height === "regular" && "6px"};
  height: ${({ $height }) => $height === "large" && "8px"};
  min-width: 100px;
  border-radius: 100px;
  overflow: hidden;
  box-shadow: var(--basement);

  &[data-background='light'] {
    background: var(--progress-light);
  }

  &[data-background='dark'] {
    background: var(--progress-dark);
  }

  &[data-value='100'] {
    ${ProgressBar} {
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
    }
  }
`;
Bar.propTypes = {
  $height: import_prop_types28.default.oneOf(["regular", "large"])
};
Bar.defaultProps = {
  $height: "regular"
};
function BaseProgress({
  max = 100,
  value = 0,
  background = "light",
  ...unhandledProps
}) {
  return /* @__PURE__ */ import_react36.default.createElement(Bar, {
    max,
    value,
    "data-background": background,
    ...unhandledProps
  }, /* @__PURE__ */ import_react36.default.createElement(ProgressBar, {
    style: { width: `${value}%` }
  }));
}
BaseProgress.propTypes = {
  background: import_prop_types28.default.oneOf(["dark", "light"]),
  value: import_prop_types28.default.number,
  max: import_prop_types28.default.number,
  $height: import_prop_types28.default.oneOf(["regular", "large"])
};
var Progress = (0, import_styled_components39.default)(BaseProgress)``;
Progress.displayName = "Progress";
var SuccessProgress = (0, import_styled_components39.default)(Progress)`
  > ${ProgressBar} {
    background: var(--progress-success);
  }
`;
SuccessProgress.displayName = "SuccessProgress";
var ErrorProgress = (0, import_styled_components39.default)(Progress)`
  > ${ProgressBar} {
    background: var(--progress-error);
  }
`;
ErrorProgress.displayName = "ErrorProgress";
var TrialProgressBar = (0, import_styled_components39.default)(Progress)`
  > ${ProgressBar} {
    background: ${({ $status }) => $status === "regular" && "var(--blues-cues)"};
    background: ${({ $status }) => $status === "warn" && "var(--warn-dark)"};
    background: ${({ $status }) => $status === "alert" && "var(--danger-dark)"};
  }
`;
TrialProgressBar.propTypes = {
  $status: import_prop_types28.default.oneOf(["regular", "warn", "alert"]),
  $height: import_prop_types28.default.oneOf(["regular", "large"])
};
TrialProgressBar.defaultProps = {
  $status: "regular"
};
TrialProgressBar.displayName = "TrialProgressBar";
var Progress_default = Progress;

// src/Radio.js
var import_react37 = __toESM(require("react"));
var import_styled_components40 = __toESM(require("styled-components"));
var import_react_radio_group_legacy = require("@radix-ui/react-radio-group-legacy");
var import_prop_types29 = __toESM(require("prop-types"));
var StyledItem = (0, import_styled_components40.default)(import_react_radio_group_legacy.Item)`
  all: unset;
  border-radius: 100%;
  border: 2px solid var(--radio);
  height: 12px;
  max-width: 12px;
  min-width: 12px;
  transition: ${easing("background-color", "border-color", "box-shadow")};

  &:hover {
    border-color: var(--radio-hover);
  }

  &:focus {
    background: var(--radio-selected-focus-bg);
    box-shadow: 0 0 0 5px var(--radio-selected-focus-bg);
    outline: none;
  }

  &[data-state='checked'] {
    border: 2px solid var(--radio-checked);
  }

  &:disabled {
    border-color: var(--radio-disabled);
  }
`;
var StyledIndicator = (0, import_styled_components40.default)(import_react_radio_group_legacy.Indicator)`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%;

  &::after {
    content: '';
    background-color: var(--radio-checked);
    border-radius: 100%;
    display: block;
    height: 8px;
    width: 8px;

    @keyframes appear {
      from {
        transform: scale(0);
      }
      to {
        transform: scale(1);
      }
    }

    animation: ${easing("appear")};
  }
`;
var Control2 = import_styled_components40.default.div`
  align-items: center;
  display: flex;
  gap: 0.8em;
  min-height: 40px;
  padding: 12px 24px;
  position: relative;
  user-select: none;

  &:hover {
    background-color: var(--radio-group-hover);
    border-radius: 6px;
  }
`;
var Label5 = import_styled_components40.default.label`
  position: relative;
  color: var(--pleather);
  cursor: pointer;
  font-weight: var(--normal);
`;
var Radio = (0, import_react37.forwardRef)((unhandledProps, ref) => /* @__PURE__ */ import_react37.default.createElement(StyledItem, {
  ...unhandledProps,
  ref
}, /* @__PURE__ */ import_react37.default.createElement(StyledIndicator, null)));
Radio.propTypes = {
  className: import_prop_types29.default.string,
  children: import_prop_types29.default.node,
  label: import_prop_types29.default.string
};
Radio.displayName = "Radio";
var Radio_default = (0, import_styled_components40.default)(Radio)``;
var Group2 = (0, import_styled_components40.default)(import_react_radio_group_legacy.Root)``;
Group2.displayName = "RadioGroup";

// src/Skeleton.js
var import_react38 = __toESM(require("react"));
var import_styled_components41 = __toESM(require("styled-components"));
var import_prop_types30 = __toESM(require("prop-types"));
var movingGradientAnimation = import_styled_components41.keyframes`
  0% { background-position: -250px 0; }
  100% { background-position: 250px 0; }
`;
var Skeleton = import_styled_components41.default.div`
  height: ${({ height = 32 }) => Number.isInteger(height) ? `${height}px` : height};
  width: ${({ width = 48 }) => Number.isInteger(width) ? `${width}px` : width};
  background: var(--skeleton-gradient);
  background-size: 500px 100px;
  animation: ${movingGradientAnimation};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  border-radius: 6px;
`;
Skeleton.propTypes = {
  width: import_prop_types30.default.oneOfType([import_prop_types30.default.number, import_prop_types30.default.string]),
  height: import_prop_types30.default.oneOfType([import_prop_types30.default.number, import_prop_types30.default.string])
};
var Skeleton_default = Skeleton;
var ImageWrapper = (0, import_styled_components41.default)(Skeleton)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
var IconWrapper2 = (0, import_styled_components41.default)(Icon_default)`
  color: var(--skeleton-icon);
`;
var BaseImageSkeleton = (unhandledProps) => {
  return /* @__PURE__ */ import_react38.default.createElement(ImageWrapper, {
    ...unhandledProps
  }, /* @__PURE__ */ import_react38.default.createElement(IconWrapper2, {
    icon: "image"
  }));
};
var ImageSkeleton = (0, import_styled_components41.default)(BaseImageSkeleton)``;
ImageSkeleton.displayName = "ImageSkeleton";

// src/Spinner.js
var import_react40 = __toESM(require("react"));
var import_prop_types31 = __toESM(require("prop-types"));
var import_styled_components42 = __toESM(require("styled-components"));

// src/hooks/use-toggle.js
var import_react39 = require("react");
function useToggle(initialValue = false) {
  const [value, setValue] = (0, import_react39.useState)(initialValue);
  const toggle = () => setValue((val) => !val);
  return [value, toggle];
}

// src/Spinner.js
var pulse = import_styled_components42.keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`;
var merge = import_styled_components42.keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.2);
  }
`;
var spinner = import_styled_components42.keyframes`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
`;
var move = ($position) => import_styled_components42.keyframes`
  0% {
    left: 18px;
    ${$position}: 18px;
  }
  100% {
    left: 18px;
    ${$position}: 42px;
  }
`;
var grow = ($position) => import_styled_components42.keyframes`
  0% {
    background: transparent;
    border: 4px solid transparent;

    ${$position === "top" ? `border-bottom-color: var(--primary);` : `border-top-color: var(--primary);`}
  }
  100% {
    background: transparent;
    border: 4px solid transparent;
    height: 50px;
    left: -5px;
    width: 50px;

    ${$position}: -2px;

    ${$position === "top" ? `border-bottom-color: var(--primary);` : `border-top-color: var(--primary);
          `}
  }
`;
var Wrapper17 = import_styled_components42.default.div`
  display: grid;
  grid-template-columns: 1fr;
`;
var Rotate = import_styled_components42.default.div`
  animation: ${pulse} 0.6s ease-in-out 1, ${spinner} 1.5s linear 0.5s infinite;
  background: var(--primary-grad);
  border-radius: 50%;
  display: block;
  grid-column-start: 1;
  grid-row-start: 1;
  height: 40px;
  position: relative;
  transform: translateZ(0);
  width: 40px;
  will-change: transform;
`;
var Arc = import_styled_components42.default.div`
  background: var(--primary);
  border-radius: 50%;
  height: 6px;
  left: 18px;
  position: absolute;
  width: 6px;
  transform: translateZ(0);
  will-change: transform;

  ${({ $position }) => import_styled_components42.css`
    animation: ${move($position)} 0.5s linear 1 0.5s forwards,
      ${grow($position)} 0.5s linear 1 1s forwards,
      ${merge} 0.5s linear 1 3s forwards;

    ${$position}: 18px;
  `}
`;
var IconWrapper3 = import_styled_components42.default.div`
  align-items: center;
  animation: ${pulse} 0.6s ease-in-out 1;
  background: var(--primary-grad);
  border-radius: 100%;
  display: flex;
  grid-column-start: 1;
  grid-row-start: 1;
  height: 40px;
  justify-content: center;
  position: absolute;
  transform: translateZ(0);
  width: 40px;
  will-change: transform;
`;
var Icon2 = (0, import_styled_components42.default)(Logo_default)`
  color: var(--white);
  font-size: var(--large);
`;
var Spinner = (unhandledProps) => {
  const $rotate = (0, import_react40.useRef)();
  const $top = (0, import_react40.useRef)();
  const $bottom = (0, import_react40.useRef)();
  const [key, reset] = useToggle();
  (0, import_react40.useEffect)(() => {
    const timer = setInterval(reset, 3600);
    return () => {
      clearInterval(timer);
    };
  }, [reset]);
  return /* @__PURE__ */ import_react40.default.createElement(Wrapper17, {
    "aria-label": "Loading",
    "aria-busy": true,
    "aria-live": "polite",
    key,
    ...unhandledProps
  }, /* @__PURE__ */ import_react40.default.createElement(Rotate, {
    ref: $rotate
  }, /* @__PURE__ */ import_react40.default.createElement(Arc, {
    $position: "top",
    ref: $top
  }), /* @__PURE__ */ import_react40.default.createElement(Arc, {
    $position: "bottom",
    ref: $bottom
  })), /* @__PURE__ */ import_react40.default.createElement(IconWrapper3, null, /* @__PURE__ */ import_react40.default.createElement(Icon2, null)));
};
Spinner.propTypes = {
  className: import_prop_types31.default.string
};
var Spinner_default = (0, import_styled_components42.default)(Spinner)``;

// src/Switch.js
var import_react41 = __toESM(require("react"));
var import_prop_types32 = __toESM(require("prop-types"));
var import_styled_components43 = __toESM(require("styled-components"));
var Wrapper18 = import_styled_components43.default.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
var Label6 = import_styled_components43.default.label``;
var Text2 = import_styled_components43.default.span``;
var SwitchWrapper = import_styled_components43.default.div`
  display: flex;
  gap: 12px;
  font-weight: var(--bold);
`;
var InputWrapper3 = import_styled_components43.default.div`
  position: relative;
`;
var HiddenInput = import_styled_components43.default.input`
  cursor: inherit;
  height: 100%;
  left: 0;
  margin: 0;
  opacity: 0;
  padding: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;
var SwitchInput = import_styled_components43.default.div`
  display: flex;
  width: 32px;
  height: 16px;
  border-radius: 8px;
  position: relative;
  will-change: left, right;
  cursor: pointer;
  padding: 3px;
  outline: none;
  background-color: var(--switch-bg);
  z-index: 1;

  :hover,
  :focus {
    background-color: var(--switch-hover-bg);

    :after {
      background-color: var(--switch-dot-hover-bg);
    }
  }

  :after {
    transition: ${easing("transform")};
    content: '';
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: var(--switch-dot-bg);
  }

  :focus {
    :before {
      content: '';
      position: absolute;
      top: -4px;
      left: -4px;
      right: -4px;
      bottom: -4px;
      border: 2px solid var(--pleather);
      border-radius: 16px;
    }
  }

  :focus:not(:focus-visible) {
    :before {
      boder: none;
    }
  }

  &[aria-checked='true'] {
    background-color: var(--switch-checked-bg);

    :after {
      /* SwitchInput width - after width - SwitchInput padding = 16px*/
      transform: translateX(16px);
      background-color: var(--switch-dot-checked-bg);
    }

    :hover,
    :focus {
      background-color: var(--switch-checked-hover-bg);
      :after {
        background-color: var(--switch-dot-checked-hover-bg);
      }
    }
  }

  &[aria-disabled='true'] {
    background-color: var(--switch-disabled-bg);

    :after {
      background-color: var(--switch-dot-disabled-bg);
    }

    :hover,
    :focus {
      background-color: var(--switch-disabled-bg);
      :after {
        background-color: var(--switch-dot-disabled-bg);
      }
    }
  }

  &[aria-disabled='true'][aria-checked='true'] {
    background-color: var(--switch-disabled-checked-bg);

    :after {
      transform: translateX(16px);
      background-color: var(--switch-dot-disabled-checked-bg);
    }

    :hover,
    :focus {
      background-color: var(--switch-disabled-checked-bg);
      :after {
        background-color: var(--switch-dot-disabled-checked-bg);
      }
    }
  }
`;
function Switch({
  checked: initialValue = false,
  className,
  disabled,
  label,
  onChange,
  onKeyDown,
  textOff,
  textOn,
  ...unhandledProps
}) {
  const [checked, setChecked] = (0, import_react41.useState)(initialValue);
  const { labelID, textOffID, textOnID } = (0, import_react41.useMemo)(() => {
    const random = Number.parseInt(Math.random() * Number.MAX_SAFE_INTEGER, 10);
    return {
      labelID: `${random}-label-switch`,
      textOffID: `${random}-text-on-switch`,
      textOnID: `${random}-text-off-switch`
    };
  }, []);
  (0, import_react41.useEffect)(() => {
    setChecked(initialValue);
  }, [initialValue]);
  const handleChange = (0, import_react41.useCallback)(
    (event) => {
      if (disabled || event.nativeEvent.defaultPrevented) {
        return;
      }
      event.preventDefault();
      if (onChange) {
        onChange(!checked, event);
        event.persist();
      }
      setChecked(!checked);
    },
    [checked, disabled, onChange]
  );
  const handleKeyDown = (0, import_react41.useCallback)(
    (event) => {
      if (event.key === " ") {
        event.preventDefault();
        onChange == null ? void 0 : onChange(!checked, event);
        setChecked((isChecked) => !isChecked);
      }
      onKeyDown == null ? void 0 : onKeyDown(event);
    },
    [onKeyDown, onChange, checked]
  );
  return /* @__PURE__ */ import_react41.default.createElement(Wrapper18, null, label && /* @__PURE__ */ import_react41.default.createElement(Label6, {
    id: labelID
  }, label), /* @__PURE__ */ import_react41.default.createElement(SwitchWrapper, null, textOff && /* @__PURE__ */ import_react41.default.createElement(Text2, {
    id: textOffID
  }, textOff), /* @__PURE__ */ import_react41.default.createElement(InputWrapper3, null, /* @__PURE__ */ import_react41.default.createElement(SwitchInput, {
    checked,
    className,
    disabled,
    onClick: handleChange,
    "aria-checked": checked,
    "aria-disabled": disabled,
    onKeyDown: handleKeyDown,
    tabIndex: disabled ? -1 : 0,
    role: "switch",
    "aria-label": "switch input",
    "aria-labelledby": `${labelID} ${textOffID} ${textOnID}`
  }), /* @__PURE__ */ import_react41.default.createElement(HiddenInput, {
    "aria-hidden": "true",
    checked,
    disabled,
    onChange: handleChange,
    type: "checkbox",
    tabIndex: "-1",
    ...unhandledProps
  })), textOn && /* @__PURE__ */ import_react41.default.createElement(Text2, {
    id: textOnID
  }, textOn)));
}
Switch.propTypes = {
  checked: import_prop_types32.default.bool,
  children: import_prop_types32.default.node,
  className: import_prop_types32.default.string,
  disabled: import_prop_types32.default.bool,
  label: import_prop_types32.default.string,
  textOff: import_prop_types32.default.string,
  textOn: import_prop_types32.default.string,
  onChange: import_prop_types32.default.func,
  onKeyDown: import_prop_types32.default.func
};
var Switch_default = (0, import_styled_components43.default)(Switch)``;

// src/Toast.js
var import_react42 = __toESM(require("react"));
var import_styled_components44 = __toESM(require("styled-components"));
var import_react_hot_toast = require("react-hot-toast");
var Wrapper19 = import_styled_components44.default.span`
  --toast-default-background: var(--smurf-blood);
  --toast-default-font-color: var(--white);

  --toast-success-background: var(--ice-ice-baby);
  --toast-success-border-color: var(--cutecumber);
  --toast-success-font-color: var(--pleather);
  --toast-success-icon-color: var(--cutecumber);

  --toast-error-background: var(--bubble-tape);
  --toast-error-border-color: var(--motorola-razr);
  --toast-error-font-color: var(--pleather);
  --toast-error-icon-color: var(--pink-power-ranger);
`;
var Prefix2 = (0, import_styled_components44.default)(Icon_default)`
  font-size: var(--large);

  ${({ kind }) => {
  switch (kind) {
    case "success":
      return "color: var(--toast-success-icon-color)";
    case "error":
      return "color: var(--toast-error-icon-color)";
    default:
      return "";
  }
}}
`;
function Toast2() {
  return /* @__PURE__ */ import_react42.default.createElement(Wrapper19, null, /* @__PURE__ */ import_react42.default.createElement(import_react_hot_toast.Toaster, {
    position: "top-center",
    toastOptions: {
      duration: 3e3,
      style: {
        background: "var(--toast-default-background)",
        borderRadius: "12px",
        color: "var(--toast-default-font-color)",
        justifyContent: "flex-start",
        padding: "16px",
        display: "flex",
        gap: "8px"
      },
      success: {
        icon: /* @__PURE__ */ import_react42.default.createElement(Prefix2, {
          icon: "check-circle",
          kind: "success"
        }),
        style: {
          background: "var(--toast-success-background)",
          border: "1px solid var(--toast-success-border-color)",
          color: "var(--toast-success-font-color)"
        }
      },
      error: {
        icon: /* @__PURE__ */ import_react42.default.createElement(Prefix2, {
          icon: "exclamation-circle",
          kind: "error"
        }),
        style: {
          background: "var(--toast-error-background)",
          border: "1px solid var(--toast-error-border-color)",
          color: "var(--toast-error-font-color)"
        }
      }
    }
  }));
}

// src/Tooltip.js
var import_react43 = __toESM(require("react"));
var import_prop_types33 = __toESM(require("prop-types"));
var import_styled_components45 = __toESM(require("styled-components"));
var import_lodash4 = __toESM(require_lodash());
var Wrapped = import_styled_components45.default.div`
  display: inline-block;

  > * {
    &[disabled] {
      pointer-events: none;
    }
  }
`;
var Reset = import_styled_components45.default.div`
  left: 0;
  position: fixed;
  top: 0;
`;
var Tip = import_styled_components45.default.div`
  background: var(--tooltip-bg);
  border-color: var(--tooltip-bg);
  border-radius: 6px;
  color: var(--white);
  font-weight: var(--normal);
  font-size: var(--x-small);
  line-height: 1.5;
  padding: 10px 12px;
  position: absolute;
  text-align: center;
  white-space: normal;

  ::after {
    border: solid transparent;
    border-width: var(--tooltip-caret-width);
    content: '';
    display: inline-block;
    position: absolute;
  }

  ${Link} {
    color: var(--color-blurple-400);
    :active {
      color: var(--color-blurple-300);
    }
  }

  ${({ size }) => {
  switch (size) {
    case "l":
      return `width: 320px;`;
    case "m":
      return `width: 200px;`;
    case "s":
      return `width: 120px;`;
    default:
      return `white-space: nowrap;`;
  }
}}

  ${({ placement }) => {
  switch (placement) {
    case "top":
      return `
        transform: translateY(calc(-1 * var(--tooltip-caret-width)));

        ::after {
          top: 100%;
          left: calc(50% - var(--tooltip-caret-width));
          border-top-color: inherit;
        }
      `;
    case "right":
      return `
        transform: translateX(var(--tooltip-caret-width));

        ::after {
          right: 100%;
          top: calc(50% - var(--tooltip-caret-width));
          border-right-color: inherit;
        }
      `;
    case "bottom":
      return `
        transform: translateY(var(--tooltip-caret-width));

        ::after {
          bottom: 100%;
          left: calc(50% - var(--tooltip-caret-width));
          border-bottom-color: inherit;
        }
      `;
    case "left":
      return `
        transform: translateX(calc(-1 * var(--tooltip-caret-width)));

        ::after {
          left: 100%;
          top: calc(50% - var(--tooltip-caret-width));
          border-left-color: inherit;
        }
      `;
    default:
      return "";
  }
}}

  ${({ persist }) => !persist && `pointer-events: none;`}
`;
var getBoundingClientRect2 = ($element) => $element ? $element.getBoundingClientRect() : { top: 0, right: 0, bottom: 0, left: 0, height: 0, width: 0 };
var getPositions2 = ({ attachment, target }) => ({
  top: {
    top: target.top - attachment.height,
    left: target.left + target.width / 2 - attachment.width / 2
  },
  right: {
    top: target.top + target.height / 2 - attachment.height / 2,
    left: target.right
  },
  bottom: {
    top: target.bottom,
    left: target.left + target.width / 2 - attachment.width / 2
  },
  left: {
    top: target.top + target.height / 2 - attachment.height / 2,
    left: target.left - attachment.width
  }
});
var usePosition2 = ({ placement, visible }) => {
  const target = (0, import_react43.useRef)();
  const attachment = (0, import_react43.useRef)();
  const [position, setPosition] = (0, import_react43.useState)({});
  const reposition = (0, import_react43.useCallback)(() => {
    const { current: $target } = target;
    const { current: $attachment } = attachment;
    const targetRect = getBoundingClientRect2($target);
    const attachmentRect = getBoundingClientRect2($attachment);
    const positions = getPositions2({
      attachment: attachmentRect,
      target: targetRect
    });
    setPosition(positions[placement]);
  }, [placement]);
  (0, import_react43.useLayoutEffect)(() => {
    if (!visible) {
      return;
    }
    const handler = (0, import_lodash4.default)(reposition, 16, { leading: true });
    setTimeout(reposition);
    window.addEventListener("resize", handler);
    window.addEventListener("scroll", handler);
    return () => {
      window.removeEventListener("resize", handler);
      window.removeEventListener("scroll", handler);
    };
  }, [reposition, visible]);
  return [{ attachment, target }, position];
};
function Tooltip({
  children,
  className,
  delay = 100,
  disabled = false,
  label,
  persist = false,
  placement = "top",
  size,
  timeout = 200,
  visible: forced,
  wrapped = false
}) {
  const [open, setOpen] = (0, import_react43.useState)(false);
  const visible = forced != null ? forced : open;
  const [refs, position] = usePosition2({ placement, visible });
  if (disabled) {
    return typeof children === "function" ? children() : children;
  }
  const handleMouseOver = () => {
    setOpen(true);
  };
  const handleMouseOut = () => {
    setOpen(false);
  };
  const renderTarget = () => {
    const unhandledProps = {
      onMouseOver: handleMouseOver,
      onMouseOut: handleMouseOut,
      ref: refs.target,
      className
    };
    if (wrapped) {
      return /* @__PURE__ */ import_react43.default.createElement(Wrapped, {
        ...unhandledProps
      }, children);
    }
    const child = import_react43.Children.only(children);
    return (0, import_react43.cloneElement)(child, unhandledProps);
  };
  return /* @__PURE__ */ import_react43.default.createElement(import_react43.default.Fragment, null, renderTarget(), /* @__PURE__ */ import_react43.default.createElement(Portal_default, {
    timeout: delay + timeout
  }, /* @__PURE__ */ import_react43.default.createElement(Reset, null, /* @__PURE__ */ import_react43.default.createElement(Fade_default, {
    delay,
    from: "center",
    timeout,
    visible
  }, /* @__PURE__ */ import_react43.default.createElement(Tip, {
    className,
    placement,
    ref: refs.attachment,
    role: "tooltip",
    size,
    style: position,
    persist,
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut
  }, typeof label === "function" ? label() : label)))));
}
Tooltip.propTypes = {
  children: import_prop_types33.default.oneOfType([import_prop_types33.default.func, import_prop_types33.default.node]),
  className: import_prop_types33.default.string,
  delay: import_prop_types33.default.number,
  disabled: import_prop_types33.default.bool,
  label: import_prop_types33.default.oneOfType([import_prop_types33.default.func, import_prop_types33.default.node]),
  persist: import_prop_types33.default.bool,
  placement: import_prop_types33.default.oneOf(["top", "right", "bottom", "left"]),
  size: import_prop_types33.default.oneOf(["s", "m", "l"]),
  timeout: import_prop_types33.default.number,
  visible: import_prop_types33.default.bool,
  wrapped: import_prop_types33.default.bool
};
var Tooltip_default = (0, import_styled_components45.default)(Tooltip)``;

// src/TextArea.js
var import_styled_components46 = __toESM(require("styled-components"));
var TextArea = import_styled_components46.default.textarea`
  background-color: var(--white);
  border: 1px solid;
  border-color: var(--input);
  border-radius: 6px;
  color: var(--input-text);
  font-size: var(--regular);
  font-weight: var(--normal);
  outline: none;
  padding: 10px 14px;
  width: 100%;
  &::placeholder {
    color: var(--input);
  }
  &:focus {
    border-color: var(--input-focus);
  }
`;
var TextArea_default = TextArea;

// src/TabsNav.js
var import_styled_components47 = __toESM(require("styled-components"));
var TabsNav = import_styled_components47.default.nav`
  --tablink-active-color: var(--blurple);
  --tablink-resting-color: var(--pleather);

  display: flex;
  flex-direction: row;
  background-color: var(--white);
  box-shadow: var(--level-1);

  ${({ sticky }) => sticky && `
      position: sticky;
      top: 100px;
      z-index: 1;
    `}
`;
var TabsList = import_styled_components47.default.ol``;
var TabItem = import_styled_components47.default.li`
  display: inline-block;
  min-width: 200px;
  padding: 18px 0;
  text-align: center;

  ${({ $active }) => $active && `
      border-bottom: 2px solid var(--tablink-active-color);

      ${Link_default} {
        color: var(--tablink-active-color);
      }
    `}

  ${Link_default} {
    --link-color: var(--tablink-resting-color);
    --link-text-decoration: none;
    --link-hover-color: var(--tablink-active-color);
    --link-visited-color: var(--link-color);
  }
`;

// src/DataList.js
var import_react46 = __toESM(require("react"));
var import_prop_types36 = __toESM(require("prop-types"));
var import_styled_components49 = __toESM(require("styled-components"));

// ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}

// ../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}

// ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o2, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p2) {
    o3.__proto__ = p2;
    return o3;
  };
  return _setPrototypeOf(o2, p);
}

// ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

// node_modules/downshift/dist/downshift.esm.js
var import_prop_types34 = __toESM(require("prop-types"));
var import_react44 = require("react");
var import_react_is = __toESM(require_react_is());

// node_modules/compute-scroll-into-view/dist/index.js
var e = (e2) => "object" == typeof e2 && null != e2 && 1 === e2.nodeType;
var t = (e2, t2) => (!t2 || "hidden" !== e2) && ("visible" !== e2 && "clip" !== e2);
var n = (e2, n2) => {
  if (e2.clientHeight < e2.scrollHeight || e2.clientWidth < e2.scrollWidth) {
    let l2 = getComputedStyle(e2, null);
    return t(l2.overflowY, n2) || t(l2.overflowX, n2) || ((e3) => {
      let t2 = ((e4) => {
        if (!e4.ownerDocument || !e4.ownerDocument.defaultView)
          return null;
        try {
          return e4.ownerDocument.defaultView.frameElement;
        } catch (e5) {
          return null;
        }
      })(e3);
      return !!t2 && (t2.clientHeight < e3.scrollHeight || t2.clientWidth < e3.scrollWidth);
    })(e2);
  }
  return false;
};
var l = (e2, t2, n2, l2, i2, o2, r, d) => o2 < e2 && r > t2 || o2 > e2 && r < t2 ? 0 : o2 <= e2 && d <= n2 || r >= t2 && d >= n2 ? o2 - e2 - l2 : r > t2 && d < n2 || o2 < e2 && d > n2 ? r - t2 + i2 : 0;
var i = (e2) => {
  let t2 = e2.parentElement;
  return null == t2 ? e2.getRootNode().host || null : t2;
};
var o = (t2, o2) => {
  var r, d, h, f, u, s;
  if ("undefined" == typeof document)
    return [];
  let { scrollMode: a, block: c, inline: g, boundary: m, skipOverflowHiddenElements: p } = o2, w = "function" == typeof m ? m : (e2) => e2 !== m;
  if (!e(t2))
    throw new TypeError("Invalid target");
  let W = document.scrollingElement || document.documentElement, H = [], b = t2;
  for (; e(b) && w(b); ) {
    if (b = i(b), b === W) {
      H.push(b);
      break;
    }
    null != b && b === document.body && n(b) && !n(document.documentElement) || null != b && n(b, p) && H.push(b);
  }
  let v = null != (d = null == (r = window.visualViewport) ? void 0 : r.width) ? d : innerWidth, y = null != (f = null == (h = window.visualViewport) ? void 0 : h.height) ? f : innerHeight, E = null != (u = window.scrollX) ? u : pageXOffset, M = null != (s = window.scrollY) ? s : pageYOffset, { height: x, width: I, top: C, right: R, bottom: T, left: V } = t2.getBoundingClientRect(), k = "start" === c || "nearest" === c ? C : "end" === c ? T : C + x / 2, B = "center" === g ? V + I / 2 : "end" === g ? R : V, D = [];
  for (let e2 = 0; e2 < H.length; e2++) {
    let t3 = H[e2], { height: n2, width: i2, top: o3, right: r2, bottom: d2, left: h2 } = t3.getBoundingClientRect();
    if ("if-needed" === a && C >= 0 && V >= 0 && T <= y && R <= v && C >= o3 && T <= d2 && V >= h2 && R <= r2)
      return D;
    let f2 = getComputedStyle(t3), u2 = parseInt(f2.borderLeftWidth, 10), s2 = parseInt(f2.borderTopWidth, 10), m2 = parseInt(f2.borderRightWidth, 10), p2 = parseInt(f2.borderBottomWidth, 10), w2 = 0, b2 = 0, O = "offsetWidth" in t3 ? t3.offsetWidth - t3.clientWidth - u2 - m2 : 0, X = "offsetHeight" in t3 ? t3.offsetHeight - t3.clientHeight - s2 - p2 : 0, Y = "offsetWidth" in t3 ? 0 === t3.offsetWidth ? 0 : i2 / t3.offsetWidth : 0, L = "offsetHeight" in t3 ? 0 === t3.offsetHeight ? 0 : n2 / t3.offsetHeight : 0;
    if (W === t3)
      w2 = "start" === c ? k : "end" === c ? k - y : "nearest" === c ? l(M, M + y, y, s2, p2, M + k, M + k + x, x) : k - y / 2, b2 = "start" === g ? B : "center" === g ? B - v / 2 : "end" === g ? B - v : l(E, E + v, v, u2, m2, E + B, E + B + I, I), w2 = Math.max(0, w2 + M), b2 = Math.max(0, b2 + E);
    else {
      w2 = "start" === c ? k - o3 - s2 : "end" === c ? k - d2 + p2 + X : "nearest" === c ? l(o3, d2, n2, s2, p2 + X, k, k + x, x) : k - (o3 + n2 / 2) + X / 2, b2 = "start" === g ? B - h2 - u2 : "center" === g ? B - (h2 + i2 / 2) + O / 2 : "end" === g ? B - r2 + m2 + O : l(h2, r2, i2, u2, m2 + O, B, B + I, I);
      let { scrollLeft: e3, scrollTop: f3 } = t3;
      w2 = Math.max(0, Math.min(f3 + w2 / L, t3.scrollHeight - n2 / L + X)), b2 = Math.max(0, Math.min(e3 + b2 / Y, t3.scrollWidth - i2 / Y + O)), k += f3 - w2, B += e3 - b2;
    }
    D.push({ el: t3, top: w2, left: b2 });
  }
  return D;
};

// ../../node_modules/tslib/modules/index.js
var import_tslib = __toESM(require_tslib(), 1);
var {
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __exportStar,
  __createBinding,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn
} = import_tslib.default;

// node_modules/downshift/dist/downshift.esm.js
var idCounter = 0;
function cbToCb(cb) {
  return typeof cb === "function" ? cb : noop;
}
function noop() {
}
function scrollIntoView(node, menuNode) {
  if (!node) {
    return;
  }
  var actions = o(node, {
    boundary: menuNode,
    block: "nearest",
    scrollMode: "if-needed"
  });
  actions.forEach(function(_ref) {
    var el = _ref.el, top = _ref.top, left = _ref.left;
    el.scrollTop = top;
    el.scrollLeft = left;
  });
}
function isOrContainsNode(parent, child, environment) {
  var result = parent === child || child instanceof environment.Node && parent.contains && parent.contains(child);
  return result;
}
function debounce4(fn, time) {
  var timeoutId;
  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }
  function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    cancel();
    timeoutId = setTimeout(function() {
      timeoutId = null;
      fn.apply(void 0, args);
    }, time);
  }
  wrapper.cancel = cancel;
  return wrapper;
}
function callAllEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }
  return function(event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    return fns.some(function(fn) {
      if (fn) {
        fn.apply(void 0, [event].concat(args));
      }
      return event.preventDownshiftDefault || event.hasOwnProperty("nativeEvent") && event.nativeEvent.preventDownshiftDefault;
    });
  };
}
function handleRefs() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    refs[_key4] = arguments[_key4];
  }
  return function(node) {
    refs.forEach(function(ref) {
      if (typeof ref === "function") {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
}
function generateId() {
  return String(idCounter++);
}
function getA11yStatusMessage$1(_ref2) {
  var isOpen = _ref2.isOpen, resultCount = _ref2.resultCount, previousResultCount = _ref2.previousResultCount;
  if (!isOpen) {
    return "";
  }
  if (!resultCount) {
    return "No results are available.";
  }
  if (resultCount !== previousResultCount) {
    return resultCount + " result" + (resultCount === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select.";
  }
  return "";
}
function unwrapArray(arg, defaultValue) {
  arg = Array.isArray(arg) ? arg[0] : arg;
  if (!arg && defaultValue) {
    return defaultValue;
  } else {
    return arg;
  }
}
function isDOMElement(element) {
  return typeof element.type === "string";
}
function getElementProps(element) {
  return element.props;
}
function requiredProp(fnName, propName) {
  console.error('The property "' + propName + '" is required in "' + fnName + '"');
}
var stateKeys = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function pickState(state) {
  if (state === void 0) {
    state = {};
  }
  var result = {};
  stateKeys.forEach(function(k) {
    if (state.hasOwnProperty(k)) {
      result[k] = state[k];
    }
  });
  return result;
}
function getState(state, props) {
  return Object.keys(state).reduce(function(prevState, key) {
    prevState[key] = isControlledProp(props, key) ? props[key] : state[key];
    return prevState;
  }, {});
}
function isControlledProp(props, key) {
  return props[key] !== void 0;
}
function normalizeArrowKey(event) {
  var key = event.key, keyCode = event.keyCode;
  if (keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0) {
    return "Arrow" + key;
  }
  return key;
}
function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === "[object Object]";
}
function getNextWrappingIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  if (circular === void 0) {
    circular = true;
  }
  if (itemCount === 0) {
    return -1;
  }
  var itemsLastIndex = itemCount - 1;
  if (typeof baseIndex !== "number" || baseIndex < 0 || baseIndex >= itemCount) {
    baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
  }
  var newIndex = baseIndex + moveAmount;
  if (newIndex < 0) {
    newIndex = circular ? itemsLastIndex : 0;
  } else if (newIndex > itemsLastIndex) {
    newIndex = circular ? 0 : itemsLastIndex;
  }
  var nonDisabledNewIndex = getNextNonDisabledIndex(moveAmount, newIndex, itemCount, getItemNodeFromIndex, circular);
  if (nonDisabledNewIndex === -1) {
    return baseIndex >= itemCount ? -1 : baseIndex;
  }
  return nonDisabledNewIndex;
}
function getNextNonDisabledIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  var currentElementNode = getItemNodeFromIndex(baseIndex);
  if (!currentElementNode || !currentElementNode.hasAttribute("disabled")) {
    return baseIndex;
  }
  if (moveAmount > 0) {
    for (var index = baseIndex + 1; index < itemCount; index++) {
      if (!getItemNodeFromIndex(index).hasAttribute("disabled")) {
        return index;
      }
    }
  } else {
    for (var _index = baseIndex - 1; _index >= 0; _index--) {
      if (!getItemNodeFromIndex(_index).hasAttribute("disabled")) {
        return _index;
      }
    }
  }
  if (circular) {
    return moveAmount > 0 ? getNextNonDisabledIndex(1, 0, itemCount, getItemNodeFromIndex, false) : getNextNonDisabledIndex(-1, itemCount - 1, itemCount, getItemNodeFromIndex, false);
  }
  return -1;
}
function targetWithinDownshift(target, downshiftElements, environment, checkActiveElement) {
  if (checkActiveElement === void 0) {
    checkActiveElement = true;
  }
  return downshiftElements.some(function(contextNode) {
    return contextNode && (isOrContainsNode(contextNode, target, environment) || checkActiveElement && isOrContainsNode(contextNode, environment.document.activeElement, environment));
  });
}
var validateControlledUnchanged = noop;
if (process.env.NODE_ENV !== "production") {
  validateControlledUnchanged = function validateControlledUnchanged2(state, prevProps, nextProps) {
    var warningDescription = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
    Object.keys(state).forEach(function(propKey) {
      if (prevProps[propKey] !== void 0 && nextProps[propKey] === void 0) {
        console.error('downshift: A component has changed the controlled prop "' + propKey + '" to be uncontrolled. ' + warningDescription);
      } else if (prevProps[propKey] === void 0 && nextProps[propKey] !== void 0) {
        console.error('downshift: A component has changed the uncontrolled prop "' + propKey + '" to be controlled. ' + warningDescription);
      }
    });
  };
}
var cleanupStatus = debounce4(function(documentProp) {
  getStatusDiv(documentProp).textContent = "";
}, 500);
function setStatus(status, documentProp) {
  var div = getStatusDiv(documentProp);
  if (!status) {
    return;
  }
  div.textContent = status;
  cleanupStatus(documentProp);
}
function getStatusDiv(documentProp) {
  if (documentProp === void 0) {
    documentProp = document;
  }
  var statusDiv = documentProp.getElementById("a11y-status-message");
  if (statusDiv) {
    return statusDiv;
  }
  statusDiv = documentProp.createElement("div");
  statusDiv.setAttribute("id", "a11y-status-message");
  statusDiv.setAttribute("role", "status");
  statusDiv.setAttribute("aria-live", "polite");
  statusDiv.setAttribute("aria-relevant", "additions text");
  Object.assign(statusDiv.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  });
  documentProp.body.appendChild(statusDiv);
  return statusDiv;
}
var unknown = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0;
var mouseUp = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1;
var itemMouseEnter = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2;
var keyDownArrowUp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3;
var keyDownArrowDown = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4;
var keyDownEscape = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5;
var keyDownEnter = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6;
var keyDownHome = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7;
var keyDownEnd = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8;
var clickItem = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9;
var blurInput = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10;
var changeInput = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11;
var keyDownSpaceButton = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12;
var clickButton = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13;
var blurButton = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14;
var controlledPropUpdatedSelectedItem = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15;
var touchEnd = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16;
var stateChangeTypes$3 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown,
  mouseUp,
  itemMouseEnter,
  keyDownArrowUp,
  keyDownArrowDown,
  keyDownEscape,
  keyDownEnter,
  keyDownHome,
  keyDownEnd,
  clickItem,
  blurInput,
  changeInput,
  keyDownSpaceButton,
  clickButton,
  blurButton,
  controlledPropUpdatedSelectedItem,
  touchEnd
});
var _excluded$4 = ["refKey", "ref"];
var _excluded2$3 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"];
var _excluded3$2 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"];
var _excluded4$1 = ["refKey", "ref"];
var _excluded5 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"];
var Downshift = /* @__PURE__ */ function() {
  var Downshift2 = /* @__PURE__ */ function(_Component) {
    _inheritsLoose(Downshift3, _Component);
    function Downshift3(_props) {
      var _this;
      _this = _Component.call(this, _props) || this;
      _this.id = _this.props.id || "downshift-" + generateId();
      _this.menuId = _this.props.menuId || _this.id + "-menu";
      _this.labelId = _this.props.labelId || _this.id + "-label";
      _this.inputId = _this.props.inputId || _this.id + "-input";
      _this.getItemId = _this.props.getItemId || function(index) {
        return _this.id + "-item-" + index;
      };
      _this.input = null;
      _this.items = [];
      _this.itemCount = null;
      _this.previousResultCount = 0;
      _this.timeoutIds = [];
      _this.internalSetTimeout = function(fn, time) {
        var id = setTimeout(function() {
          _this.timeoutIds = _this.timeoutIds.filter(function(i2) {
            return i2 !== id;
          });
          fn();
        }, time);
        _this.timeoutIds.push(id);
      };
      _this.setItemCount = function(count) {
        _this.itemCount = count;
      };
      _this.unsetItemCount = function() {
        _this.itemCount = null;
      };
      _this.setHighlightedIndex = function(highlightedIndex, otherStateToSet) {
        if (highlightedIndex === void 0) {
          highlightedIndex = _this.props.defaultHighlightedIndex;
        }
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(_extends({
          highlightedIndex
        }, otherStateToSet));
      };
      _this.clearSelection = function(cb) {
        _this.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: _this.props.defaultHighlightedIndex,
          isOpen: _this.props.defaultIsOpen
        }, cb);
      };
      _this.selectItem = function(item, otherStateToSet, cb) {
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(_extends({
          isOpen: _this.props.defaultIsOpen,
          highlightedIndex: _this.props.defaultHighlightedIndex,
          selectedItem: item,
          inputValue: _this.props.itemToString(item)
        }, otherStateToSet), cb);
      };
      _this.selectItemAtIndex = function(itemIndex, otherStateToSet, cb) {
        var item = _this.items[itemIndex];
        if (item == null) {
          return;
        }
        _this.selectItem(item, otherStateToSet, cb);
      };
      _this.selectHighlightedItem = function(otherStateToSet, cb) {
        return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
      };
      _this.internalSetState = function(stateToSet, cb) {
        var isItemSelected, onChangeArg;
        var onStateChangeArg = {};
        var isStateToSetFunction = typeof stateToSet === "function";
        if (!isStateToSetFunction && stateToSet.hasOwnProperty("inputValue")) {
          _this.props.onInputValueChange(stateToSet.inputValue, _extends({}, _this.getStateAndHelpers(), stateToSet));
        }
        return _this.setState(function(state) {
          state = _this.getState(state);
          var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet;
          newStateToSet = _this.props.stateReducer(state, newStateToSet);
          isItemSelected = newStateToSet.hasOwnProperty("selectedItem");
          var nextState = {};
          if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) {
            onChangeArg = newStateToSet.selectedItem;
          }
          newStateToSet.type = newStateToSet.type || unknown;
          Object.keys(newStateToSet).forEach(function(key) {
            if (state[key] !== newStateToSet[key]) {
              onStateChangeArg[key] = newStateToSet[key];
            }
            if (key === "type") {
              return;
            }
            newStateToSet[key];
            if (!isControlledProp(_this.props, key)) {
              nextState[key] = newStateToSet[key];
            }
          });
          if (isStateToSetFunction && newStateToSet.hasOwnProperty("inputValue")) {
            _this.props.onInputValueChange(newStateToSet.inputValue, _extends({}, _this.getStateAndHelpers(), newStateToSet));
          }
          return nextState;
        }, function() {
          cbToCb(cb)();
          var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
          if (hasMoreStateThanType) {
            _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers());
          }
          if (isItemSelected) {
            _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers());
          }
          if (onChangeArg !== void 0) {
            _this.props.onChange(onChangeArg, _this.getStateAndHelpers());
          }
          _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
        });
      };
      _this.rootRef = function(node) {
        return _this._rootNode = node;
      };
      _this.getRootProps = function(_temp, _temp2) {
        var _extends2;
        var _ref = _temp === void 0 ? {} : _temp, _ref$refKey = _ref.refKey, refKey = _ref$refKey === void 0 ? "ref" : _ref$refKey, ref = _ref.ref, rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$suppressRefErro = _ref2.suppressRefError, suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
        _this.getRootProps.called = true;
        _this.getRootProps.refKey = refKey;
        _this.getRootProps.suppressRefError = suppressRefError;
        var _this$getState = _this.getState(), isOpen = _this$getState.isOpen;
        return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, _this.rootRef), _extends2.role = "combobox", _extends2["aria-expanded"] = isOpen, _extends2["aria-haspopup"] = "listbox", _extends2["aria-owns"] = isOpen ? _this.menuId : null, _extends2["aria-labelledby"] = _this.labelId, _extends2), rest);
      };
      _this.keyDownHandlers = {
        ArrowDown: function ArrowDown(event) {
          var _this2 = this;
          event.preventDefault();
          if (this.getState().isOpen) {
            var amount = event.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowDown
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowDown
            }, function() {
              var itemCount = _this2.getItemCount();
              if (itemCount > 0) {
                var _this2$getState = _this2.getState(), highlightedIndex = _this2$getState.highlightedIndex;
                var nextHighlightedIndex = getNextWrappingIndex(1, highlightedIndex, itemCount, function(index) {
                  return _this2.getItemNodeFromIndex(index);
                });
                _this2.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowDown
                });
              }
            });
          }
        },
        ArrowUp: function ArrowUp(event) {
          var _this3 = this;
          event.preventDefault();
          if (this.getState().isOpen) {
            var amount = event.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowUp
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowUp
            }, function() {
              var itemCount = _this3.getItemCount();
              if (itemCount > 0) {
                var _this3$getState = _this3.getState(), highlightedIndex = _this3$getState.highlightedIndex;
                var nextHighlightedIndex = getNextWrappingIndex(-1, highlightedIndex, itemCount, function(index) {
                  return _this3.getItemNodeFromIndex(index);
                });
                _this3.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowUp
                });
              }
            });
          }
        },
        Enter: function Enter(event) {
          if (event.which === 229) {
            return;
          }
          var _this$getState2 = this.getState(), isOpen = _this$getState2.isOpen, highlightedIndex = _this$getState2.highlightedIndex;
          if (isOpen && highlightedIndex != null) {
            event.preventDefault();
            var item = this.items[highlightedIndex];
            var itemNode = this.getItemNodeFromIndex(highlightedIndex);
            if (item == null || itemNode && itemNode.hasAttribute("disabled")) {
              return;
            }
            this.selectHighlightedItem({
              type: keyDownEnter
            });
          }
        },
        Escape: function Escape(event) {
          event.preventDefault();
          this.reset(_extends({
            type: keyDownEscape
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      };
      _this.buttonKeyDownHandlers = _extends({}, _this.keyDownHandlers, {
        " ": function _(event) {
          event.preventDefault();
          this.toggleMenu({
            type: keyDownSpaceButton
          });
        }
      });
      _this.inputKeyDownHandlers = _extends({}, _this.keyDownHandlers, {
        Home: function Home(event) {
          var _this4 = this;
          var _this$getState3 = this.getState(), isOpen = _this$getState3.isOpen;
          if (!isOpen) {
            return;
          }
          event.preventDefault();
          var itemCount = this.getItemCount();
          if (itemCount <= 0 || !isOpen) {
            return;
          }
          var newHighlightedIndex = getNextNonDisabledIndex(1, 0, itemCount, function(index) {
            return _this4.getItemNodeFromIndex(index);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownHome
          });
        },
        End: function End(event) {
          var _this5 = this;
          var _this$getState4 = this.getState(), isOpen = _this$getState4.isOpen;
          if (!isOpen) {
            return;
          }
          event.preventDefault();
          var itemCount = this.getItemCount();
          if (itemCount <= 0 || !isOpen) {
            return;
          }
          var newHighlightedIndex = getNextNonDisabledIndex(-1, itemCount - 1, itemCount, function(index) {
            return _this5.getItemNodeFromIndex(index);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownEnd
          });
        }
      });
      _this.getToggleButtonProps = function(_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3, onClick = _ref3.onClick;
        _ref3.onPress;
        var onKeyDown = _ref3.onKeyDown, onKeyUp = _ref3.onKeyUp, onBlur = _ref3.onBlur, rest = _objectWithoutPropertiesLoose(_ref3, _excluded2$3);
        var _this$getState5 = _this.getState(), isOpen = _this$getState5.isOpen;
        var enabledEventHandlers = {
          onClick: callAllEventHandlers(onClick, _this.buttonHandleClick),
          onKeyDown: callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
          onKeyUp: callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
          onBlur: callAllEventHandlers(onBlur, _this.buttonHandleBlur)
        };
        var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
        return _extends({
          type: "button",
          role: "button",
          "aria-label": isOpen ? "close menu" : "open menu",
          "aria-haspopup": true,
          "data-toggle": true
        }, eventHandlers, rest);
      };
      _this.buttonHandleKeyUp = function(event) {
        event.preventDefault();
      };
      _this.buttonHandleKeyDown = function(event) {
        var key = normalizeArrowKey(event);
        if (_this.buttonKeyDownHandlers[key]) {
          _this.buttonKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
        }
      };
      _this.buttonHandleClick = function(event) {
        event.preventDefault();
        if (_this.props.environment.document.activeElement === _this.props.environment.document.body) {
          event.target.focus();
        }
        if (process.env.NODE_ENV === "test") {
          _this.toggleMenu({
            type: clickButton
          });
        } else {
          _this.internalSetTimeout(function() {
            return _this.toggleMenu({
              type: clickButton
            });
          });
        }
      };
      _this.buttonHandleBlur = function(event) {
        var blurTarget = event.target;
        _this.internalSetTimeout(function() {
          if (!_this.isMouseDown && (_this.props.environment.document.activeElement == null || _this.props.environment.document.activeElement.id !== _this.inputId) && _this.props.environment.document.activeElement !== blurTarget) {
            _this.reset({
              type: blurButton
            });
          }
        });
      };
      _this.getLabelProps = function(props) {
        return _extends({
          htmlFor: _this.inputId,
          id: _this.labelId
        }, props);
      };
      _this.getInputProps = function(_temp4) {
        var _ref4 = _temp4 === void 0 ? {} : _temp4, onKeyDown = _ref4.onKeyDown, onBlur = _ref4.onBlur, onChange = _ref4.onChange, onInput = _ref4.onInput;
        _ref4.onChangeText;
        var rest = _objectWithoutPropertiesLoose(_ref4, _excluded3$2);
        var onChangeKey;
        var eventHandlers = {};
        {
          onChangeKey = "onChange";
        }
        var _this$getState6 = _this.getState(), inputValue = _this$getState6.inputValue, isOpen = _this$getState6.isOpen, highlightedIndex = _this$getState6.highlightedIndex;
        if (!rest.disabled) {
          var _eventHandlers;
          eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
        }
        return _extends({
          "aria-autocomplete": "list",
          "aria-activedescendant": isOpen && typeof highlightedIndex === "number" && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
          "aria-controls": isOpen ? _this.menuId : null,
          "aria-labelledby": rest && rest["aria-label"] ? void 0 : _this.labelId,
          autoComplete: "off",
          value: inputValue,
          id: _this.inputId
        }, eventHandlers, rest);
      };
      _this.inputHandleKeyDown = function(event) {
        var key = normalizeArrowKey(event);
        if (key && _this.inputKeyDownHandlers[key]) {
          _this.inputKeyDownHandlers[key].call(_assertThisInitialized(_this), event);
        }
      };
      _this.inputHandleChange = function(event) {
        _this.internalSetState({
          type: changeInput,
          isOpen: true,
          inputValue: event.target.value,
          highlightedIndex: _this.props.defaultHighlightedIndex
        });
      };
      _this.inputHandleBlur = function() {
        _this.internalSetTimeout(function() {
          var downshiftButtonIsActive = _this.props.environment.document && !!_this.props.environment.document.activeElement && !!_this.props.environment.document.activeElement.dataset && _this.props.environment.document.activeElement.dataset.toggle && _this._rootNode && _this._rootNode.contains(_this.props.environment.document.activeElement);
          if (!_this.isMouseDown && !downshiftButtonIsActive) {
            _this.reset({
              type: blurInput
            });
          }
        });
      };
      _this.menuRef = function(node) {
        _this._menuNode = node;
      };
      _this.getMenuProps = function(_temp5, _temp6) {
        var _extends3;
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$refKey = _ref5.refKey, refKey = _ref5$refKey === void 0 ? "ref" : _ref5$refKey, ref = _ref5.ref, props = _objectWithoutPropertiesLoose(_ref5, _excluded4$1);
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$suppressRefErro = _ref6.suppressRefError, suppressRefError = _ref6$suppressRefErro === void 0 ? false : _ref6$suppressRefErro;
        _this.getMenuProps.called = true;
        _this.getMenuProps.refKey = refKey;
        _this.getMenuProps.suppressRefError = suppressRefError;
        return _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, _this.menuRef), _extends3.role = "listbox", _extends3["aria-labelledby"] = props && props["aria-label"] ? null : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
      };
      _this.getItemProps = function(_temp7) {
        var _enabledEventHandlers;
        var _ref7 = _temp7 === void 0 ? {} : _temp7, onMouseMove = _ref7.onMouseMove, onMouseDown = _ref7.onMouseDown, onClick = _ref7.onClick;
        _ref7.onPress;
        var index = _ref7.index, _ref7$item = _ref7.item, item = _ref7$item === void 0 ? process.env.NODE_ENV === "production" ? void 0 : requiredProp("getItemProps", "item") : _ref7$item, rest = _objectWithoutPropertiesLoose(_ref7, _excluded5);
        if (index === void 0) {
          _this.items.push(item);
          index = _this.items.indexOf(item);
        } else {
          _this.items[index] = item;
        }
        var onSelectKey = "onClick";
        var customClickHandler = onClick;
        var enabledEventHandlers = (_enabledEventHandlers = {
          onMouseMove: callAllEventHandlers(onMouseMove, function() {
            if (index === _this.getState().highlightedIndex) {
              return;
            }
            _this.setHighlightedIndex(index, {
              type: itemMouseEnter
            });
            _this.avoidScrolling = true;
            _this.internalSetTimeout(function() {
              return _this.avoidScrolling = false;
            }, 250);
          }),
          onMouseDown: callAllEventHandlers(onMouseDown, function(event) {
            event.preventDefault();
          })
        }, _enabledEventHandlers[onSelectKey] = callAllEventHandlers(customClickHandler, function() {
          _this.selectItemAtIndex(index, {
            type: clickItem
          });
        }), _enabledEventHandlers);
        var eventHandlers = rest.disabled ? {
          onMouseDown: enabledEventHandlers.onMouseDown
        } : enabledEventHandlers;
        return _extends({
          id: _this.getItemId(index),
          role: "option",
          "aria-selected": _this.getState().highlightedIndex === index
        }, eventHandlers, rest);
      };
      _this.clearItems = function() {
        _this.items = [];
      };
      _this.reset = function(otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(function(_ref8) {
          var selectedItem = _ref8.selectedItem;
          return _extends({
            isOpen: _this.props.defaultIsOpen,
            highlightedIndex: _this.props.defaultHighlightedIndex,
            inputValue: _this.props.itemToString(selectedItem)
          }, otherStateToSet);
        }, cb);
      };
      _this.toggleMenu = function(otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(function(_ref9) {
          var isOpen = _ref9.isOpen;
          return _extends({
            isOpen: !isOpen
          }, isOpen && {
            highlightedIndex: _this.props.defaultHighlightedIndex
          }, otherStateToSet);
        }, function() {
          var _this$getState7 = _this.getState(), isOpen = _this$getState7.isOpen, highlightedIndex = _this$getState7.highlightedIndex;
          if (isOpen) {
            if (_this.getItemCount() > 0 && typeof highlightedIndex === "number") {
              _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
            }
          }
          cbToCb(cb)();
        });
      };
      _this.openMenu = function(cb) {
        _this.internalSetState({
          isOpen: true
        }, cb);
      };
      _this.closeMenu = function(cb) {
        _this.internalSetState({
          isOpen: false
        }, cb);
      };
      _this.updateStatus = debounce4(function() {
        var state = _this.getState();
        var item = _this.items[state.highlightedIndex];
        var resultCount = _this.getItemCount();
        var status = _this.props.getA11yStatusMessage(_extends({
          itemToString: _this.props.itemToString,
          previousResultCount: _this.previousResultCount,
          resultCount,
          highlightedItem: item
        }, state));
        _this.previousResultCount = resultCount;
        setStatus(status, _this.props.environment.document);
      }, 200);
      var _this$props = _this.props, defaultHighlightedIndex = _this$props.defaultHighlightedIndex, _this$props$initialHi = _this$props.initialHighlightedIndex, _highlightedIndex = _this$props$initialHi === void 0 ? defaultHighlightedIndex : _this$props$initialHi, defaultIsOpen = _this$props.defaultIsOpen, _this$props$initialIs = _this$props.initialIsOpen, _isOpen = _this$props$initialIs === void 0 ? defaultIsOpen : _this$props$initialIs, _this$props$initialIn = _this$props.initialInputValue, _inputValue = _this$props$initialIn === void 0 ? "" : _this$props$initialIn, _this$props$initialSe = _this$props.initialSelectedItem, _selectedItem = _this$props$initialSe === void 0 ? null : _this$props$initialSe;
      var _state = _this.getState({
        highlightedIndex: _highlightedIndex,
        isOpen: _isOpen,
        inputValue: _inputValue,
        selectedItem: _selectedItem
      });
      if (_state.selectedItem != null && _this.props.initialInputValue === void 0) {
        _state.inputValue = _this.props.itemToString(_state.selectedItem);
      }
      _this.state = _state;
      return _this;
    }
    var _proto = Downshift3.prototype;
    _proto.internalClearTimeouts = function internalClearTimeouts() {
      this.timeoutIds.forEach(function(id) {
        clearTimeout(id);
      });
      this.timeoutIds = [];
    };
    _proto.getState = function getState$1(stateToMerge) {
      if (stateToMerge === void 0) {
        stateToMerge = this.state;
      }
      return getState(stateToMerge, this.props);
    };
    _proto.getItemCount = function getItemCount() {
      var itemCount = this.items.length;
      if (this.itemCount != null) {
        itemCount = this.itemCount;
      } else if (this.props.itemCount !== void 0) {
        itemCount = this.props.itemCount;
      }
      return itemCount;
    };
    _proto.getItemNodeFromIndex = function getItemNodeFromIndex(index) {
      return this.props.environment.document.getElementById(this.getItemId(index));
    };
    _proto.scrollHighlightedItemIntoView = function scrollHighlightedItemIntoView() {
      {
        var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(node, this._menuNode);
      }
    };
    _proto.moveHighlightedIndex = function moveHighlightedIndex(amount, otherStateToSet) {
      var _this6 = this;
      var itemCount = this.getItemCount();
      var _this$getState8 = this.getState(), highlightedIndex = _this$getState8.highlightedIndex;
      if (itemCount > 0) {
        var nextHighlightedIndex = getNextWrappingIndex(amount, highlightedIndex, itemCount, function(index) {
          return _this6.getItemNodeFromIndex(index);
        });
        this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
      }
    };
    _proto.getStateAndHelpers = function getStateAndHelpers() {
      var _this$getState9 = this.getState(), highlightedIndex = _this$getState9.highlightedIndex, inputValue = _this$getState9.inputValue, selectedItem = _this$getState9.selectedItem, isOpen = _this$getState9.isOpen;
      var itemToString2 = this.props.itemToString;
      var id = this.id;
      var getRootProps = this.getRootProps, getToggleButtonProps = this.getToggleButtonProps, getLabelProps = this.getLabelProps, getMenuProps = this.getMenuProps, getInputProps = this.getInputProps, getItemProps = this.getItemProps, openMenu = this.openMenu, closeMenu = this.closeMenu, toggleMenu = this.toggleMenu, selectItem = this.selectItem, selectItemAtIndex = this.selectItemAtIndex, selectHighlightedItem = this.selectHighlightedItem, setHighlightedIndex = this.setHighlightedIndex, clearSelection = this.clearSelection, clearItems = this.clearItems, reset = this.reset, setItemCount = this.setItemCount, unsetItemCount = this.unsetItemCount, setState = this.internalSetState;
      return {
        getRootProps,
        getToggleButtonProps,
        getLabelProps,
        getMenuProps,
        getInputProps,
        getItemProps,
        reset,
        openMenu,
        closeMenu,
        toggleMenu,
        selectItem,
        selectItemAtIndex,
        selectHighlightedItem,
        setHighlightedIndex,
        clearSelection,
        clearItems,
        setItemCount,
        unsetItemCount,
        setState,
        itemToString: itemToString2,
        id,
        highlightedIndex,
        inputValue,
        isOpen,
        selectedItem
      };
    };
    _proto.componentDidMount = function componentDidMount() {
      var _this7 = this;
      if (process.env.NODE_ENV !== "production" && true && this.getMenuProps.called && !this.getMenuProps.suppressRefError) {
        validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
      }
      {
        var onMouseDown = function onMouseDown2() {
          _this7.isMouseDown = true;
        };
        var onMouseUp = function onMouseUp2(event) {
          _this7.isMouseDown = false;
          var contextWithinDownshift = targetWithinDownshift(event.target, [_this7._rootNode, _this7._menuNode], _this7.props.environment);
          if (!contextWithinDownshift && _this7.getState().isOpen) {
            _this7.reset({
              type: mouseUp
            }, function() {
              return _this7.props.onOuterClick(_this7.getStateAndHelpers());
            });
          }
        };
        var onTouchStart = function onTouchStart2() {
          _this7.isTouchMove = false;
        };
        var onTouchMove = function onTouchMove2() {
          _this7.isTouchMove = true;
        };
        var onTouchEnd = function onTouchEnd2(event) {
          var contextWithinDownshift = targetWithinDownshift(event.target, [_this7._rootNode, _this7._menuNode], _this7.props.environment, false);
          if (!_this7.isTouchMove && !contextWithinDownshift && _this7.getState().isOpen) {
            _this7.reset({
              type: touchEnd
            }, function() {
              return _this7.props.onOuterClick(_this7.getStateAndHelpers());
            });
          }
        };
        var environment = this.props.environment;
        environment.addEventListener("mousedown", onMouseDown);
        environment.addEventListener("mouseup", onMouseUp);
        environment.addEventListener("touchstart", onTouchStart);
        environment.addEventListener("touchmove", onTouchMove);
        environment.addEventListener("touchend", onTouchEnd);
        this.cleanup = function() {
          _this7.internalClearTimeouts();
          _this7.updateStatus.cancel();
          environment.removeEventListener("mousedown", onMouseDown);
          environment.removeEventListener("mouseup", onMouseUp);
          environment.removeEventListener("touchstart", onTouchStart);
          environment.removeEventListener("touchmove", onTouchMove);
          environment.removeEventListener("touchend", onTouchEnd);
        };
      }
    };
    _proto.shouldScroll = function shouldScroll(prevState, prevProps) {
      var _ref10 = this.props.highlightedIndex === void 0 ? this.getState() : this.props, currentHighlightedIndex = _ref10.highlightedIndex;
      var _ref11 = prevProps.highlightedIndex === void 0 ? prevState : prevProps, prevHighlightedIndex = _ref11.highlightedIndex;
      var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
      var scrollWhenNavigating = currentHighlightedIndex !== prevHighlightedIndex;
      return scrollWhenOpen || scrollWhenNavigating;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      if (process.env.NODE_ENV !== "production") {
        validateControlledUnchanged(this.state, prevProps, this.props);
        if (this.getMenuProps.called && !this.getMenuProps.suppressRefError) {
          validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
        }
      }
      if (isControlledProp(this.props, "selectedItem") && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
        this.internalSetState({
          type: controlledPropUpdatedSelectedItem,
          inputValue: this.props.itemToString(this.props.selectedItem)
        });
      }
      if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) {
        this.scrollHighlightedItemIntoView();
      }
      {
        this.updateStatus();
      }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cleanup();
    };
    _proto.render = function render() {
      var children = unwrapArray(this.props.children, noop);
      this.clearItems();
      this.getRootProps.called = false;
      this.getRootProps.refKey = void 0;
      this.getRootProps.suppressRefError = void 0;
      this.getMenuProps.called = false;
      this.getMenuProps.refKey = void 0;
      this.getMenuProps.suppressRefError = void 0;
      this.getLabelProps.called = false;
      this.getInputProps.called = false;
      var element = unwrapArray(children(this.getStateAndHelpers()));
      if (!element) {
        return null;
      }
      if (this.getRootProps.called || this.props.suppressRefError) {
        if (process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError) {
          validateGetRootPropsCalledCorrectly(element, this.getRootProps);
        }
        return element;
      } else if (isDOMElement(element)) {
        return /* @__PURE__ */ (0, import_react44.cloneElement)(element, this.getRootProps(getElementProps(element)));
      }
      if (process.env.NODE_ENV !== "production") {
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
      }
      return void 0;
    };
    return Downshift3;
  }(import_react44.Component);
  Downshift2.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: false,
    getA11yStatusMessage: getA11yStatusMessage$1,
    itemToString: function itemToString2(i2) {
      if (i2 == null) {
        return "";
      }
      if (process.env.NODE_ENV !== "production" && isPlainObject(i2) && !i2.hasOwnProperty("toString")) {
        console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", i2);
      }
      return String(i2);
    },
    onStateChange: noop,
    onInputValueChange: noop,
    onUserAction: noop,
    onChange: noop,
    onSelect: noop,
    onOuterClick: noop,
    selectedItemChanged: function selectedItemChanged2(prevItem, item) {
      return prevItem !== item;
    },
    environment: typeof window === "undefined" ? {} : window,
    stateReducer: function stateReducer2(state, stateToSet) {
      return stateToSet;
    },
    suppressRefError: false,
    scrollIntoView
  };
  Downshift2.stateChangeTypes = stateChangeTypes$3;
  return Downshift2;
}();
process.env.NODE_ENV !== "production" ? Downshift.propTypes = {
  children: import_prop_types34.default.func,
  defaultHighlightedIndex: import_prop_types34.default.number,
  defaultIsOpen: import_prop_types34.default.bool,
  initialHighlightedIndex: import_prop_types34.default.number,
  initialSelectedItem: import_prop_types34.default.any,
  initialInputValue: import_prop_types34.default.string,
  initialIsOpen: import_prop_types34.default.bool,
  getA11yStatusMessage: import_prop_types34.default.func,
  itemToString: import_prop_types34.default.func,
  onChange: import_prop_types34.default.func,
  onSelect: import_prop_types34.default.func,
  onStateChange: import_prop_types34.default.func,
  onInputValueChange: import_prop_types34.default.func,
  onUserAction: import_prop_types34.default.func,
  onOuterClick: import_prop_types34.default.func,
  selectedItemChanged: import_prop_types34.default.func,
  stateReducer: import_prop_types34.default.func,
  itemCount: import_prop_types34.default.number,
  id: import_prop_types34.default.string,
  environment: import_prop_types34.default.shape({
    addEventListener: import_prop_types34.default.func,
    removeEventListener: import_prop_types34.default.func,
    document: import_prop_types34.default.shape({
      getElementById: import_prop_types34.default.func,
      activeElement: import_prop_types34.default.any,
      body: import_prop_types34.default.any
    })
  }),
  suppressRefError: import_prop_types34.default.bool,
  scrollIntoView: import_prop_types34.default.func,
  selectedItem: import_prop_types34.default.any,
  isOpen: import_prop_types34.default.bool,
  inputValue: import_prop_types34.default.string,
  highlightedIndex: import_prop_types34.default.number,
  labelId: import_prop_types34.default.string,
  inputId: import_prop_types34.default.string,
  menuId: import_prop_types34.default.string,
  getItemId: import_prop_types34.default.func
} : void 0;
function validateGetMenuPropsCalledCorrectly(node, _ref12) {
  var refKey = _ref12.refKey;
  if (!node) {
    console.error('downshift: The ref prop "' + refKey + '" from getMenuProps was not applied correctly on your menu element.');
  }
}
function validateGetRootPropsCalledCorrectly(element, _ref13) {
  var refKey = _ref13.refKey;
  var refKeySpecified = refKey !== "ref";
  var isComposite = !isDOMElement(element);
  if (isComposite && !refKeySpecified && !(0, import_react_is.isForwardRef)(element)) {
    console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps");
  } else if (!isComposite && refKeySpecified) {
    console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + refKey + '"');
  }
  if (!(0, import_react_is.isForwardRef)(element) && !getElementProps(element)[refKey]) {
    console.error('downshift: You must apply the ref prop "' + refKey + '" from getRootProps onto your root element.');
  }
}
var _excluded$3 = ["isInitialMount", "highlightedIndex", "items", "environment"];
var dropdownDefaultStateValues = {
  highlightedIndex: -1,
  isOpen: false,
  selectedItem: null,
  inputValue: ""
};
function callOnChangeProps(action, state, newState) {
  var props = action.props, type = action.type;
  var changes = {};
  Object.keys(state).forEach(function(key) {
    invokeOnChangeHandler(key, action, state, newState);
    if (newState[key] !== state[key]) {
      changes[key] = newState[key];
    }
  });
  if (props.onStateChange && Object.keys(changes).length) {
    props.onStateChange(_extends({
      type
    }, changes));
  }
}
function invokeOnChangeHandler(key, action, state, newState) {
  var props = action.props, type = action.type;
  var handler = "on" + capitalizeString(key) + "Change";
  if (props[handler] && newState[key] !== void 0 && newState[key] !== state[key]) {
    props[handler](_extends({
      type
    }, newState));
  }
}
function stateReducer(s, a) {
  return a.changes;
}
function getA11ySelectionMessage(selectionParameters) {
  var selectedItem = selectionParameters.selectedItem, itemToStringLocal = selectionParameters.itemToString;
  return selectedItem ? itemToStringLocal(selectedItem) + " has been selected." : "";
}
var updateA11yStatus = debounce4(function(getA11yMessage, document2) {
  setStatus(getA11yMessage(), document2);
}, 200);
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? import_react44.useLayoutEffect : import_react44.useEffect;
function useElementIds(_ref) {
  var _ref$id = _ref.id, id = _ref$id === void 0 ? "downshift-" + generateId() : _ref$id, labelId = _ref.labelId, menuId = _ref.menuId, getItemId = _ref.getItemId, toggleButtonId = _ref.toggleButtonId, inputId = _ref.inputId;
  var elementIdsRef = (0, import_react44.useRef)({
    labelId: labelId || id + "-label",
    menuId: menuId || id + "-menu",
    getItemId: getItemId || function(index) {
      return id + "-item-" + index;
    },
    toggleButtonId: toggleButtonId || id + "-toggle-button",
    inputId: inputId || id + "-input"
  });
  return elementIdsRef.current;
}
function getItemAndIndex(itemProp, indexProp, items, errorMessage) {
  var item, index;
  if (itemProp === void 0) {
    if (indexProp === void 0) {
      throw new Error(errorMessage);
    }
    item = items[indexProp];
    index = indexProp;
  } else {
    index = indexProp === void 0 ? items.indexOf(itemProp) : indexProp;
    item = itemProp;
  }
  return [item, index];
}
function itemToString(item) {
  return item ? String(item) : "";
}
function isAcceptedCharacterKey(key) {
  return /^\S{1}$/.test(key);
}
function capitalizeString(string) {
  return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}
function useLatestRef(val) {
  var ref = (0, import_react44.useRef)(val);
  ref.current = val;
  return ref;
}
function useEnhancedReducer(reducer, initialState, props) {
  var prevStateRef = (0, import_react44.useRef)();
  var actionRef = (0, import_react44.useRef)();
  var enhancedReducer = (0, import_react44.useCallback)(function(state2, action2) {
    actionRef.current = action2;
    state2 = getState(state2, action2.props);
    var changes = reducer(state2, action2);
    var newState = action2.props.stateReducer(state2, _extends({}, action2, {
      changes
    }));
    return newState;
  }, [reducer]);
  var _useReducer = (0, import_react44.useReducer)(enhancedReducer, initialState), state = _useReducer[0], dispatch = _useReducer[1];
  var propsRef = useLatestRef(props);
  var dispatchWithProps = (0, import_react44.useCallback)(function(action2) {
    return dispatch(_extends({
      props: propsRef.current
    }, action2));
  }, [propsRef]);
  var action = actionRef.current;
  (0, import_react44.useEffect)(function() {
    if (action && prevStateRef.current && prevStateRef.current !== state) {
      callOnChangeProps(action, getState(prevStateRef.current, action.props), state);
    }
    prevStateRef.current = state;
  }, [state, props, action]);
  return [state, dispatchWithProps];
}
function useControlledReducer$1(reducer, initialState, props) {
  var _useEnhancedReducer = useEnhancedReducer(reducer, initialState, props), state = _useEnhancedReducer[0], dispatch = _useEnhancedReducer[1];
  return [getState(state, props), dispatch];
}
var defaultProps$3 = {
  itemToString,
  stateReducer,
  getA11ySelectionMessage,
  scrollIntoView,
  environment: typeof window === "undefined" ? {} : window
};
function getDefaultValue$1(props, propKey, defaultStateValues2) {
  if (defaultStateValues2 === void 0) {
    defaultStateValues2 = dropdownDefaultStateValues;
  }
  var defaultValue = props["default" + capitalizeString(propKey)];
  if (defaultValue !== void 0) {
    return defaultValue;
  }
  return defaultStateValues2[propKey];
}
function getInitialValue$1(props, propKey, defaultStateValues2) {
  if (defaultStateValues2 === void 0) {
    defaultStateValues2 = dropdownDefaultStateValues;
  }
  var value = props[propKey];
  if (value !== void 0) {
    return value;
  }
  var initialValue = props["initial" + capitalizeString(propKey)];
  if (initialValue !== void 0) {
    return initialValue;
  }
  return getDefaultValue$1(props, propKey, defaultStateValues2);
}
function getInitialState$2(props) {
  var selectedItem = getInitialValue$1(props, "selectedItem");
  var isOpen = getInitialValue$1(props, "isOpen");
  var highlightedIndex = getInitialValue$1(props, "highlightedIndex");
  var inputValue = getInitialValue$1(props, "inputValue");
  return {
    highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.indexOf(selectedItem) : highlightedIndex,
    isOpen,
    selectedItem,
    inputValue
  };
}
function getHighlightedIndexOnOpen(props, state, offset) {
  var items = props.items, initialHighlightedIndex = props.initialHighlightedIndex, defaultHighlightedIndex = props.defaultHighlightedIndex;
  var selectedItem = state.selectedItem, highlightedIndex = state.highlightedIndex;
  if (items.length === 0) {
    return -1;
  }
  if (initialHighlightedIndex !== void 0 && highlightedIndex === initialHighlightedIndex) {
    return initialHighlightedIndex;
  }
  if (defaultHighlightedIndex !== void 0) {
    return defaultHighlightedIndex;
  }
  if (selectedItem) {
    return items.indexOf(selectedItem);
  }
  if (offset === 0) {
    return -1;
  }
  return offset < 0 ? items.length - 1 : 0;
}
function useMouseAndTouchTracker(isOpen, downshiftElementRefs, environment, handleBlur) {
  var mouseAndTouchTrackersRef = (0, import_react44.useRef)({
    isMouseDown: false,
    isTouchMove: false
  });
  (0, import_react44.useEffect)(function() {
    if ((environment == null ? void 0 : environment.addEventListener) == null) {
      return;
    }
    var onMouseDown = function onMouseDown2() {
      mouseAndTouchTrackersRef.current.isMouseDown = true;
    };
    var onMouseUp = function onMouseUp2(event) {
      mouseAndTouchTrackersRef.current.isMouseDown = false;
      if (isOpen && !targetWithinDownshift(event.target, downshiftElementRefs.map(function(ref) {
        return ref.current;
      }), environment)) {
        handleBlur();
      }
    };
    var onTouchStart = function onTouchStart2() {
      mouseAndTouchTrackersRef.current.isTouchMove = false;
    };
    var onTouchMove = function onTouchMove2() {
      mouseAndTouchTrackersRef.current.isTouchMove = true;
    };
    var onTouchEnd = function onTouchEnd2(event) {
      if (isOpen && !mouseAndTouchTrackersRef.current.isTouchMove && !targetWithinDownshift(event.target, downshiftElementRefs.map(function(ref) {
        return ref.current;
      }), environment, false)) {
        handleBlur();
      }
    };
    environment.addEventListener("mousedown", onMouseDown);
    environment.addEventListener("mouseup", onMouseUp);
    environment.addEventListener("touchstart", onTouchStart);
    environment.addEventListener("touchmove", onTouchMove);
    environment.addEventListener("touchend", onTouchEnd);
    return function cleanup() {
      environment.removeEventListener("mousedown", onMouseDown);
      environment.removeEventListener("mouseup", onMouseUp);
      environment.removeEventListener("touchstart", onTouchStart);
      environment.removeEventListener("touchmove", onTouchMove);
      environment.removeEventListener("touchend", onTouchEnd);
    };
  }, [isOpen, environment]);
  return mouseAndTouchTrackersRef;
}
var useGetterPropsCalledChecker = function useGetterPropsCalledChecker2() {
  return noop;
};
if (process.env.NODE_ENV !== "production") {
  useGetterPropsCalledChecker = function useGetterPropsCalledChecker3() {
    var isInitialMountRef = (0, import_react44.useRef)(true);
    for (var _len = arguments.length, propKeys = new Array(_len), _key = 0; _key < _len; _key++) {
      propKeys[_key] = arguments[_key];
    }
    var getterPropsCalledRef = (0, import_react44.useRef)(propKeys.reduce(function(acc, propKey) {
      acc[propKey] = {};
      return acc;
    }, {}));
    (0, import_react44.useEffect)(function() {
      Object.keys(getterPropsCalledRef.current).forEach(function(propKey) {
        var propCallInfo = getterPropsCalledRef.current[propKey];
        if (isInitialMountRef.current) {
          if (!Object.keys(propCallInfo).length) {
            console.error("downshift: You forgot to call the " + propKey + " getter function on your component / element.");
            return;
          }
        }
        var suppressRefError = propCallInfo.suppressRefError, refKey = propCallInfo.refKey, elementRef = propCallInfo.elementRef;
        if ((!elementRef || !elementRef.current) && !suppressRefError) {
          console.error('downshift: The ref prop "' + refKey + '" from ' + propKey + " was not applied correctly on your element.");
        }
      });
      isInitialMountRef.current = false;
    });
    var setGetterPropCallInfo = (0, import_react44.useCallback)(function(propKey, suppressRefError, refKey, elementRef) {
      getterPropsCalledRef.current[propKey] = {
        suppressRefError,
        refKey,
        elementRef
      };
    }, []);
    return setGetterPropCallInfo;
  };
}
function useA11yMessageSetter(getA11yMessage, dependencyArray, _ref2) {
  var isInitialMount = _ref2.isInitialMount, highlightedIndex = _ref2.highlightedIndex, items = _ref2.items, environment = _ref2.environment, rest = _objectWithoutPropertiesLoose(_ref2, _excluded$3);
  (0, import_react44.useEffect)(function() {
    if (isInitialMount || false) {
      return;
    }
    updateA11yStatus(function() {
      return getA11yMessage(_extends({
        highlightedIndex,
        highlightedItem: items[highlightedIndex],
        resultCount: items.length
      }, rest));
    }, environment.document);
  }, dependencyArray);
}
function useScrollIntoView(_ref3) {
  var highlightedIndex = _ref3.highlightedIndex, isOpen = _ref3.isOpen, itemRefs = _ref3.itemRefs, getItemNodeFromIndex = _ref3.getItemNodeFromIndex, menuElement = _ref3.menuElement, scrollIntoViewProp = _ref3.scrollIntoView;
  var shouldScrollRef = (0, import_react44.useRef)(true);
  useIsomorphicLayoutEffect(function() {
    if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) {
      return;
    }
    if (shouldScrollRef.current === false) {
      shouldScrollRef.current = true;
    } else {
      scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex), menuElement);
    }
  }, [highlightedIndex]);
  return shouldScrollRef;
}
var useControlPropsValidator = noop;
if (process.env.NODE_ENV !== "production") {
  useControlPropsValidator = function useControlPropsValidator2(_ref4) {
    var isInitialMount = _ref4.isInitialMount, props = _ref4.props, state = _ref4.state;
    var prevPropsRef = (0, import_react44.useRef)(props);
    (0, import_react44.useEffect)(function() {
      if (isInitialMount) {
        return;
      }
      validateControlledUnchanged(state, prevPropsRef.current, props);
      prevPropsRef.current = props;
    }, [state, props, isInitialMount]);
  };
}
function getChangesOnSelection(props, highlightedIndex, inputValue) {
  var _props$items;
  if (inputValue === void 0) {
    inputValue = true;
  }
  var shouldSelect = ((_props$items = props.items) == null ? void 0 : _props$items.length) && highlightedIndex >= 0;
  return _extends({
    isOpen: false,
    highlightedIndex: -1
  }, shouldSelect && _extends({
    selectedItem: props.items[highlightedIndex],
    isOpen: getDefaultValue$1(props, "isOpen"),
    highlightedIndex: getDefaultValue$1(props, "highlightedIndex")
  }, inputValue && {
    inputValue: props.itemToString(props.items[highlightedIndex])
  }));
}
function downshiftCommonReducer(state, action, stateChangeTypes2) {
  var type = action.type, props = action.props;
  var changes;
  switch (type) {
    case stateChangeTypes2.ItemMouseMove:
      changes = {
        highlightedIndex: action.disabled ? -1 : action.index
      };
      break;
    case stateChangeTypes2.MenuMouseLeave:
      changes = {
        highlightedIndex: -1
      };
      break;
    case stateChangeTypes2.ToggleButtonClick:
    case stateChangeTypes2.FunctionToggleMenu:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case stateChangeTypes2.FunctionOpenMenu:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case stateChangeTypes2.FunctionCloseMenu:
      changes = {
        isOpen: false
      };
      break;
    case stateChangeTypes2.FunctionSetHighlightedIndex:
      changes = {
        highlightedIndex: action.highlightedIndex
      };
      break;
    case stateChangeTypes2.FunctionSetInputValue:
      changes = {
        inputValue: action.inputValue
      };
      break;
    case stateChangeTypes2.FunctionReset:
      changes = {
        highlightedIndex: getDefaultValue$1(props, "highlightedIndex"),
        isOpen: getDefaultValue$1(props, "isOpen"),
        selectedItem: getDefaultValue$1(props, "selectedItem"),
        inputValue: getDefaultValue$1(props, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return _extends({}, state, changes);
}
function getItemIndexByCharacterKey(_a) {
  var keysSoFar = _a.keysSoFar, highlightedIndex = _a.highlightedIndex, items = _a.items, itemToString2 = _a.itemToString, getItemNodeFromIndex = _a.getItemNodeFromIndex;
  var lowerCasedKeysSoFar = keysSoFar.toLowerCase();
  for (var index = 0; index < items.length; index++) {
    var offsetIndex = (index + highlightedIndex + (keysSoFar.length < 2 ? 1 : 0)) % items.length;
    var item = items[offsetIndex];
    if (item !== void 0 && itemToString2(item).toLowerCase().startsWith(lowerCasedKeysSoFar)) {
      var element = getItemNodeFromIndex(offsetIndex);
      if (!(element === null || element === void 0 ? void 0 : element.hasAttribute("disabled"))) {
        return offsetIndex;
      }
    }
  }
  return highlightedIndex;
}
var propTypes$2 = {
  items: import_prop_types34.default.array.isRequired,
  itemToString: import_prop_types34.default.func,
  getA11yStatusMessage: import_prop_types34.default.func,
  getA11ySelectionMessage: import_prop_types34.default.func,
  highlightedIndex: import_prop_types34.default.number,
  defaultHighlightedIndex: import_prop_types34.default.number,
  initialHighlightedIndex: import_prop_types34.default.number,
  isOpen: import_prop_types34.default.bool,
  defaultIsOpen: import_prop_types34.default.bool,
  initialIsOpen: import_prop_types34.default.bool,
  selectedItem: import_prop_types34.default.any,
  initialSelectedItem: import_prop_types34.default.any,
  defaultSelectedItem: import_prop_types34.default.any,
  id: import_prop_types34.default.string,
  labelId: import_prop_types34.default.string,
  menuId: import_prop_types34.default.string,
  getItemId: import_prop_types34.default.func,
  toggleButtonId: import_prop_types34.default.string,
  stateReducer: import_prop_types34.default.func,
  onSelectedItemChange: import_prop_types34.default.func,
  onHighlightedIndexChange: import_prop_types34.default.func,
  onStateChange: import_prop_types34.default.func,
  onIsOpenChange: import_prop_types34.default.func,
  environment: import_prop_types34.default.shape({
    addEventListener: import_prop_types34.default.func,
    removeEventListener: import_prop_types34.default.func,
    document: import_prop_types34.default.shape({
      getElementById: import_prop_types34.default.func,
      activeElement: import_prop_types34.default.any,
      body: import_prop_types34.default.any
    })
  })
};
function getA11yStatusMessage(_a) {
  var isOpen = _a.isOpen, resultCount = _a.resultCount, previousResultCount = _a.previousResultCount;
  if (!isOpen) {
    return "";
  }
  if (!resultCount) {
    return "No results are available.";
  }
  if (resultCount !== previousResultCount) {
    return "".concat(resultCount, " result").concat(resultCount === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.");
  }
  return "";
}
var defaultProps$2 = __assign(__assign({}, defaultProps$3), { getA11yStatusMessage });
var validatePropTypes$2 = noop;
if (process.env.NODE_ENV !== "production") {
  validatePropTypes$2 = function(options, caller) {
    import_prop_types34.default.checkPropTypes(propTypes$2, options, "prop", caller.name);
  };
}
var ToggleButtonClick$1 = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 0;
var ToggleButtonKeyDownArrowDown = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_down__" : 1;
var ToggleButtonKeyDownArrowUp = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_up__" : 2;
var ToggleButtonKeyDownCharacter = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_character__" : 3;
var ToggleButtonKeyDownEscape = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_escape__" : 4;
var ToggleButtonKeyDownHome = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_home__" : 5;
var ToggleButtonKeyDownEnd = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_end__" : 6;
var ToggleButtonKeyDownEnter = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_enter__" : 7;
var ToggleButtonKeyDownSpaceButton = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_space_button__" : 8;
var ToggleButtonKeyDownPageUp = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_up__" : 9;
var ToggleButtonKeyDownPageDown = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_down__" : 10;
var ToggleButtonBlur = process.env.NODE_ENV !== "production" ? "__togglebutton_blur__" : 11;
var MenuMouseLeave$1 = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 12;
var ItemMouseMove$1 = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 13;
var ItemClick$1 = process.env.NODE_ENV !== "production" ? "__item_click__" : 14;
var FunctionToggleMenu$1 = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15;
var FunctionOpenMenu$1 = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16;
var FunctionCloseMenu$1 = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17;
var FunctionSetHighlightedIndex$1 = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18;
var FunctionSelectItem$1 = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19;
var FunctionSetInputValue$1 = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20;
var FunctionReset$2 = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21;
var stateChangeTypes$2 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ToggleButtonClick: ToggleButtonClick$1,
  ToggleButtonKeyDownArrowDown,
  ToggleButtonKeyDownArrowUp,
  ToggleButtonKeyDownCharacter,
  ToggleButtonKeyDownEscape,
  ToggleButtonKeyDownHome,
  ToggleButtonKeyDownEnd,
  ToggleButtonKeyDownEnter,
  ToggleButtonKeyDownSpaceButton,
  ToggleButtonKeyDownPageUp,
  ToggleButtonKeyDownPageDown,
  ToggleButtonBlur,
  MenuMouseLeave: MenuMouseLeave$1,
  ItemMouseMove: ItemMouseMove$1,
  ItemClick: ItemClick$1,
  FunctionToggleMenu: FunctionToggleMenu$1,
  FunctionOpenMenu: FunctionOpenMenu$1,
  FunctionCloseMenu: FunctionCloseMenu$1,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex$1,
  FunctionSelectItem: FunctionSelectItem$1,
  FunctionSetInputValue: FunctionSetInputValue$1,
  FunctionReset: FunctionReset$2
});
function downshiftSelectReducer(state, action) {
  var _props$items;
  var type = action.type, props = action.props, altKey = action.altKey;
  var changes;
  switch (type) {
    case ItemClick$1:
      changes = {
        isOpen: getDefaultValue$1(props, "isOpen"),
        highlightedIndex: getDefaultValue$1(props, "highlightedIndex"),
        selectedItem: props.items[action.index]
      };
      break;
    case ToggleButtonKeyDownCharacter:
      {
        var lowercasedKey = action.key;
        var inputValue = "" + state.inputValue + lowercasedKey;
        var prevHighlightedIndex = !state.isOpen && state.selectedItem ? props.items.indexOf(state.selectedItem) : state.highlightedIndex;
        var highlightedIndex = getItemIndexByCharacterKey({
          keysSoFar: inputValue,
          highlightedIndex: prevHighlightedIndex,
          items: props.items,
          itemToString: props.itemToString,
          getItemNodeFromIndex: action.getItemNodeFromIndex
        });
        changes = {
          inputValue,
          highlightedIndex,
          isOpen: true
        };
      }
      break;
    case ToggleButtonKeyDownArrowDown:
      {
        var _highlightedIndex = state.isOpen ? getNextWrappingIndex(1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false) : altKey && state.selectedItem == null ? -1 : getHighlightedIndexOnOpen(props, state, 1);
        changes = {
          highlightedIndex: _highlightedIndex,
          isOpen: true
        };
      }
      break;
    case ToggleButtonKeyDownArrowUp:
      if (state.isOpen && altKey) {
        changes = getChangesOnSelection(props, state.highlightedIndex, false);
      } else {
        var _highlightedIndex2 = state.isOpen ? getNextWrappingIndex(-1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false) : getHighlightedIndexOnOpen(props, state, -1);
        changes = {
          highlightedIndex: _highlightedIndex2,
          isOpen: true
        };
      }
      break;
    case ToggleButtonKeyDownEnter:
    case ToggleButtonKeyDownSpaceButton:
      changes = getChangesOnSelection(props, state.highlightedIndex, false);
      break;
    case ToggleButtonKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false),
        isOpen: true
      };
      break;
    case ToggleButtonKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false),
        isOpen: true
      };
      break;
    case ToggleButtonKeyDownPageUp:
      changes = {
        highlightedIndex: getNextWrappingIndex(-10, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case ToggleButtonKeyDownPageDown:
      changes = {
        highlightedIndex: getNextWrappingIndex(10, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case ToggleButtonKeyDownEscape:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;
    case ToggleButtonBlur:
      changes = _extends({
        isOpen: false,
        highlightedIndex: -1
      }, state.highlightedIndex >= 0 && ((_props$items = props.items) == null ? void 0 : _props$items.length) && {
        selectedItem: props.items[state.highlightedIndex]
      });
      break;
    case FunctionSelectItem$1:
      changes = {
        selectedItem: action.selectedItem
      };
      break;
    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$2);
  }
  return _extends({}, state, changes);
}
var _excluded$2 = ["onMouseLeave", "refKey", "onKeyDown", "onBlur", "ref"];
var _excluded2$2 = ["onBlur", "onClick", "onPress", "onKeyDown", "refKey", "ref"];
var _excluded3$1 = ["item", "index", "onMouseMove", "onClick", "onPress", "refKey", "ref", "disabled"];
useSelect.stateChangeTypes = stateChangeTypes$2;
function useSelect(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }
  validatePropTypes$2(userProps, useSelect);
  var props = _extends({}, defaultProps$2, userProps);
  var items = props.items, scrollIntoView2 = props.scrollIntoView, environment = props.environment, itemToString2 = props.itemToString, getA11ySelectionMessage2 = props.getA11ySelectionMessage, getA11yStatusMessage2 = props.getA11yStatusMessage;
  var initialState = getInitialState$2(props);
  var _useControlledReducer = useControlledReducer$1(downshiftSelectReducer, initialState, props), state = _useControlledReducer[0], dispatch = _useControlledReducer[1];
  var isOpen = state.isOpen, highlightedIndex = state.highlightedIndex, selectedItem = state.selectedItem, inputValue = state.inputValue;
  var toggleButtonRef = (0, import_react44.useRef)(null);
  var menuRef = (0, import_react44.useRef)(null);
  var itemRefs = (0, import_react44.useRef)({});
  var clearTimeoutRef = (0, import_react44.useRef)(null);
  var elementIds = useElementIds(props);
  var previousResultCountRef = (0, import_react44.useRef)();
  var isInitialMountRef = (0, import_react44.useRef)(true);
  var latest = useLatestRef({
    state,
    props
  });
  var getItemNodeFromIndex = (0, import_react44.useCallback)(function(index) {
    return itemRefs.current[elementIds.getItemId(index)];
  }, [elementIds]);
  useA11yMessageSetter(getA11yStatusMessage2, [isOpen, highlightedIndex, inputValue, items], _extends({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items,
    environment,
    itemToString: itemToString2
  }, state));
  useA11yMessageSetter(getA11ySelectionMessage2, [selectedItem], _extends({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items,
    environment,
    itemToString: itemToString2
  }, state));
  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex,
    isOpen,
    itemRefs,
    scrollIntoView: scrollIntoView2,
    getItemNodeFromIndex
  });
  (0, import_react44.useEffect)(function() {
    clearTimeoutRef.current = debounce4(function(outerDispatch) {
      outerDispatch({
        type: FunctionSetInputValue$1,
        inputValue: ""
      });
    }, 500);
    return function() {
      clearTimeoutRef.current.cancel();
    };
  }, []);
  (0, import_react44.useEffect)(function() {
    if (!inputValue) {
      return;
    }
    clearTimeoutRef.current(dispatch);
  }, [dispatch, inputValue]);
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props,
    state
  });
  (0, import_react44.useEffect)(function() {
    if (isInitialMountRef.current) {
      return;
    }
    previousResultCountRef.current = items.length;
  });
  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [menuRef, toggleButtonRef], environment, function() {
    dispatch({
      type: ToggleButtonBlur
    });
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker("getMenuProps", "getToggleButtonProps");
  (0, import_react44.useEffect)(function() {
    isInitialMountRef.current = false;
    return function() {
      isInitialMountRef.current = true;
    };
  }, []);
  (0, import_react44.useEffect)(function() {
    if (!isOpen) {
      itemRefs.current = {};
    }
  }, [isOpen]);
  var toggleButtonKeyDownHandlers = (0, import_react44.useMemo)(function() {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownArrowDown,
          getItemNodeFromIndex,
          altKey: event.altKey
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownArrowUp,
          getItemNodeFromIndex,
          altKey: event.altKey
        });
      },
      Home: function Home(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownHome,
          getItemNodeFromIndex
        });
      },
      End: function End(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownEnd,
          getItemNodeFromIndex
        });
      },
      Escape: function Escape() {
        if (latest.current.state.isOpen) {
          dispatch({
            type: ToggleButtonKeyDownEscape
          });
        }
      },
      Enter: function Enter(event) {
        event.preventDefault();
        dispatch({
          type: latest.current.state.isOpen ? ToggleButtonKeyDownEnter : ToggleButtonClick$1
        });
      },
      PageUp: function PageUp(event) {
        if (latest.current.state.isOpen) {
          event.preventDefault();
          dispatch({
            type: ToggleButtonKeyDownPageUp,
            getItemNodeFromIndex
          });
        }
      },
      PageDown: function PageDown(event) {
        if (latest.current.state.isOpen) {
          event.preventDefault();
          dispatch({
            type: ToggleButtonKeyDownPageDown,
            getItemNodeFromIndex
          });
        }
      },
      " ": function _(event) {
        event.preventDefault();
        var currentState = latest.current.state;
        if (!currentState.isOpen) {
          dispatch({
            type: ToggleButtonClick$1
          });
          return;
        }
        if (currentState.inputValue) {
          dispatch({
            type: ToggleButtonKeyDownCharacter,
            key: " ",
            getItemNodeFromIndex
          });
        } else {
          dispatch({
            type: ToggleButtonKeyDownSpaceButton
          });
        }
      }
    };
  }, [dispatch, getItemNodeFromIndex, latest]);
  var toggleMenu = (0, import_react44.useCallback)(function() {
    dispatch({
      type: FunctionToggleMenu$1
    });
  }, [dispatch]);
  var closeMenu = (0, import_react44.useCallback)(function() {
    dispatch({
      type: FunctionCloseMenu$1
    });
  }, [dispatch]);
  var openMenu = (0, import_react44.useCallback)(function() {
    dispatch({
      type: FunctionOpenMenu$1
    });
  }, [dispatch]);
  var setHighlightedIndex = (0, import_react44.useCallback)(function(newHighlightedIndex) {
    dispatch({
      type: FunctionSetHighlightedIndex$1,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch]);
  var selectItem = (0, import_react44.useCallback)(function(newSelectedItem) {
    dispatch({
      type: FunctionSelectItem$1,
      selectedItem: newSelectedItem
    });
  }, [dispatch]);
  var reset = (0, import_react44.useCallback)(function() {
    dispatch({
      type: FunctionReset$2
    });
  }, [dispatch]);
  var setInputValue = (0, import_react44.useCallback)(function(newInputValue) {
    dispatch({
      type: FunctionSetInputValue$1,
      inputValue: newInputValue
    });
  }, [dispatch]);
  var getLabelProps = (0, import_react44.useCallback)(function(labelProps) {
    return _extends({
      id: elementIds.labelId,
      htmlFor: elementIds.toggleButtonId
    }, labelProps);
  }, [elementIds]);
  var getMenuProps = (0, import_react44.useCallback)(function(_temp, _temp2) {
    var _extends2;
    var _ref = _temp === void 0 ? {} : _temp, onMouseLeave = _ref.onMouseLeave, _ref$refKey = _ref.refKey, refKey = _ref$refKey === void 0 ? "ref" : _ref$refKey;
    _ref.onKeyDown;
    _ref.onBlur;
    var ref = _ref.ref, rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
    var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$suppressRefErro = _ref2.suppressRefError, suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
    var menuHandleMouseLeave = function menuHandleMouseLeave2() {
      dispatch({
        type: MenuMouseLeave$1
      });
    };
    setGetterPropCallInfo("getMenuProps", suppressRefError, refKey, menuRef);
    return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function(menuNode) {
      menuRef.current = menuNode;
    }), _extends2.id = elementIds.menuId, _extends2.role = "listbox", _extends2["aria-labelledby"] = rest && rest["aria-label"] ? void 0 : "" + elementIds.labelId, _extends2.onMouseLeave = callAllEventHandlers(onMouseLeave, menuHandleMouseLeave), _extends2), rest);
  }, [dispatch, setGetterPropCallInfo, elementIds]);
  var getToggleButtonProps = (0, import_react44.useCallback)(function(_temp3, _temp4) {
    var _extends3;
    var _ref3 = _temp3 === void 0 ? {} : _temp3, onBlur = _ref3.onBlur, onClick = _ref3.onClick;
    _ref3.onPress;
    var onKeyDown = _ref3.onKeyDown, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, ref = _ref3.ref, rest = _objectWithoutPropertiesLoose(_ref3, _excluded2$2);
    var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$suppressRefErro = _ref4.suppressRefError, suppressRefError = _ref4$suppressRefErro === void 0 ? false : _ref4$suppressRefErro;
    var latestState = latest.current.state;
    var toggleButtonHandleClick = function toggleButtonHandleClick2() {
      dispatch({
        type: ToggleButtonClick$1
      });
    };
    var toggleButtonHandleBlur = function toggleButtonHandleBlur2() {
      if (latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown) {
        dispatch({
          type: ToggleButtonBlur
        });
      }
    };
    var toggleButtonHandleKeyDown = function toggleButtonHandleKeyDown2(event) {
      var key = normalizeArrowKey(event);
      if (key && toggleButtonKeyDownHandlers[key]) {
        toggleButtonKeyDownHandlers[key](event);
      } else if (isAcceptedCharacterKey(key)) {
        dispatch({
          type: ToggleButtonKeyDownCharacter,
          key,
          getItemNodeFromIndex
        });
      }
    };
    var toggleProps = _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function(toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    }), _extends3["aria-activedescendant"] = latestState.isOpen && latestState.highlightedIndex > -1 ? elementIds.getItemId(latestState.highlightedIndex) : "", _extends3["aria-controls"] = elementIds.menuId, _extends3["aria-expanded"] = latest.current.state.isOpen, _extends3["aria-haspopup"] = "listbox", _extends3["aria-labelledby"] = rest && rest["aria-label"] ? void 0 : "" + elementIds.labelId, _extends3.id = elementIds.toggleButtonId, _extends3.role = "combobox", _extends3.tabIndex = 0, _extends3.onBlur = callAllEventHandlers(onBlur, toggleButtonHandleBlur), _extends3), rest);
    if (!rest.disabled) {
      {
        toggleProps.onClick = callAllEventHandlers(onClick, toggleButtonHandleClick);
        toggleProps.onKeyDown = callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
      }
    }
    setGetterPropCallInfo("getToggleButtonProps", suppressRefError, refKey, toggleButtonRef);
    return toggleProps;
  }, [latest, elementIds, setGetterPropCallInfo, dispatch, mouseAndTouchTrackersRef, toggleButtonKeyDownHandlers, getItemNodeFromIndex]);
  var getItemProps = (0, import_react44.useCallback)(function(_temp5) {
    var _extends4;
    var _ref5 = _temp5 === void 0 ? {} : _temp5, itemProp = _ref5.item, indexProp = _ref5.index, onMouseMove = _ref5.onMouseMove, onClick = _ref5.onClick;
    _ref5.onPress;
    var _ref5$refKey = _ref5.refKey, refKey = _ref5$refKey === void 0 ? "ref" : _ref5$refKey, ref = _ref5.ref, disabled = _ref5.disabled, rest = _objectWithoutPropertiesLoose(_ref5, _excluded3$1);
    var _latest$current = latest.current, latestState = _latest$current.state, latestProps = _latest$current.props;
    var _getItemAndIndex = getItemAndIndex(itemProp, indexProp, latestProps.items, "Pass either item or index to getItemProps!"), item = _getItemAndIndex[0], index = _getItemAndIndex[1];
    var itemHandleMouseMove = function itemHandleMouseMove2() {
      if (index === latestState.highlightedIndex) {
        return;
      }
      shouldScrollRef.current = false;
      dispatch({
        type: ItemMouseMove$1,
        index,
        disabled
      });
    };
    var itemHandleClick = function itemHandleClick2() {
      dispatch({
        type: ItemClick$1,
        index
      });
    };
    var itemProps = _extends((_extends4 = {
      disabled,
      role: "option",
      "aria-selected": "" + (item === selectedItem),
      id: elementIds.getItemId(index)
    }, _extends4[refKey] = handleRefs(ref, function(itemNode) {
      if (itemNode) {
        itemRefs.current[elementIds.getItemId(index)] = itemNode;
      }
    }), _extends4), rest);
    if (!disabled) {
      {
        itemProps.onClick = callAllEventHandlers(onClick, itemHandleClick);
      }
    }
    itemProps.onMouseMove = callAllEventHandlers(onMouseMove, itemHandleMouseMove);
    return itemProps;
  }, [latest, selectedItem, elementIds, shouldScrollRef, dispatch]);
  return {
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    getItemProps,
    toggleMenu,
    openMenu,
    closeMenu,
    setHighlightedIndex,
    selectItem,
    reset,
    setInputValue,
    highlightedIndex,
    isOpen,
    selectedItem,
    inputValue
  };
}
var InputKeyDownArrowDown = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0;
var InputKeyDownArrowUp = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1;
var InputKeyDownEscape = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2;
var InputKeyDownHome = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3;
var InputKeyDownEnd = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4;
var InputKeyDownPageUp = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5;
var InputKeyDownPageDown = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6;
var InputKeyDownEnter = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7;
var InputChange = process.env.NODE_ENV !== "production" ? "__input_change__" : 8;
var InputBlur = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9;
var InputFocus = process.env.NODE_ENV !== "production" ? "__input_focus__" : 10;
var MenuMouseLeave = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11;
var ItemMouseMove = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12;
var ItemClick = process.env.NODE_ENV !== "production" ? "__item_click__" : 13;
var ToggleButtonClick = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14;
var FunctionToggleMenu = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15;
var FunctionOpenMenu = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16;
var FunctionCloseMenu = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17;
var FunctionSetHighlightedIndex = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18;
var FunctionSelectItem = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19;
var FunctionSetInputValue = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20;
var FunctionReset$1 = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21;
var ControlledPropUpdatedSelectedItem = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22;
var stateChangeTypes$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown,
  InputKeyDownArrowUp,
  InputKeyDownEscape,
  InputKeyDownHome,
  InputKeyDownEnd,
  InputKeyDownPageUp,
  InputKeyDownPageDown,
  InputKeyDownEnter,
  InputChange,
  InputBlur,
  InputFocus,
  MenuMouseLeave,
  ItemMouseMove,
  ItemClick,
  ToggleButtonClick,
  FunctionToggleMenu,
  FunctionOpenMenu,
  FunctionCloseMenu,
  FunctionSetHighlightedIndex,
  FunctionSelectItem,
  FunctionSetInputValue,
  FunctionReset: FunctionReset$1,
  ControlledPropUpdatedSelectedItem
});
function getInitialState$1(props) {
  var initialState = getInitialState$2(props);
  var selectedItem = initialState.selectedItem;
  var inputValue = initialState.inputValue;
  if (inputValue === "" && selectedItem && props.defaultInputValue === void 0 && props.initialInputValue === void 0 && props.inputValue === void 0) {
    inputValue = props.itemToString(selectedItem);
  }
  return _extends({}, initialState, {
    inputValue
  });
}
var propTypes$1 = {
  items: import_prop_types34.default.array.isRequired,
  itemToString: import_prop_types34.default.func,
  selectedItemChanged: import_prop_types34.default.func,
  getA11yStatusMessage: import_prop_types34.default.func,
  getA11ySelectionMessage: import_prop_types34.default.func,
  highlightedIndex: import_prop_types34.default.number,
  defaultHighlightedIndex: import_prop_types34.default.number,
  initialHighlightedIndex: import_prop_types34.default.number,
  isOpen: import_prop_types34.default.bool,
  defaultIsOpen: import_prop_types34.default.bool,
  initialIsOpen: import_prop_types34.default.bool,
  selectedItem: import_prop_types34.default.any,
  initialSelectedItem: import_prop_types34.default.any,
  defaultSelectedItem: import_prop_types34.default.any,
  inputValue: import_prop_types34.default.string,
  defaultInputValue: import_prop_types34.default.string,
  initialInputValue: import_prop_types34.default.string,
  id: import_prop_types34.default.string,
  labelId: import_prop_types34.default.string,
  menuId: import_prop_types34.default.string,
  getItemId: import_prop_types34.default.func,
  inputId: import_prop_types34.default.string,
  toggleButtonId: import_prop_types34.default.string,
  stateReducer: import_prop_types34.default.func,
  onSelectedItemChange: import_prop_types34.default.func,
  onHighlightedIndexChange: import_prop_types34.default.func,
  onStateChange: import_prop_types34.default.func,
  onIsOpenChange: import_prop_types34.default.func,
  onInputValueChange: import_prop_types34.default.func,
  environment: import_prop_types34.default.shape({
    addEventListener: import_prop_types34.default.func,
    removeEventListener: import_prop_types34.default.func,
    document: import_prop_types34.default.shape({
      getElementById: import_prop_types34.default.func,
      activeElement: import_prop_types34.default.any,
      body: import_prop_types34.default.any
    })
  })
};
function useControlledReducer(reducer, initialState, props) {
  var previousSelectedItemRef = (0, import_react44.useRef)();
  var _useEnhancedReducer = useEnhancedReducer(reducer, initialState, props), state = _useEnhancedReducer[0], dispatch = _useEnhancedReducer[1];
  (0, import_react44.useEffect)(function() {
    if (!isControlledProp(props, "selectedItem")) {
      return;
    }
    if (props.selectedItemChanged(previousSelectedItemRef.current, props.selectedItem)) {
      dispatch({
        type: ControlledPropUpdatedSelectedItem,
        inputValue: props.itemToString(props.selectedItem)
      });
    }
    previousSelectedItemRef.current = state.selectedItem === previousSelectedItemRef.current ? props.selectedItem : state.selectedItem;
  }, [state.selectedItem, props.selectedItem]);
  return [getState(state, props), dispatch];
}
var validatePropTypes$1 = noop;
if (process.env.NODE_ENV !== "production") {
  validatePropTypes$1 = function validatePropTypes2(options, caller) {
    import_prop_types34.default.checkPropTypes(propTypes$1, options, "prop", caller.name);
  };
}
var defaultProps$1 = _extends({}, defaultProps$3, {
  selectedItemChanged: function selectedItemChanged(prevItem, item) {
    return prevItem !== item;
  },
  getA11yStatusMessage: getA11yStatusMessage$1
});
function downshiftUseComboboxReducer(state, action) {
  var _props$items;
  var type = action.type, props = action.props, altKey = action.altKey;
  var changes;
  switch (type) {
    case ItemClick:
      changes = {
        isOpen: getDefaultValue$1(props, "isOpen"),
        highlightedIndex: getDefaultValue$1(props, "highlightedIndex"),
        selectedItem: props.items[action.index],
        inputValue: props.itemToString(props.items[action.index])
      };
      break;
    case InputKeyDownArrowDown:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getNextWrappingIndex(1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, true)
        };
      } else {
        changes = {
          highlightedIndex: altKey && state.selectedItem == null ? -1 : getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
          isOpen: props.items.length >= 0
        };
      }
      break;
    case InputKeyDownArrowUp:
      if (state.isOpen) {
        if (altKey) {
          changes = getChangesOnSelection(props, state.highlightedIndex);
        } else {
          changes = {
            highlightedIndex: getNextWrappingIndex(-1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, true)
          };
        }
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
          isOpen: props.items.length >= 0
        };
      }
      break;
    case InputKeyDownEnter:
      changes = getChangesOnSelection(props, state.highlightedIndex);
      break;
    case InputKeyDownEscape:
      changes = _extends({
        isOpen: false,
        highlightedIndex: -1
      }, !state.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case InputKeyDownPageUp:
      changes = {
        highlightedIndex: getNextWrappingIndex(-10, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case InputKeyDownPageDown:
      changes = {
        highlightedIndex: getNextWrappingIndex(10, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case InputKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case InputKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case InputBlur:
      changes = _extends({
        isOpen: false,
        highlightedIndex: -1
      }, state.highlightedIndex >= 0 && ((_props$items = props.items) == null ? void 0 : _props$items.length) && action.selectItem && {
        selectedItem: props.items[state.highlightedIndex],
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;
    case InputChange:
      changes = {
        isOpen: true,
        highlightedIndex: getDefaultValue$1(props, "highlightedIndex"),
        inputValue: action.inputValue
      };
      break;
    case InputFocus:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case FunctionSelectItem:
      changes = {
        selectedItem: action.selectedItem,
        inputValue: props.itemToString(action.selectedItem)
      };
      break;
    case ControlledPropUpdatedSelectedItem:
      changes = {
        inputValue: action.inputValue
      };
      break;
    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$1);
  }
  return _extends({}, state, changes);
}
var _excluded$1 = ["onMouseLeave", "refKey", "ref"];
var _excluded2$1 = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"];
var _excluded3 = ["onClick", "onPress", "refKey", "ref"];
var _excluded4 = ["onKeyDown", "onChange", "onInput", "onFocus", "onBlur", "onChangeText", "refKey", "ref"];
useCombobox.stateChangeTypes = stateChangeTypes$1;
function useCombobox(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }
  validatePropTypes$1(userProps, useCombobox);
  var props = _extends({}, defaultProps$1, userProps);
  var initialIsOpen = props.initialIsOpen, defaultIsOpen = props.defaultIsOpen, items = props.items, scrollIntoView2 = props.scrollIntoView, environment = props.environment, getA11yStatusMessage2 = props.getA11yStatusMessage, getA11ySelectionMessage2 = props.getA11ySelectionMessage, itemToString2 = props.itemToString;
  var initialState = getInitialState$1(props);
  var _useControlledReducer = useControlledReducer(downshiftUseComboboxReducer, initialState, props), state = _useControlledReducer[0], dispatch = _useControlledReducer[1];
  var isOpen = state.isOpen, highlightedIndex = state.highlightedIndex, selectedItem = state.selectedItem, inputValue = state.inputValue;
  var menuRef = (0, import_react44.useRef)(null);
  var itemRefs = (0, import_react44.useRef)({});
  var inputRef = (0, import_react44.useRef)(null);
  var toggleButtonRef = (0, import_react44.useRef)(null);
  var isInitialMountRef = (0, import_react44.useRef)(true);
  var elementIds = useElementIds(props);
  var previousResultCountRef = (0, import_react44.useRef)();
  var latest = useLatestRef({
    state,
    props
  });
  var getItemNodeFromIndex = (0, import_react44.useCallback)(function(index) {
    return itemRefs.current[elementIds.getItemId(index)];
  }, [elementIds]);
  useA11yMessageSetter(getA11yStatusMessage2, [isOpen, highlightedIndex, inputValue, items], _extends({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items,
    environment,
    itemToString: itemToString2
  }, state));
  useA11yMessageSetter(getA11ySelectionMessage2, [selectedItem], _extends({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items,
    environment,
    itemToString: itemToString2
  }, state));
  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex,
    isOpen,
    itemRefs,
    scrollIntoView: scrollIntoView2,
    getItemNodeFromIndex
  });
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props,
    state
  });
  (0, import_react44.useEffect)(function() {
    var focusOnOpen = initialIsOpen || defaultIsOpen || isOpen;
    if (focusOnOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  (0, import_react44.useEffect)(function() {
    if (isInitialMountRef.current) {
      return;
    }
    previousResultCountRef.current = items.length;
  });
  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [inputRef, menuRef, toggleButtonRef], environment, function() {
    dispatch({
      type: InputBlur,
      selectItem: false
    });
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker("getInputProps", "getMenuProps");
  (0, import_react44.useEffect)(function() {
    isInitialMountRef.current = false;
    return function() {
      isInitialMountRef.current = true;
    };
  }, []);
  (0, import_react44.useEffect)(function() {
    var _environment$document;
    if (!isOpen) {
      itemRefs.current = {};
    } else if (((_environment$document = environment.document) == null ? void 0 : _environment$document.activeElement) !== inputRef.current) {
      var _inputRef$current;
      inputRef == null || (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.focus();
    }
  }, [isOpen, environment]);
  var inputKeyDownHandlers = (0, import_react44.useMemo)(function() {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownArrowDown,
          altKey: event.altKey,
          getItemNodeFromIndex
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownArrowUp,
          altKey: event.altKey,
          getItemNodeFromIndex
        });
      },
      Home: function Home(event) {
        if (!latest.current.state.isOpen) {
          return;
        }
        event.preventDefault();
        dispatch({
          type: InputKeyDownHome,
          getItemNodeFromIndex
        });
      },
      End: function End(event) {
        if (!latest.current.state.isOpen) {
          return;
        }
        event.preventDefault();
        dispatch({
          type: InputKeyDownEnd,
          getItemNodeFromIndex
        });
      },
      Escape: function Escape(event) {
        var latestState = latest.current.state;
        if (latestState.isOpen || latestState.inputValue || latestState.selectedItem || latestState.highlightedIndex > -1) {
          event.preventDefault();
          dispatch({
            type: InputKeyDownEscape
          });
        }
      },
      Enter: function Enter(event) {
        var latestState = latest.current.state;
        if (!latestState.isOpen || event.which === 229) {
          return;
        }
        event.preventDefault();
        dispatch({
          type: InputKeyDownEnter,
          getItemNodeFromIndex
        });
      },
      PageUp: function PageUp(event) {
        if (latest.current.state.isOpen) {
          event.preventDefault();
          dispatch({
            type: InputKeyDownPageUp,
            getItemNodeFromIndex
          });
        }
      },
      PageDown: function PageDown(event) {
        if (latest.current.state.isOpen) {
          event.preventDefault();
          dispatch({
            type: InputKeyDownPageDown,
            getItemNodeFromIndex
          });
        }
      }
    };
  }, [dispatch, latest, getItemNodeFromIndex]);
  var getLabelProps = (0, import_react44.useCallback)(function(labelProps) {
    return _extends({
      id: elementIds.labelId,
      htmlFor: elementIds.inputId
    }, labelProps);
  }, [elementIds]);
  var getMenuProps = (0, import_react44.useCallback)(function(_temp, _temp2) {
    var _extends2;
    var _ref = _temp === void 0 ? {} : _temp, onMouseLeave = _ref.onMouseLeave, _ref$refKey = _ref.refKey, refKey = _ref$refKey === void 0 ? "ref" : _ref$refKey, ref = _ref.ref, rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
    var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$suppressRefErro = _ref2.suppressRefError, suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
    setGetterPropCallInfo("getMenuProps", suppressRefError, refKey, menuRef);
    return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function(menuNode) {
      menuRef.current = menuNode;
    }), _extends2.id = elementIds.menuId, _extends2.role = "listbox", _extends2["aria-labelledby"] = rest && rest["aria-label"] ? void 0 : "" + elementIds.labelId, _extends2.onMouseLeave = callAllEventHandlers(onMouseLeave, function() {
      dispatch({
        type: MenuMouseLeave
      });
    }), _extends2), rest);
  }, [dispatch, setGetterPropCallInfo, elementIds]);
  var getItemProps = (0, import_react44.useCallback)(function(_temp3) {
    var _extends3, _ref4;
    var _ref3 = _temp3 === void 0 ? {} : _temp3, itemProp = _ref3.item, indexProp = _ref3.index, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, ref = _ref3.ref, onMouseMove = _ref3.onMouseMove, onMouseDown = _ref3.onMouseDown, onClick = _ref3.onClick;
    _ref3.onPress;
    var disabled = _ref3.disabled, rest = _objectWithoutPropertiesLoose(_ref3, _excluded2$1);
    var _latest$current = latest.current, latestProps = _latest$current.props, latestState = _latest$current.state;
    var _getItemAndIndex = getItemAndIndex(itemProp, indexProp, latestProps.items, "Pass either item or index to getItemProps!"), index = _getItemAndIndex[1];
    var onSelectKey = "onClick";
    var customClickHandler = onClick;
    var itemHandleMouseMove = function itemHandleMouseMove2() {
      if (index === latestState.highlightedIndex) {
        return;
      }
      shouldScrollRef.current = false;
      dispatch({
        type: ItemMouseMove,
        index,
        disabled
      });
    };
    var itemHandleClick = function itemHandleClick2() {
      dispatch({
        type: ItemClick,
        index
      });
    };
    var itemHandleMouseDown = function itemHandleMouseDown2(e2) {
      return e2.preventDefault();
    };
    return _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function(itemNode) {
      if (itemNode) {
        itemRefs.current[elementIds.getItemId(index)] = itemNode;
      }
    }), _extends3.disabled = disabled, _extends3.role = "option", _extends3["aria-selected"] = "" + (index === latestState.highlightedIndex), _extends3.id = elementIds.getItemId(index), _extends3), !disabled && (_ref4 = {}, _ref4[onSelectKey] = callAllEventHandlers(customClickHandler, itemHandleClick), _ref4), {
      onMouseMove: callAllEventHandlers(onMouseMove, itemHandleMouseMove),
      onMouseDown: callAllEventHandlers(onMouseDown, itemHandleMouseDown)
    }, rest);
  }, [dispatch, latest, shouldScrollRef, elementIds]);
  var getToggleButtonProps = (0, import_react44.useCallback)(function(_temp4) {
    var _extends4;
    var _ref5 = _temp4 === void 0 ? {} : _temp4, onClick = _ref5.onClick;
    _ref5.onPress;
    var _ref5$refKey = _ref5.refKey, refKey = _ref5$refKey === void 0 ? "ref" : _ref5$refKey, ref = _ref5.ref, rest = _objectWithoutPropertiesLoose(_ref5, _excluded3);
    var latestState = latest.current.state;
    var toggleButtonHandleClick = function toggleButtonHandleClick2() {
      dispatch({
        type: ToggleButtonClick
      });
    };
    return _extends((_extends4 = {}, _extends4[refKey] = handleRefs(ref, function(toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    }), _extends4["aria-controls"] = elementIds.menuId, _extends4["aria-expanded"] = latestState.isOpen, _extends4.id = elementIds.toggleButtonId, _extends4.tabIndex = -1, _extends4), !rest.disabled && _extends({}, {
      onClick: callAllEventHandlers(onClick, toggleButtonHandleClick)
    }), rest);
  }, [dispatch, latest, elementIds]);
  var getInputProps = (0, import_react44.useCallback)(function(_temp5, _temp6) {
    var _extends5;
    var _ref6 = _temp5 === void 0 ? {} : _temp5, onKeyDown = _ref6.onKeyDown, onChange = _ref6.onChange, onInput = _ref6.onInput, onFocus = _ref6.onFocus, onBlur = _ref6.onBlur;
    _ref6.onChangeText;
    var _ref6$refKey = _ref6.refKey, refKey = _ref6$refKey === void 0 ? "ref" : _ref6$refKey, ref = _ref6.ref, rest = _objectWithoutPropertiesLoose(_ref6, _excluded4);
    var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressRefErro = _ref7.suppressRefError, suppressRefError = _ref7$suppressRefErro === void 0 ? false : _ref7$suppressRefErro;
    setGetterPropCallInfo("getInputProps", suppressRefError, refKey, inputRef);
    var latestState = latest.current.state;
    var inputHandleKeyDown = function inputHandleKeyDown2(event) {
      var key = normalizeArrowKey(event);
      if (key && inputKeyDownHandlers[key]) {
        inputKeyDownHandlers[key](event);
      }
    };
    var inputHandleChange = function inputHandleChange2(event) {
      dispatch({
        type: InputChange,
        inputValue: event.target.value
      });
    };
    var inputHandleBlur = function inputHandleBlur2(event) {
      if (latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown) {
        var isBlurByTabChange = event.relatedTarget === null && environment.document.activeElement !== environment.document.body;
        dispatch({
          type: InputBlur,
          selectItem: !isBlurByTabChange
        });
      }
    };
    var inputHandleFocus = function inputHandleFocus2() {
      if (!latestState.isOpen) {
        dispatch({
          type: InputFocus
        });
      }
    };
    var onChangeKey = "onChange";
    var eventHandlers = {};
    if (!rest.disabled) {
      var _eventHandlers;
      eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, inputHandleBlur), _eventHandlers.onFocus = callAllEventHandlers(onFocus, inputHandleFocus), _eventHandlers);
    }
    return _extends((_extends5 = {}, _extends5[refKey] = handleRefs(ref, function(inputNode) {
      inputRef.current = inputNode;
    }), _extends5["aria-activedescendant"] = latestState.isOpen && latestState.highlightedIndex > -1 ? elementIds.getItemId(latestState.highlightedIndex) : "", _extends5["aria-autocomplete"] = "list", _extends5["aria-controls"] = elementIds.menuId, _extends5["aria-expanded"] = latestState.isOpen, _extends5["aria-labelledby"] = rest && rest["aria-label"] ? void 0 : "" + elementIds.labelId, _extends5.autoComplete = "off", _extends5.id = elementIds.inputId, _extends5.role = "combobox", _extends5.value = latestState.inputValue, _extends5), eventHandlers, rest);
  }, [setGetterPropCallInfo, latest, elementIds, inputKeyDownHandlers, dispatch, mouseAndTouchTrackersRef, environment]);
  var toggleMenu = (0, import_react44.useCallback)(function() {
    dispatch({
      type: FunctionToggleMenu
    });
  }, [dispatch]);
  var closeMenu = (0, import_react44.useCallback)(function() {
    dispatch({
      type: FunctionCloseMenu
    });
  }, [dispatch]);
  var openMenu = (0, import_react44.useCallback)(function() {
    dispatch({
      type: FunctionOpenMenu
    });
  }, [dispatch]);
  var setHighlightedIndex = (0, import_react44.useCallback)(function(newHighlightedIndex) {
    dispatch({
      type: FunctionSetHighlightedIndex,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch]);
  var selectItem = (0, import_react44.useCallback)(function(newSelectedItem) {
    dispatch({
      type: FunctionSelectItem,
      selectedItem: newSelectedItem
    });
  }, [dispatch]);
  var setInputValue = (0, import_react44.useCallback)(function(newInputValue) {
    dispatch({
      type: FunctionSetInputValue,
      inputValue: newInputValue
    });
  }, [dispatch]);
  var reset = (0, import_react44.useCallback)(function() {
    dispatch({
      type: FunctionReset$1
    });
  }, [dispatch]);
  return {
    getItemProps,
    getLabelProps,
    getMenuProps,
    getInputProps,
    getToggleButtonProps,
    toggleMenu,
    openMenu,
    closeMenu,
    setHighlightedIndex,
    setInputValue,
    selectItem,
    reset,
    highlightedIndex,
    isOpen,
    selectedItem,
    inputValue
  };
}
var defaultStateValues = {
  activeIndex: -1,
  selectedItems: []
};
function getInitialValue(props, propKey) {
  return getInitialValue$1(props, propKey, defaultStateValues);
}
function getDefaultValue(props, propKey) {
  return getDefaultValue$1(props, propKey, defaultStateValues);
}
function getInitialState(props) {
  var activeIndex = getInitialValue(props, "activeIndex");
  var selectedItems = getInitialValue(props, "selectedItems");
  return {
    activeIndex,
    selectedItems
  };
}
function isKeyDownOperationPermitted(event) {
  if (event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) {
    return false;
  }
  var element = event.target;
  if (element instanceof HTMLInputElement && element.value !== "" && (element.selectionStart !== 0 || element.selectionEnd !== 0)) {
    return false;
  }
  return true;
}
function getA11yRemovalMessage(selectionParameters) {
  var removedSelectedItem = selectionParameters.removedSelectedItem, itemToStringLocal = selectionParameters.itemToString;
  return itemToStringLocal(removedSelectedItem) + " has been removed.";
}
var propTypes = {
  selectedItems: import_prop_types34.default.array,
  initialSelectedItems: import_prop_types34.default.array,
  defaultSelectedItems: import_prop_types34.default.array,
  itemToString: import_prop_types34.default.func,
  getA11yRemovalMessage: import_prop_types34.default.func,
  stateReducer: import_prop_types34.default.func,
  activeIndex: import_prop_types34.default.number,
  initialActiveIndex: import_prop_types34.default.number,
  defaultActiveIndex: import_prop_types34.default.number,
  onActiveIndexChange: import_prop_types34.default.func,
  onSelectedItemsChange: import_prop_types34.default.func,
  keyNavigationNext: import_prop_types34.default.string,
  keyNavigationPrevious: import_prop_types34.default.string,
  environment: import_prop_types34.default.shape({
    addEventListener: import_prop_types34.default.func,
    removeEventListener: import_prop_types34.default.func,
    document: import_prop_types34.default.shape({
      getElementById: import_prop_types34.default.func,
      activeElement: import_prop_types34.default.any,
      body: import_prop_types34.default.any
    })
  })
};
var defaultProps = {
  itemToString: defaultProps$3.itemToString,
  stateReducer: defaultProps$3.stateReducer,
  environment: defaultProps$3.environment,
  getA11yRemovalMessage,
  keyNavigationNext: "ArrowRight",
  keyNavigationPrevious: "ArrowLeft"
};
var validatePropTypes = noop;
if (process.env.NODE_ENV !== "production") {
  validatePropTypes = function validatePropTypes2(options, caller) {
    import_prop_types34.default.checkPropTypes(propTypes, options, "prop", caller.name);
  };
}
var SelectedItemClick = process.env.NODE_ENV !== "production" ? "__selected_item_click__" : 0;
var SelectedItemKeyDownDelete = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_delete__" : 1;
var SelectedItemKeyDownBackspace = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_backspace__" : 2;
var SelectedItemKeyDownNavigationNext = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_navigation_next__" : 3;
var SelectedItemKeyDownNavigationPrevious = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_navigation_previous__" : 4;
var DropdownKeyDownNavigationPrevious = process.env.NODE_ENV !== "production" ? "__dropdown_keydown_navigation_previous__" : 5;
var DropdownKeyDownBackspace = process.env.NODE_ENV !== "production" ? "__dropdown_keydown_backspace__" : 6;
var DropdownClick = process.env.NODE_ENV !== "production" ? "__dropdown_click__" : 7;
var FunctionAddSelectedItem = process.env.NODE_ENV !== "production" ? "__function_add_selected_item__" : 8;
var FunctionRemoveSelectedItem = process.env.NODE_ENV !== "production" ? "__function_remove_selected_item__" : 9;
var FunctionSetSelectedItems = process.env.NODE_ENV !== "production" ? "__function_set_selected_items__" : 10;
var FunctionSetActiveIndex = process.env.NODE_ENV !== "production" ? "__function_set_active_index__" : 11;
var FunctionReset = process.env.NODE_ENV !== "production" ? "__function_reset__" : 12;
var stateChangeTypes = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  SelectedItemClick,
  SelectedItemKeyDownDelete,
  SelectedItemKeyDownBackspace,
  SelectedItemKeyDownNavigationNext,
  SelectedItemKeyDownNavigationPrevious,
  DropdownKeyDownNavigationPrevious,
  DropdownKeyDownBackspace,
  DropdownClick,
  FunctionAddSelectedItem,
  FunctionRemoveSelectedItem,
  FunctionSetSelectedItems,
  FunctionSetActiveIndex,
  FunctionReset
});
function downshiftMultipleSelectionReducer(state, action) {
  var type = action.type, index = action.index, props = action.props, selectedItem = action.selectedItem;
  var activeIndex = state.activeIndex, selectedItems = state.selectedItems;
  var changes;
  switch (type) {
    case SelectedItemClick:
      changes = {
        activeIndex: index
      };
      break;
    case SelectedItemKeyDownNavigationPrevious:
      changes = {
        activeIndex: activeIndex - 1 < 0 ? 0 : activeIndex - 1
      };
      break;
    case SelectedItemKeyDownNavigationNext:
      changes = {
        activeIndex: activeIndex + 1 >= selectedItems.length ? -1 : activeIndex + 1
      };
      break;
    case SelectedItemKeyDownBackspace:
    case SelectedItemKeyDownDelete: {
      if (activeIndex < 0) {
        break;
      }
      var newActiveIndex = activeIndex;
      if (selectedItems.length === 1) {
        newActiveIndex = -1;
      } else if (activeIndex === selectedItems.length - 1) {
        newActiveIndex = selectedItems.length - 2;
      }
      changes = _extends({
        selectedItems: [].concat(selectedItems.slice(0, activeIndex), selectedItems.slice(activeIndex + 1))
      }, {
        activeIndex: newActiveIndex
      });
      break;
    }
    case DropdownKeyDownNavigationPrevious:
      changes = {
        activeIndex: selectedItems.length - 1
      };
      break;
    case DropdownKeyDownBackspace:
      changes = {
        selectedItems: selectedItems.slice(0, selectedItems.length - 1)
      };
      break;
    case FunctionAddSelectedItem:
      changes = {
        selectedItems: [].concat(selectedItems, [selectedItem])
      };
      break;
    case DropdownClick:
      changes = {
        activeIndex: -1
      };
      break;
    case FunctionRemoveSelectedItem: {
      var _newActiveIndex = activeIndex;
      var selectedItemIndex = selectedItems.indexOf(selectedItem);
      if (selectedItemIndex < 0) {
        break;
      }
      if (selectedItems.length === 1) {
        _newActiveIndex = -1;
      } else if (selectedItemIndex === selectedItems.length - 1) {
        _newActiveIndex = selectedItems.length - 2;
      }
      changes = {
        selectedItems: [].concat(selectedItems.slice(0, selectedItemIndex), selectedItems.slice(selectedItemIndex + 1)),
        activeIndex: _newActiveIndex
      };
      break;
    }
    case FunctionSetSelectedItems: {
      var newSelectedItems = action.selectedItems;
      changes = {
        selectedItems: newSelectedItems
      };
      break;
    }
    case FunctionSetActiveIndex: {
      var _newActiveIndex2 = action.activeIndex;
      changes = {
        activeIndex: _newActiveIndex2
      };
      break;
    }
    case FunctionReset:
      changes = {
        activeIndex: getDefaultValue(props, "activeIndex"),
        selectedItems: getDefaultValue(props, "selectedItems")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return _extends({}, state, changes);
}
var _excluded = ["refKey", "ref", "onClick", "onKeyDown", "selectedItem", "index"];
var _excluded2 = ["refKey", "ref", "onKeyDown", "onClick", "preventKeyAction"];
useMultipleSelection.stateChangeTypes = stateChangeTypes;
function useMultipleSelection(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }
  validatePropTypes(userProps, useMultipleSelection);
  var props = _extends({}, defaultProps, userProps);
  var getA11yRemovalMessage2 = props.getA11yRemovalMessage, itemToString2 = props.itemToString, environment = props.environment, keyNavigationNext = props.keyNavigationNext, keyNavigationPrevious = props.keyNavigationPrevious;
  var _useControlledReducer = useControlledReducer$1(downshiftMultipleSelectionReducer, getInitialState(props), props), state = _useControlledReducer[0], dispatch = _useControlledReducer[1];
  var activeIndex = state.activeIndex, selectedItems = state.selectedItems;
  var isInitialMountRef = (0, import_react44.useRef)(true);
  var dropdownRef = (0, import_react44.useRef)(null);
  var previousSelectedItemsRef = (0, import_react44.useRef)(selectedItems);
  var selectedItemRefs = (0, import_react44.useRef)();
  selectedItemRefs.current = [];
  var latest = useLatestRef({
    state,
    props
  });
  (0, import_react44.useEffect)(function() {
    if (isInitialMountRef.current || false) {
      return;
    }
    if (selectedItems.length < previousSelectedItemsRef.current.length) {
      var removedSelectedItem = previousSelectedItemsRef.current.find(function(item) {
        return selectedItems.indexOf(item) < 0;
      });
      setStatus(getA11yRemovalMessage2({
        itemToString: itemToString2,
        resultCount: selectedItems.length,
        removedSelectedItem,
        activeIndex,
        activeSelectedItem: selectedItems[activeIndex]
      }), environment.document);
    }
    previousSelectedItemsRef.current = selectedItems;
  }, [selectedItems.length]);
  (0, import_react44.useEffect)(function() {
    if (isInitialMountRef.current) {
      return;
    }
    if (activeIndex === -1 && dropdownRef.current) {
      dropdownRef.current.focus();
    } else if (selectedItemRefs.current[activeIndex]) {
      selectedItemRefs.current[activeIndex].focus();
    }
  }, [activeIndex]);
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props,
    state
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker("getDropdownProps");
  (0, import_react44.useEffect)(function() {
    isInitialMountRef.current = false;
    return function() {
      isInitialMountRef.current = true;
    };
  }, []);
  var selectedItemKeyDownHandlers = (0, import_react44.useMemo)(function() {
    var _ref;
    return _ref = {}, _ref[keyNavigationPrevious] = function() {
      dispatch({
        type: SelectedItemKeyDownNavigationPrevious
      });
    }, _ref[keyNavigationNext] = function() {
      dispatch({
        type: SelectedItemKeyDownNavigationNext
      });
    }, _ref.Delete = function Delete() {
      dispatch({
        type: SelectedItemKeyDownDelete
      });
    }, _ref.Backspace = function Backspace() {
      dispatch({
        type: SelectedItemKeyDownBackspace
      });
    }, _ref;
  }, [dispatch, keyNavigationNext, keyNavigationPrevious]);
  var dropdownKeyDownHandlers = (0, import_react44.useMemo)(function() {
    var _ref2;
    return _ref2 = {}, _ref2[keyNavigationPrevious] = function(event) {
      if (isKeyDownOperationPermitted(event)) {
        dispatch({
          type: DropdownKeyDownNavigationPrevious
        });
      }
    }, _ref2.Backspace = function Backspace(event) {
      if (isKeyDownOperationPermitted(event)) {
        dispatch({
          type: DropdownKeyDownBackspace
        });
      }
    }, _ref2;
  }, [dispatch, keyNavigationPrevious]);
  var getSelectedItemProps = (0, import_react44.useCallback)(function(_temp) {
    var _extends2;
    var _ref3 = _temp === void 0 ? {} : _temp, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, ref = _ref3.ref, onClick = _ref3.onClick, onKeyDown = _ref3.onKeyDown, selectedItemProp = _ref3.selectedItem, indexProp = _ref3.index, rest = _objectWithoutPropertiesLoose(_ref3, _excluded);
    var latestState = latest.current.state;
    var _getItemAndIndex = getItemAndIndex(selectedItemProp, indexProp, latestState.selectedItems, "Pass either item or index to getSelectedItemProps!"), index = _getItemAndIndex[1];
    var isFocusable = index > -1 && index === latestState.activeIndex;
    var selectedItemHandleClick = function selectedItemHandleClick2() {
      dispatch({
        type: SelectedItemClick,
        index
      });
    };
    var selectedItemHandleKeyDown = function selectedItemHandleKeyDown2(event) {
      var key = normalizeArrowKey(event);
      if (key && selectedItemKeyDownHandlers[key]) {
        selectedItemKeyDownHandlers[key](event);
      }
    };
    return _extends((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function(selectedItemNode) {
      if (selectedItemNode) {
        selectedItemRefs.current.push(selectedItemNode);
      }
    }), _extends2.tabIndex = isFocusable ? 0 : -1, _extends2.onClick = callAllEventHandlers(onClick, selectedItemHandleClick), _extends2.onKeyDown = callAllEventHandlers(onKeyDown, selectedItemHandleKeyDown), _extends2), rest);
  }, [dispatch, latest, selectedItemKeyDownHandlers]);
  var getDropdownProps = (0, import_react44.useCallback)(function(_temp2, _temp3) {
    var _extends3;
    var _ref4 = _temp2 === void 0 ? {} : _temp2, _ref4$refKey = _ref4.refKey, refKey = _ref4$refKey === void 0 ? "ref" : _ref4$refKey, ref = _ref4.ref, onKeyDown = _ref4.onKeyDown, onClick = _ref4.onClick, _ref4$preventKeyActio = _ref4.preventKeyAction, preventKeyAction = _ref4$preventKeyActio === void 0 ? false : _ref4$preventKeyActio, rest = _objectWithoutPropertiesLoose(_ref4, _excluded2);
    var _ref5 = _temp3 === void 0 ? {} : _temp3, _ref5$suppressRefErro = _ref5.suppressRefError, suppressRefError = _ref5$suppressRefErro === void 0 ? false : _ref5$suppressRefErro;
    setGetterPropCallInfo("getDropdownProps", suppressRefError, refKey, dropdownRef);
    var dropdownHandleKeyDown = function dropdownHandleKeyDown2(event) {
      var key = normalizeArrowKey(event);
      if (key && dropdownKeyDownHandlers[key]) {
        dropdownKeyDownHandlers[key](event);
      }
    };
    var dropdownHandleClick = function dropdownHandleClick2() {
      dispatch({
        type: DropdownClick
      });
    };
    return _extends((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function(dropdownNode) {
      if (dropdownNode) {
        dropdownRef.current = dropdownNode;
      }
    }), _extends3), !preventKeyAction && {
      onKeyDown: callAllEventHandlers(onKeyDown, dropdownHandleKeyDown),
      onClick: callAllEventHandlers(onClick, dropdownHandleClick)
    }, rest);
  }, [dispatch, dropdownKeyDownHandlers, setGetterPropCallInfo]);
  var addSelectedItem = (0, import_react44.useCallback)(function(selectedItem) {
    dispatch({
      type: FunctionAddSelectedItem,
      selectedItem
    });
  }, [dispatch]);
  var removeSelectedItem = (0, import_react44.useCallback)(function(selectedItem) {
    dispatch({
      type: FunctionRemoveSelectedItem,
      selectedItem
    });
  }, [dispatch]);
  var setSelectedItems = (0, import_react44.useCallback)(function(newSelectedItems) {
    dispatch({
      type: FunctionSetSelectedItems,
      selectedItems: newSelectedItems
    });
  }, [dispatch]);
  var setActiveIndex = (0, import_react44.useCallback)(function(newActiveIndex) {
    dispatch({
      type: FunctionSetActiveIndex,
      activeIndex: newActiveIndex
    });
  }, [dispatch]);
  var reset = (0, import_react44.useCallback)(function() {
    dispatch({
      type: FunctionReset
    });
  }, [dispatch]);
  return {
    getSelectedItemProps,
    getDropdownProps,
    addSelectedItem,
    removeSelectedItem,
    setSelectedItems,
    setActiveIndex,
    reset,
    selectedItems,
    activeIndex
  };
}

// src/ThreeDotsLoader.js
var import_react45 = __toESM(require("react"));
var import_prop_types35 = __toESM(require("prop-types"));
var import_styled_components48 = __toESM(require("styled-components"));
var ThreeDotsLoader = ({ className }) => {
  return /* @__PURE__ */ import_react45.default.createElement("div", {
    className: `${className}`
  }, /* @__PURE__ */ import_react45.default.createElement("div", {
    className: "dot-loader"
  }, /* @__PURE__ */ import_react45.default.createElement("div", {
    className: "bounce1"
  }), /* @__PURE__ */ import_react45.default.createElement("div", {
    className: "bounce2"
  }), /* @__PURE__ */ import_react45.default.createElement("div", {
    className: "bounce3"
  })));
};
ThreeDotsLoader.propTypes = {
  className: import_prop_types35.default.string
};
var ThreeDotsLoader_default = (0, import_styled_components48.default)(ThreeDotsLoader)`
  .dot-loader {
    width: 100%;
    text-align: center;
  }

  .dot-loader > div {
    width: 10px;
    height: 10px;
    background-color: ${(props) => props.dotColor || "#fff"};

    border-radius: 100%;
    display: inline-block;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .dot-loader .bounce1 {
    animation-delay: -0.32s;
  }

  .dot-loader .bounce2 {
    animation-delay: -0.16s;
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
`;

// src/DataList.js
function escapeRegExp(string = "") {
  return string.replace(/[$()*+.?[\\\]^{|}-]/g, "\\$&");
}
var Wrapper20 = import_styled_components49.default.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
var OptionList = import_styled_components49.default.ul`
  position: absolute;
  background-color: var(--dropdown-bg);
  border-color: var(--dropdown-inactive);
  border-radius: 6px;
  box-shadow: var(--dropdown-menu-shadow);
  cursor: pointer;
  list-style-type: none;
  max-height: ${maxMenuHeight}px;
  overflow-y: auto;
  padding: 8px;
  z-index: var(--z-index-300);
  margin-top: 8px;
`;
var Option2 = import_styled_components49.default.li`
  border-radius: 6px;
  color: var(--dropdown-text);
  padding: 8px;
  user-select: none;

  ${(props) => props.$isFocused && import_styled_components49.css`
      background-color: var(--dropdown-option-bg);
      color: var(--dropdown-active);
    `},
`;
var Mark = import_styled_components49.default.mark`
  font-weight: var(--bold);
  color: var(--dropdown-text);
  background-color: unset;
`;
var Heading2 = import_styled_components49.default.div`
  color: var(--dark-resting);
  font-size: var(--xx-small);
  font-weight: var(--normal);
  padding: 4px 8px;
  text-transform: uppercase;
  user-select: none;
`;
var getPattern = (value) => new RegExp(`(${escapeRegExp(String(value))})`, "i");
var DEFAULT_SUGGESTIONS = [];
function DataList({
  value = "",
  suggestions = DEFAULT_SUGGESTIONS,
  loading = false,
  onSelectedItemChange,
  ...unhandledProps
}) {
  var _a, _b;
  const [matches, setMatches] = (0, import_react46.useState)(suggestions);
  const handleInputValueChange = (0, import_react46.useCallback)(
    ({ inputValue: inputValue2 }) => {
      const pattern2 = getPattern(inputValue2 ? String(inputValue2) : "");
      setMatches([
        ...new Set(suggestions.filter((suggestion) => pattern2.test(suggestion)))
      ]);
    },
    [suggestions]
  );
  const {
    getInputProps,
    getItemProps,
    getMenuProps,
    highlightedIndex,
    inputValue,
    isOpen,
    openMenu
  } = useCombobox({
    items: matches,
    initialInputValue: value,
    onInputValueChange: handleInputValueChange,
    onSelectedItemChange
  });
  (0, import_react46.useEffect)(() => {
    handleInputValueChange({ inputValue });
  }, [handleInputValueChange, inputValue, suggestions]);
  const [refs, position] = usePosition({ placement: "left", visible: isOpen });
  const targetInputWidth = ((_b = (_a = refs.target) == null ? void 0 : _a.current) == null ? void 0 : _b.offsetWidth) || 0;
  const pattern = getPattern(inputValue);
  const [firstSuggestion] = suggestions;
  const hasMatches = matches.length > 0;
  const showMenu = isOpen && (hasMatches || loading);
  const handleFocus = () => {
    if (!isOpen) {
      openMenu();
    }
  };
  return /* @__PURE__ */ import_react46.default.createElement(Wrapper20, null, /* @__PURE__ */ import_react46.default.createElement(Input_default, {
    type: "text",
    ...getInputProps({
      placeholder: firstSuggestion && `e.g. ${firstSuggestion}`,
      onFocus: handleFocus,
      ref: refs.target,
      ...unhandledProps
    })
  }), /* @__PURE__ */ import_react46.default.createElement(Portal_default, null, /* @__PURE__ */ import_react46.default.createElement(OptionList, {
    ...getMenuProps({
      ref: refs.attachment,
      style: showMenu ? {
        top: position.top,
        left: position.left,
        width: targetInputWidth,
        position: "fixed"
      } : { display: "none" }
    })
  }, hasMatches && /* @__PURE__ */ import_react46.default.createElement(import_react46.default.Fragment, null, /* @__PURE__ */ import_react46.default.createElement(Heading2, {
    role: "heading"
  }, "Example values"), matches.map((match, index) => /* @__PURE__ */ import_react46.default.createElement(Option2, {
    $isFocused: highlightedIndex === index,
    key: match,
    ...getItemProps({ item: match, index })
  }, match.split(pattern).map(
    (part, partialIndex) => inputValue && pattern.test(part) ? /* @__PURE__ */ import_react46.default.createElement(Mark, {
      key: partialIndex
    }, part) : part
  )))), loading && /* @__PURE__ */ import_react46.default.createElement(ThreeDotsLoader_default, {
    dotColor: "#5C5CFF"
  }))));
}
DataList.propTypes = {
  value: import_prop_types36.default.string,
  suggestions: import_prop_types36.default.arrayOf(import_prop_types36.default.string),
  loading: import_prop_types36.default.bool,
  onSelectedItemChange: import_prop_types36.default.func
};
var DataList_default = (0, import_styled_components49.default)(DataList)``;

// src/Form.js
var import_styled_components50 = __toESM(require("styled-components"));
var Form_default = import_styled_components50.default.form`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${Label_default} {
    position: relative;

    ${ErrorMsg} {
      position: absolute;
      bottom: -21px;
    }
  }

  ${Select} {
    max-width: 100%;
  }

  ${ButtonGroup} {
    margin-top: 8px;
  }
`;

// src/Popover.js
var import_react_popover = require("@radix-ui/react-popover");
var import_styled_components51 = __toESM(require("styled-components"));
var PopoverContent = (0, import_styled_components51.default)(import_react_popover.Content)`
  border-radius: 6px;
  padding: 24px;
  width: ${({ size }) => {
  switch (size) {
    case "large":
      return "508px";
    case "medium":
      return "340px";
    case "regular":
    default:
      return "304px";
  }
}};
  background-color: var(--white);
  box-shadow: var(--level-3);
  margin-top: 16px;
  outline: none;

  ${H2} {
    margin-bottom: 16px;
  }
`;
var PopoverTrigger = (0, import_styled_components51.default)(import_react_popover.Trigger)``;
var Popover = (0, import_styled_components51.default)(import_react_popover.Root)`
  border: solid 1px red;
  width: 100px;
  height: 100px;
`;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Banner,
  BannerGroup,
  Button,
  ButtonGroup,
  ButtonLink,
  Caption,
  Card,
  CardContent,
  Carousel,
  Checkbox,
  CheckboxGroup,
  CheckboxSelect,
  ContentStatus,
  Creatable,
  DataList,
  DateInput,
  DateRangeDropdown,
  DateRangeInputs,
  DateRangePicker,
  Definition,
  Description,
  DescriptiveList,
  Dropdown,
  EmptyState,
  ErrorMsg,
  ErrorProgress,
  ExpandableText,
  ExternalLink,
  FULL_RANGE_OPTIONS,
  Form,
  Fullscreen,
  H1,
  H2,
  H3,
  H4,
  H5,
  Heading,
  HorizontalScroll,
  Icon,
  IconButton,
  IconWithinCButton,
  ImageSkeleton,
  Input,
  InputClickToCopy,
  Item,
  LIMITED_RANGE_OPTIONS,
  Label,
  Link,
  List,
  ListRow,
  ListRowContent,
  Logo,
  Menu,
  MenuCheckboxItem,
  MenuContent,
  MenuHeading,
  MenuItem,
  MenuList,
  MenuPortalOverride,
  MenuSection,
  MenuSeparator,
  MenuTrigger,
  Modal,
  ModalFooter,
  MoreMenu,
  NegativeBanner,
  NegativeNotice,
  Notice,
  OptionLabel,
  OptionWrapper,
  Overflow,
  Page,
  PageActions,
  PageBody,
  PageDescription,
  PageHeader,
  PageReturn,
  PageSubheader,
  PageTitle,
  Panel,
  PanelActions,
  PanelBody,
  PanelFooter,
  PanelHeader,
  PanelSection,
  PanelSectionTitle,
  PanelTitle,
  Paragraph,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Portal,
  PrintButton,
  Progress,
  RANGE_OPTIONS,
  Radio,
  RadioControl,
  RadioGroup,
  RadioLabel,
  SearchInput,
  Select,
  Skeleton,
  SortDropdown,
  Spinner,
  SplitButton,
  SquareButton,
  StarCheckbox,
  StatusLabel,
  SuccessMsg,
  SuccessNotice,
  SuccessProgress,
  Switch,
  TabItem,
  Table,
  TabsList,
  TabsNav,
  Tbody,
  Td,
  Term,
  Text,
  TextArea,
  TextClickToCopy,
  Th,
  Thead,
  Toast,
  Tooltip,
  Tr,
  TrialProgressBar,
  UILink,
  WarningMsg,
  WarningNotice,
  add,
  calculateDatesFor,
  calendar,
  diff,
  easing,
  endOf,
  format,
  fromNow,
  getEndOfToday,
  getRecommendedFrequency,
  isAfter,
  isBefore,
  normalizeDates,
  parse,
  startOf,
  subtract,
  useDateRange,
  useToggle,
  utc
});
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
//# sourceMappingURL=index.js.map